import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AcceptanceStates: { [key: string]: AcceptanceState };
  Date: number;
  FormScores: { [key: string]: number };
  Object: object;
};

export enum AcceptanceState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type AccessTokenResponse = {
  __typename?: 'AccessTokenResponse';
  accessToken: Scalars['String'];
};

export type ActionSummaries = {
  __typename?: 'ActionSummaries';
  activities?: Maybe<ActionSummary>;
  journals?: Maybe<ActionSummary>;
  moodResponses?: Maybe<ActionSummary>;
  surveyResponses?: Maybe<ActionSummary>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ActionSummariesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};

export type ActionSummary = {
  __typename?: 'ActionSummary';
  count?: Maybe<Scalars['Int']>;
  countsByDay?: Maybe<Array<Maybe<CountByDay>>>;
};

export type ActivitiesState = {
  __typename?: 'ActivitiesState';
  completeTime?: Maybe<Scalars['Date']>;
  slug?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Date']>;
  state?: Maybe<UserActivityState>;
};

export type Activity = {
  __typename?: 'Activity';
  route?: Maybe<Routes>;
  session?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<ActivityState>;
};

export type ActivityMetaData = {
  __typename?: 'ActivityMetaData';
  link?: Maybe<Scalars['String']>;
  narratorAvatar?: Maybe<Scalars['String']>;
  narratorBio?: Maybe<Scalars['String']>;
  narratorName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  translation?: Maybe<ActivityTranslation>;
};

export type ActivityResponse = {
  __typename?: 'ActivityResponse';
  activityData?: Maybe<Scalars['String']>;
  activitySlug: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
  user: User;
};

export type ActivityResponseFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type ActivityTranslation = {
  __typename?: 'ActivityTranslation';
  ar?: Maybe<ActivityTranslationItem>;
  en?: Maybe<ActivityTranslationItem>;
  uk?: Maybe<ActivityTranslationItem>;
};

export type ActivityTranslationItem = {
  __typename?: 'ActivityTranslationItem';
  narratorBio?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
};

export enum ActivityTypes {
  AllForOneAndNoneForAll = 'ALL_FOR_ONE_AND_NONE_FOR_ALL',
  BoostYourSelfCompassion = 'BOOST_YOUR_SELF_COMPASSION',
  CherishPastHappyMoments = 'CHERISH_PAST_HAPPY_MOMENTS',
  DontStressTheStress = 'DONT_STRESS_THE_STRESS',
  FeelLessAccountableForNegativeOutcomes = 'FEEL_LESS_ACCOUNTABLE_FOR_NEGATIVE_OUTCOMES',
  FocusOnWhatMakesYouHappy = 'FOCUS_ON_WHAT_MAKES_YOU_HAPPY',
  FortuneTelling = 'FORTUNE_TELLING',
  LookPerspective = 'LOOK_PERSPECTIVE',
  MindReading = 'MIND_READING',
  NegativeVsPositive = 'NEGATIVE_VS_POSITIVE',
  RemindYourselfOfYourStrength = 'REMIND_YOURSELF_OF_YOUR_STRENGTH',
  SeeYourselfInAPositiveWay = 'SEE_YOURSELF_IN_A_POSITIVE_WAY',
  SlowDownYourOverthinking = 'SLOW_DOWN_YOUR_OVERTHINKING',
  SpottingStress = 'SPOTTING_STRESS',
  StopFocusingOnTheNegative = 'STOP_FOCUSING_ON_THE_NEGATIVE',
  TheBenefitsOfEmotionalRegulation = 'THE_BENEFITS_OF_EMOTIONAL_REGULATION',
  TheCrystalBallExperiment = 'THE_CRYSTAL_BALL_EXPERIMENT',
  TheSelfFulfillingProphecy = 'THE_SELF_FULFILLING_PROPHECY',
  TodayWillBeDifferent = 'TODAY_WILL_BE_DIFFERENT',
  WhyIsItImportantToIdentifyStressfulThoughts = 'WHY_IS_IT_IMPORTANT_TO_IDENTIFY_STRESSFUL_THOUGHTS'
}

export type Addendum = {
  __typename?: 'Addendum';
  signature: Signature;
  text: Scalars['String'];
};

export enum AgeRanges {
  From_18To_24 = 'FROM_18_TO_24',
  From_24To_30 = 'FROM_24_TO_30',
  From_30To_45 = 'FROM_30_TO_45',
  From_45To_60 = 'FROM_45_TO_60',
  From_60 = 'FROM_60',
  To_18 = 'TO_18'
}

export type AggregateDailyStepData = {
  __typename?: 'AggregateDailyStepData';
  date?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AggregateMoodByDayFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  sort?: InputMaybe<Sort>;
};

export type AggregateSession = {
  __typename?: 'AggregateSession';
  hasUnconfirmedSessions?: Maybe<Scalars['Boolean']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type AggregateSessionsByMonthFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  sort?: InputMaybe<Sort>;
};

export type AggregateStepFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};

export type Answer = {
  __typename?: 'Answer';
  option?: Maybe<Option>;
  options?: Maybe<Array<Maybe<Option>>>;
  question: Question;
};

export type AnswerInput = {
  optionSlug?: InputMaybe<Scalars['String']>;
  optionSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionSlug: Scalars['String'];
};

export type AnswerScores = {
  __typename?: 'AnswerScores';
  anxiety?: Maybe<AnxietyScores>;
  depression?: Maybe<DepressionScores>;
  stress?: Maybe<StressScores>;
};

export type AnxietyScores = {
  __typename?: 'AnxietyScores';
  level?: Maybe<Levels>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

export type AppTool = {
  __typename?: 'AppTool';
  completed: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type AppToolInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};

export type AppUsage = {
  __typename?: 'AppUsage';
  action: EventType;
  activitySlug?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  journalType?: Maybe<JournalTypes>;
  surveyType?: Maybe<SurveyTypes>;
};

export type AppUsageFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type AvatarUploadUrl = {
  __typename?: 'AvatarUploadUrl';
  url?: Maybe<Scalars['String']>;
};

export type BillableCptCode = {
  __typename?: 'BillableCptCode';
  cptCode: Scalars['String'];
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  estimatedAmount: Scalars['Float'];
  id: Scalars['ID'];
  isBilled: Scalars['Boolean'];
  organization: Organization;
  patient: User;
  updatedAt: Scalars['Date'];
};

export enum BillingType {
  Insurance = 'INSURANCE',
  SelfPay = 'SELF_PAY'
}

export type Buddy = {
  __typename?: 'Buddy';
  avatarUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  moodOfToday?: Maybe<Scalars['Int']>;
  sharedData?: Maybe<Array<Maybe<SharedData>>>;
};

export type BuddyInvitation = {
  __typename?: 'BuddyInvitation';
  code: Scalars['String'];
  id: Scalars['String'];
  user: User;
};

export type BuddyMoodResponse = {
  __typename?: 'BuddyMoodResponse';
  date: Scalars['Date'];
  emotions?: Maybe<Array<Maybe<Emotion>>>;
  id: Scalars['String'];
  selectedMood?: Maybe<Scalars['Int']>;
};

export type BuddyStandardMessage = {
  __typename?: 'BuddyStandardMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
  slug: Scalars['String'];
  translation?: Maybe<BuddyStandardMessageTranslation>;
};

export type BuddyStandardMessageTranslation = {
  __typename?: 'BuddyStandardMessageTranslation';
  en?: Maybe<BuddyStandardMessageTranslationItem>;
  uk?: Maybe<BuddyStandardMessageTranslationItem>;
};

export type BuddyStandardMessageTranslationItem = {
  __typename?: 'BuddyStandardMessageTranslationItem';
  message?: Maybe<Scalars['String']>;
};

export type CccResponse = {
  __typename?: 'CCCResponse';
  challengeEndDate?: Maybe<Scalars['Date']>;
  challengeStartDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  finalMood?: Maybe<Scalars['Int']>;
  finalThoughts?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialMood?: Maybe<Scalars['Int']>;
  initialThoughts?: Maybe<Scalars['String']>;
  initialThoughtsContradiction?: Maybe<Scalars['String']>;
  initialThoughtsSupport?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  user: User;
};

export type CccResponseFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type CmsForm = {
  __typename?: 'CMSForm';
  createdAt: Scalars['Date'];
  data: CmsFormData;
  id: Scalars['ID'];
  organization: Organization;
  patient: User;
  sessions?: Maybe<Array<Maybe<Session>>>;
  state: CmsFormState;
  updatedAt: Scalars['Date'];
};

export type CmsFormData = {
  __typename?: 'CMSFormData';
  additionalClaimInformation?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['Float']>;
  assignmentAccepted?: Maybe<Scalars['Boolean']>;
  authorizationNumber?: Maybe<Scalars['String']>;
  autoAccidentState?: Maybe<Scalars['String']>;
  claimCodes?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  currentIllnessId?: Maybe<Scalars['String']>;
  dateOfCurrentIllness?: Maybe<Scalars['Date']>;
  diagnoses?: Maybe<Array<Maybe<Scalars['String']>>>;
  facilityAddress1?: Maybe<Scalars['String']>;
  facilityAddress2?: Maybe<Scalars['String']>;
  facilityCity?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityNpi?: Maybe<Scalars['String']>;
  facilityState?: Maybe<Scalars['String']>;
  facilityZipCode?: Maybe<Scalars['String']>;
  hospitalizationDateFrom?: Maybe<Scalars['Date']>;
  hospitalizationDateTo?: Maybe<Scalars['Date']>;
  icdInd?: Maybe<Scalars['String']>;
  insuranceAddress1?: Maybe<Scalars['String']>;
  insuranceAddress2?: Maybe<Scalars['String']>;
  insuranceCity?: Maybe<Scalars['String']>;
  insuranceMemberId?: Maybe<Scalars['String']>;
  insuranceName?: Maybe<Scalars['String']>;
  insuranceState?: Maybe<Scalars['String']>;
  insuranceType?: Maybe<CmsFormInsuranceType>;
  insuranceZipCode?: Maybe<Scalars['String']>;
  insuredAddress?: Maybe<Scalars['String']>;
  insuredCity?: Maybe<Scalars['String']>;
  insuredDateOfBirth?: Maybe<Scalars['Date']>;
  insuredGender?: Maybe<Genders>;
  insuredInsuranceName?: Maybe<Scalars['String']>;
  insuredName?: Maybe<Scalars['String']>;
  insuredPhoneNumber?: Maybe<Scalars['String']>;
  insuredPolicyGroup?: Maybe<Scalars['String']>;
  insuredState?: Maybe<Scalars['String']>;
  insuredZipCode?: Maybe<Scalars['String']>;
  isAutoAccident?: Maybe<Scalars['Boolean']>;
  isEmploymentRelated?: Maybe<Scalars['Boolean']>;
  isOtherAccident?: Maybe<Scalars['Boolean']>;
  isOtherInsuranceAvailable?: Maybe<Scalars['Boolean']>;
  isOutsideLab?: Maybe<Scalars['Boolean']>;
  isWithInsuredSignatureOnFile?: Maybe<Scalars['Boolean']>;
  originalRefNum?: Maybe<Scalars['String']>;
  otherDate?: Maybe<Scalars['Date']>;
  otherInsuredInsuranceName?: Maybe<Scalars['String']>;
  otherInsuredMemberId?: Maybe<Scalars['String']>;
  otherInsuredName?: Maybe<Scalars['String']>;
  outsideLabCharges?: Maybe<Scalars['Float']>;
  patientAccountNumber?: Maybe<Scalars['String']>;
  patientAddress?: Maybe<Scalars['String']>;
  patientCity?: Maybe<Scalars['String']>;
  patientDateOfBirth?: Maybe<Scalars['Date']>;
  patientGender?: Maybe<Genders>;
  patientName?: Maybe<Scalars['String']>;
  patientPhoneNumber?: Maybe<Scalars['String']>;
  patientRelationToInsured?: Maybe<RelationToInsured>;
  patientState?: Maybe<Scalars['String']>;
  patientZipCode?: Maybe<Scalars['String']>;
  providerAddress1?: Maybe<Scalars['String']>;
  providerAddress2?: Maybe<Scalars['String']>;
  providerCity?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  providerNpi?: Maybe<Scalars['String']>;
  providerPhoneNumber?: Maybe<Scalars['String']>;
  providerState?: Maybe<Scalars['String']>;
  providerTaxonomyCode?: Maybe<Scalars['String']>;
  providerZipCode?: Maybe<Scalars['String']>;
  referringProviderId?: Maybe<Scalars['String']>;
  referringProviderName?: Maybe<Scalars['String']>;
  referringProviderNpi?: Maybe<Scalars['String']>;
  referringProviderSecondaryId?: Maybe<Scalars['String']>;
  referringProviderSecondaryIdType?: Maybe<Scalars['String']>;
  resubmissionCode?: Maybe<Scalars['Int']>;
  services?: Maybe<Array<Maybe<CmsFormService>>>;
  signatureDate?: Maybe<Scalars['Date']>;
  taxFederationId?: Maybe<Scalars['String']>;
  taxFederationIdType?: Maybe<TaxFederationIdType>;
  unableToWorkDateFrom?: Maybe<Scalars['Date']>;
  unableToWorkDateTo?: Maybe<Scalars['Date']>;
};

export type CmsFormDataInput = {
  additionalClaimInformation?: InputMaybe<Scalars['String']>;
  amountPaid?: InputMaybe<Scalars['Float']>;
  assignmentAccepted?: InputMaybe<Scalars['Boolean']>;
  authorizationNumber?: InputMaybe<Scalars['String']>;
  autoAccidentState?: InputMaybe<Scalars['String']>;
  claimCodes?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currentIllnessId?: InputMaybe<Scalars['String']>;
  dateOfCurrentIllness?: InputMaybe<Scalars['Date']>;
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facilityAddress1?: InputMaybe<Scalars['String']>;
  facilityAddress2?: InputMaybe<Scalars['String']>;
  facilityCity?: InputMaybe<Scalars['String']>;
  facilityName?: InputMaybe<Scalars['String']>;
  facilityNpi?: InputMaybe<Scalars['String']>;
  facilityState?: InputMaybe<Scalars['String']>;
  facilityZipCode?: InputMaybe<Scalars['String']>;
  hospitalizationDateFrom?: InputMaybe<Scalars['Date']>;
  hospitalizationDateTo?: InputMaybe<Scalars['Date']>;
  icdInd?: InputMaybe<Scalars['String']>;
  insuranceAddress1?: InputMaybe<Scalars['String']>;
  insuranceAddress2?: InputMaybe<Scalars['String']>;
  insuranceCity?: InputMaybe<Scalars['String']>;
  insuranceMemberId?: InputMaybe<Scalars['String']>;
  insuranceName?: InputMaybe<Scalars['String']>;
  insuranceState?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<CmsFormInsuranceType>;
  insuranceZipCode?: InputMaybe<Scalars['String']>;
  insuredAddress?: InputMaybe<Scalars['String']>;
  insuredCity?: InputMaybe<Scalars['String']>;
  insuredDateOfBirth?: InputMaybe<Scalars['Date']>;
  insuredGender?: InputMaybe<Genders>;
  insuredInsuranceName?: InputMaybe<Scalars['String']>;
  insuredName?: InputMaybe<Scalars['String']>;
  insuredPhoneNumber?: InputMaybe<Scalars['String']>;
  insuredPolicyGroup?: InputMaybe<Scalars['String']>;
  insuredState?: InputMaybe<Scalars['String']>;
  insuredZipCode?: InputMaybe<Scalars['String']>;
  isAutoAccident?: InputMaybe<Scalars['Boolean']>;
  isEmploymentRelated?: InputMaybe<Scalars['Boolean']>;
  isOtherAccident?: InputMaybe<Scalars['Boolean']>;
  isOtherInsuranceAvailable?: InputMaybe<Scalars['Boolean']>;
  isOutsideLab?: InputMaybe<Scalars['Boolean']>;
  isWithInsuredSignatureOnFile?: InputMaybe<Scalars['Boolean']>;
  originalRefNum?: InputMaybe<Scalars['String']>;
  otherDate?: InputMaybe<Scalars['Date']>;
  otherInsuredInsuranceName?: InputMaybe<Scalars['String']>;
  otherInsuredMemberId?: InputMaybe<Scalars['String']>;
  otherInsuredName?: InputMaybe<Scalars['String']>;
  outsideLabCharges?: InputMaybe<Scalars['Float']>;
  patientAccountNumber?: InputMaybe<Scalars['String']>;
  patientAddress?: InputMaybe<Scalars['String']>;
  patientCity?: InputMaybe<Scalars['String']>;
  patientDateOfBirth?: InputMaybe<Scalars['Date']>;
  patientGender?: InputMaybe<Genders>;
  patientName?: InputMaybe<Scalars['String']>;
  patientPhoneNumber?: InputMaybe<Scalars['String']>;
  patientRelationToInsured?: InputMaybe<RelationToInsured>;
  patientState?: InputMaybe<Scalars['String']>;
  patientZipCode?: InputMaybe<Scalars['String']>;
  providerAddress1?: InputMaybe<Scalars['String']>;
  providerAddress2?: InputMaybe<Scalars['String']>;
  providerCity?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Scalars['String']>;
  providerNpi?: InputMaybe<Scalars['String']>;
  providerPhoneNumber?: InputMaybe<Scalars['String']>;
  providerState?: InputMaybe<Scalars['String']>;
  providerTaxonomyCode?: InputMaybe<Scalars['String']>;
  providerZipCode?: InputMaybe<Scalars['String']>;
  referringProviderId?: InputMaybe<Scalars['String']>;
  referringProviderName?: InputMaybe<Scalars['String']>;
  referringProviderNpi?: InputMaybe<Scalars['String']>;
  referringProviderSecondaryId?: InputMaybe<Scalars['String']>;
  referringProviderSecondaryIdType?: InputMaybe<Scalars['String']>;
  resubmissionCode?: InputMaybe<Scalars['Int']>;
  services?: InputMaybe<Array<InputMaybe<CmsFormServiceInput>>>;
  signatureDate?: InputMaybe<Scalars['Date']>;
  taxFederationId?: InputMaybe<Scalars['String']>;
  taxFederationIdType?: InputMaybe<TaxFederationIdType>;
  unableToWorkDateFrom?: InputMaybe<Scalars['Date']>;
  unableToWorkDateTo?: InputMaybe<Scalars['Date']>;
};

export type CmsFormHistory = {
  __typename?: 'CMSFormHistory';
  cmsFormId: Scalars['ID'];
  createdAt: Scalars['Date'];
  data: CmsFormData;
  id: Scalars['ID'];
  state: CmsFormState;
  updatedAt: Scalars['Date'];
};

export type CmsFormHistoryFilter = {
  sort?: InputMaybe<Sort>;
};

export enum CmsFormInsuranceType {
  Champva = 'CHAMPVA',
  FecaBlklung = 'FECA_BLKLUNG',
  GroupHealthPlan = 'GROUP_HEALTH_PLAN',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  Other = 'OTHER',
  Tricare = 'TRICARE'
}

export type CmsFormService = {
  __typename?: 'CMSFormService';
  charges?: Maybe<Scalars['Float']>;
  cptCode?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  diagnosis?: Maybe<Scalars['String']>;
  epsdt?: Maybe<Scalars['String']>;
  isEmergency?: Maybe<Scalars['Boolean']>;
  modifier1?: Maybe<Scalars['String']>;
  modifier2?: Maybe<Scalars['String']>;
  modifier3?: Maybe<Scalars['String']>;
  modifier4?: Maybe<Scalars['String']>;
  placeOfService?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['String']>;
};

export type CmsFormServiceInput = {
  charges?: InputMaybe<Scalars['Float']>;
  cptCode?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  epsdt?: InputMaybe<Scalars['String']>;
  isEmergency?: InputMaybe<Scalars['Boolean']>;
  modifier1?: InputMaybe<Scalars['String']>;
  modifier2?: InputMaybe<Scalars['String']>;
  modifier3?: InputMaybe<Scalars['String']>;
  modifier4?: InputMaybe<Scalars['String']>;
  placeOfService?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

export enum CmsFormState {
  Draft = 'DRAFT',
  OnHold = 'ON_HOLD',
  Ready = 'READY',
  Submitted = 'SUBMITTED'
}

export type ChatLog = {
  __typename?: 'ChatLog';
  createdAt: Scalars['Date'];
  guestId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messages: Array<Maybe<ChatLogMessage>>;
  organization?: Maybe<Organization>;
  template?: Maybe<Template>;
  updatedAt: Scalars['Date'];
};

export type ChatLogMessage = {
  __typename?: 'ChatLogMessage';
  content: Scalars['String'];
  role: Scalars['String'];
};

export type ChatLogMessageContent = {
  __typename?: 'ChatLogMessageContent';
  content?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type CompletedTask = {
  __typename?: 'CompletedTask';
  completedDate?: Maybe<Scalars['Date']>;
  taskId: Scalars['ID'];
};

export type CountByDay = {
  __typename?: 'CountByDay';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export type Country = {
  __typename?: 'Country';
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
};

export type CrisisContact = {
  __typename?: 'CrisisContact';
  category?: Maybe<Array<Maybe<Scalars['String']>>>;
  countryCode: Scalars['String'];
  description: Scalars['String'];
  email?: Maybe<CrisisContactMethod>;
  id: Scalars['String'];
  slug: Scalars['String'];
  sms?: Maybe<CrisisContactMethod>;
  tel?: Maybe<CrisisContactMethod>;
  title: Scalars['String'];
  website?: Maybe<CrisisContactMethod>;
};

export type CrisisContactFilter = {
  countryCode?: InputMaybe<Scalars['String']>;
};

export type CrisisContactMethod = {
  __typename?: 'CrisisContactMethod';
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  from?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['String']>;
};

export type CurrentPeriodLimits = {
  __typename?: 'CurrentPeriodLimits';
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type CustomIcon = {
  __typename?: 'CustomIcon';
  iconName: Scalars['String'];
  itemId: Scalars['ID'];
};

export type CustomIconsInput = {
  iconName?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
};

export type DailyCccResponseAggregate = {
  __typename?: 'DailyCCCResponseAggregate';
  cccResponses: Array<Maybe<CccResponse>>;
  date: Scalars['Date'];
};

export type DailyMoodAggregate = {
  __typename?: 'DailyMoodAggregate';
  averageSelectedMood: Scalars['Int'];
  checkinCount: Scalars['Int'];
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type DailyQuestion = {
  __typename?: 'DailyQuestion';
  createdAt: Scalars['Date'];
  displayTime: Scalars['Date'];
  id: Scalars['String'];
  question: Scalars['String'];
  translation?: Maybe<DailyQuestionTranslationItem>;
  updatedAt: Scalars['Date'];
};

export type DailyQuestionTranslationItem = {
  __typename?: 'DailyQuestionTranslationItem';
  en?: Maybe<DailyQuestionTranslationItem>;
  question?: Maybe<Scalars['String']>;
  uk?: Maybe<DailyQuestionTranslationItem>;
};

export type DefaultSignature = {
  __typename?: 'DefaultSignature';
  credentials?: Maybe<Scalars['String']>;
  licenceNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DefaultSignatureInput = {
  credentials?: InputMaybe<Scalars['String']>;
  licenceNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DefaultTemplateFilter = {
  type?: InputMaybe<TemplateType>;
};

export type DeferredDeepLink = {
  __typename?: 'DeferredDeepLink';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  updatedAt: Scalars['Date'];
  value: Scalars['String'];
};

export type DepressionScores = {
  __typename?: 'DepressionScores';
  level?: Maybe<Levels>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type DiaryEntriesAggregates = {
  __typename?: 'DiaryEntriesAggregates';
  _id?: Maybe<DiaryEntryAggregateId>;
  diaryEntries?: Maybe<Array<Maybe<DiaryEntry>>>;
};

export type DiaryEntriesAggregatesResult = {
  __typename?: 'DiaryEntriesAggregatesResult';
  data?: Maybe<Array<Maybe<DiaryEntriesAggregates>>>;
  total?: Maybe<Scalars['Int']>;
};

export type DiaryEntriesByItemResult = {
  __typename?: 'DiaryEntriesByItemResult';
  data?: Maybe<Array<Maybe<DiaryEntry>>>;
  total?: Maybe<Scalars['Int']>;
};

export type DiaryEntriesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type DiaryEntry = {
  __typename?: 'DiaryEntry';
  _id?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  diaryEntryDate?: Maybe<Scalars['Date']>;
  diaryEntryType?: Maybe<DiaryEntryType>;
  emotions?: Maybe<Array<Maybe<Emotion>>>;
  finalMood?: Maybe<Scalars['Int']>;
  finalThoughts?: Maybe<Scalars['String']>;
  initialMood?: Maybe<Scalars['Int']>;
  initialThoughts?: Maybe<Scalars['String']>;
  initialThoughtsContradiction?: Maybe<Scalars['String']>;
  initialThoughtsSupport?: Maybe<Scalars['String']>;
  moodContextItems?: Maybe<Array<Maybe<MoodContextItem>>>;
  moodContextLabels?: Maybe<Array<Maybe<MoodContextLabel>>>;
  question?: Maybe<Scalars['String']>;
  scores?: Maybe<Score>;
  selectedMood?: Maybe<Scalars['Int']>;
  type?: Maybe<JournalTypes>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type DiaryEntryAggregateId = {
  __typename?: 'DiaryEntryAggregateId';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export enum DiaryEntryType {
  Ccc = 'CCC',
  Journaling = 'JOURNALING',
  Mood = 'MOOD'
}

export type DoctorsFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Sort>;
};

export enum Educations {
  GraduateDegree = 'GRADUATE_DEGREE',
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  NoSchooling = 'NO_SCHOOLING',
  SomeSchooling = 'SOME_SCHOOLING',
  UndergraduateDegree = 'UNDERGRADUATE_DEGREE'
}

export type Emotion = {
  __typename?: 'Emotion';
  custom: Scalars['Boolean'];
  descriptionReplaceText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  moods?: Maybe<Array<Maybe<Scalars['Int']>>>;
  slug?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  translation?: Maybe<EmotionTranslation>;
  type?: Maybe<EmotionType>;
};

export type EmotionTranslation = {
  __typename?: 'EmotionTranslation';
  ar?: Maybe<EmotionTranslationItem>;
  en?: Maybe<EmotionTranslationItem>;
  uk?: Maybe<EmotionTranslationItem>;
};

export type EmotionTranslationItem = {
  __typename?: 'EmotionTranslationItem';
  description?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum EmotionType {
  Negative = 'negative',
  Positive = 'positive'
}

export type EmotionalStabilityScores = {
  __typename?: 'EmotionalStabilityScores';
  level?: Maybe<PersonalityTestLevels>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

export enum EmploymentTypes {
  Employed = 'EMPLOYED',
  HomemakerOrUnemployed = 'HOMEMAKER_OR_UNEMPLOYED',
  Other = 'OTHER',
  Retired = 'RETIRED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export enum EthnicOrigins {
  Arab = 'ARAB',
  Asian = 'ASIAN',
  Black = 'BLACK',
  Latino = 'LATINO',
  Other = 'OTHER',
  White = 'WHITE'
}

export enum EventType {
  ActivityCompleted = 'ACTIVITY_COMPLETED',
  CccExerciseCompleted = 'CCC_EXERCISE_COMPLETED',
  JournalCompleted = 'JOURNAL_COMPLETED',
  MoodCheckInCompleted = 'MOOD_CHECK_IN_COMPLETED',
  MoodTipStatusUpdated = 'MOOD_TIP_STATUS_UPDATED',
  PatientRegistered = 'PATIENT_REGISTERED',
  WellbeingSurveyCompleted = 'WELLBEING_SURVEY_COMPLETED'
}

export enum Features {
  CrisisContacts = 'CRISIS_CONTACTS',
  HealthData = 'HEALTH_DATA',
  Insights = 'INSIGHTS',
  Premium = 'PREMIUM',
  SehaWidget = 'SEHA_WIDGET',
  TestUser = 'TEST_USER',
  ViewBuddies = 'VIEW_BUDDIES',
  ViewUsers = 'VIEW_USERS'
}

export type Feedback = {
  __typename?: 'Feedback';
  activitySlug?: Maybe<Scalars['String']>;
  activityType?: Maybe<ActivityTypes>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  isHelpful?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  moodTipId?: Maybe<Scalars['String']>;
  surveyType?: Maybe<SurveyTypes>;
  type: FeedbackTypes;
  updatedAt?: Maybe<Scalars['Date']>;
  usefulness?: Maybe<Usefulness>;
  user: User;
  widgetType?: Maybe<WidgetType>;
};

export enum FeedbackTypes {
  Activity = 'ACTIVITY',
  MoodTip = 'MOOD_TIP',
  Survey = 'SURVEY',
  Widget = 'WIDGET'
}

export type FeedbacksByActivitySlugFilter = {
  activitySlug?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type FeedbacksByWidgetTypeFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  widgetType?: InputMaybe<WidgetType>;
};

export type FlourishingRatioFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};

export type FlourishingRatioResponse = {
  __typename?: 'FlourishingRatioResponse';
  flourishingRatio?: Maybe<Scalars['Float']>;
  negativeMoodCheckIns?: Maybe<Scalars['Int']>;
  positiveMoodCheckIns?: Maybe<Scalars['Int']>;
  totalMoodCheckIns?: Maybe<Scalars['Int']>;
};

export type Form = {
  __typename?: 'Form';
  completed?: Maybe<Scalars['Boolean']>;
  configUpdatedAt?: Maybe<Scalars['Date']>;
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  doctor?: Maybe<User>;
  formSchedule?: Maybe<FormSchedule>;
  id: Scalars['ID'];
  lastResendDate?: Maybe<Scalars['Date']>;
  message?: Maybe<Scalars['String']>;
  moduleSchedule?: Maybe<ModuleSchedule>;
  organization?: Maybe<Organization>;
  patient?: Maybe<User>;
  repeatable?: Maybe<Scalars['Boolean']>;
  responseDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  responses?: Maybe<Array<Maybe<Scalars['String']>>>;
  scorable?: Maybe<Scalars['Boolean']>;
  scores?: Maybe<Scalars['FormScores']>;
  sent?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Template>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TemplateType>;
  updatedAt: Scalars['Date'];
};

export type FormSchedule = {
  __typename?: 'FormSchedule';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  doctor: User;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isPaused?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  nextOccurrence?: Maybe<Scalars['Date']>;
  organization: Organization;
  patient: User;
  repeat: Repeat;
  repeatable?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  template?: Maybe<Template>;
  updatedAt: Scalars['Date'];
};

export enum Genders {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER'
}

export type Generate2FaQrCodeUrlResult = {
  __typename?: 'Generate2FAQrCodeUrlResult';
  otpAuthUrl: Scalars['String'];
  twoFactorSecret: Scalars['String'];
};

export type Geolocation = {
  __typename?: 'Geolocation';
  created: Scalars['Date'];
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  user: User;
};

export type Group = {
  __typename?: 'Group';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inactive?: Maybe<Scalars['Boolean']>;
  mentors?: Maybe<Array<Maybe<User>>>;
  name?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  organization: Organization;
  patients?: Maybe<Array<Maybe<User>>>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  topic?: Maybe<Scalars['String']>;
  type?: Maybe<GroupType>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum GroupType {
  Couple = 'COUPLE',
  Regular = 'REGULAR'
}

export enum HealthDataTypes {
  ActiveMinutes = 'ACTIVE_MINUTES',
  CaloriesExpended = 'CALORIES_EXPENDED',
  HeartMinutes = 'HEART_MINUTES',
  StepCount = 'STEP_COUNT'
}

export type HealthDataset = {
  __typename?: 'HealthDataset';
  created: Scalars['Date'];
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  user: User;
};

export enum HealthInsurance {
  No = 'NO',
  Unavailable = 'UNAVAILABLE',
  Yes = 'YES'
}

export type HighlightedTextResponse = {
  __typename?: 'HighlightedTextResponse';
  anxiety?: Maybe<Array<Maybe<HighlightedTextTranslation>>>;
  depression?: Maybe<Array<Maybe<HighlightedTextTranslation>>>;
  stress?: Maybe<Array<Maybe<HighlightedTextTranslation>>>;
};

export type HighlightedTextTranslation = {
  __typename?: 'HighlightedTextTranslation';
  ar?: Maybe<HighlightedTextTranslationItem>;
  en?: Maybe<HighlightedTextTranslationItem>;
  uk?: Maybe<HighlightedTextTranslationItem>;
};

export type HighlightedTextTranslationItem = {
  __typename?: 'HighlightedTextTranslationItem';
  highlightedText?: Maybe<Scalars['String']>;
};

export type HubSpotSubscription = {
  __typename?: 'HubSpotSubscription';
  billingFrequency?: Maybe<HubSpotSubscriptionBillingFrequency>;
  gracePeriodEndDate?: Maybe<Scalars['Date']>;
  lastPaymentDate?: Maybe<Scalars['Date']>;
  nextPaymentDueDate?: Maybe<Scalars['Date']>;
  subscriptionStatus?: Maybe<HubSpotSubscriptionStatus>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
};

export enum HubSpotSubscriptionBillingFrequency {
  Annually = 'annually',
  Monthly = 'monthly'
}

export enum HubSpotSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Expired = 'expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Scheduled = 'scheduled',
  Unpaid = 'unpaid'
}

export enum ImageSide {
  Back = 'BACK',
  Front = 'FRONT'
}

export type Insurance = {
  __typename?: 'Insurance';
  acceptAssignment?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  inactive?: Maybe<Scalars['Boolean']>;
  insuranceAddress1?: Maybe<Scalars['String']>;
  insuranceAddress2?: Maybe<Scalars['String']>;
  insuranceBackImage?: Maybe<Scalars['String']>;
  insuranceCity?: Maybe<Scalars['String']>;
  insuranceFrontImage?: Maybe<Scalars['String']>;
  insuranceName?: Maybe<Scalars['String']>;
  insurancePayerId?: Maybe<Scalars['String']>;
  insuranceState?: Maybe<Scalars['String']>;
  insuranceType: InsuranceType;
  insuranceZipCode?: Maybe<Scalars['String']>;
  insuredAddress1?: Maybe<Scalars['String']>;
  insuredAddress2?: Maybe<Scalars['String']>;
  insuredCity?: Maybe<Scalars['String']>;
  insuredDateOfBirth?: Maybe<Scalars['Date']>;
  insuredFirstName?: Maybe<Scalars['String']>;
  insuredGender?: Maybe<Genders>;
  insuredLastName?: Maybe<Scalars['String']>;
  insuredMiddleName?: Maybe<Scalars['String']>;
  insuredPhoneNumber?: Maybe<Scalars['String']>;
  insuredState?: Maybe<Scalars['String']>;
  insuredZipCode?: Maybe<Scalars['String']>;
  patient: User;
  patientRelationToInsured: RelationToInsured;
  policyCopay?: Maybe<Scalars['Float']>;
  policyDeductible?: Maybe<Scalars['Float']>;
  policyGroupId?: Maybe<Scalars['String']>;
  policyMaximumAmount?: Maybe<Scalars['Float']>;
  policyMemberId?: Maybe<Scalars['String']>;
  policyPlanId?: Maybe<Scalars['String']>;
  signatureOnFile?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
};

export type InsuranceDataInput = {
  acceptAssignment?: InputMaybe<Scalars['Boolean']>;
  inactive?: InputMaybe<Scalars['Boolean']>;
  insuranceAddress1?: InputMaybe<Scalars['String']>;
  insuranceAddress2?: InputMaybe<Scalars['String']>;
  insuranceCity?: InputMaybe<Scalars['String']>;
  insuranceName?: InputMaybe<Scalars['String']>;
  insurancePayerId?: InputMaybe<Scalars['String']>;
  insuranceState?: InputMaybe<Scalars['String']>;
  insuranceType: InsuranceType;
  insuranceZipCode?: InputMaybe<Scalars['String']>;
  insuredAddress1?: InputMaybe<Scalars['String']>;
  insuredAddress2?: InputMaybe<Scalars['String']>;
  insuredCity?: InputMaybe<Scalars['String']>;
  insuredDateOfBirth?: InputMaybe<Scalars['Date']>;
  insuredFirstName?: InputMaybe<Scalars['String']>;
  insuredGender?: InputMaybe<Genders>;
  insuredLastName?: InputMaybe<Scalars['String']>;
  insuredMiddleName?: InputMaybe<Scalars['String']>;
  insuredPhoneNumber?: InputMaybe<Scalars['String']>;
  insuredState?: InputMaybe<Scalars['String']>;
  insuredZipCode?: InputMaybe<Scalars['String']>;
  patientRelationToInsured: RelationToInsured;
  policyCopay?: InputMaybe<Scalars['Float']>;
  policyDeductible?: InputMaybe<Scalars['Float']>;
  policyGroupId?: InputMaybe<Scalars['String']>;
  policyMaximumAmount?: InputMaybe<Scalars['Float']>;
  policyMemberId?: InputMaybe<Scalars['String']>;
  policyPlanId?: InputMaybe<Scalars['String']>;
  signatureOnFile?: InputMaybe<Scalars['Boolean']>;
};

export enum InsuranceType {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type IntegrationToken = {
  __typename?: 'IntegrationToken';
  id: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user: User;
};

export enum IntegrationTypes {
  AppleHealth = 'APPLE_HEALTH',
  GoogleFit = 'GOOGLE_FIT',
  Unidays = 'UNIDAYS'
}

export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  invoiceNumber: Scalars['Float'];
  organization: Organization;
  patient: User;
  paymentDate?: Maybe<Scalars['Date']>;
  paymentMethod?: Maybe<PaymentMethod>;
  refundDate?: Maybe<Scalars['Date']>;
  refundMethod?: Maybe<PaymentMethod>;
  session: Session;
  state: InvoiceState;
  stripePaymentId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  stripeProcessingFee?: Maybe<Scalars['Float']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeRefundStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export enum InvoiceState {
  Paid = 'PAID',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type Journal = {
  __typename?: 'Journal';
  answer: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  question: Scalars['String'];
  type: JournalTypes;
  updatedAt?: Maybe<Scalars['Date']>;
  user: User;
};

export type JournalFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  journalType?: InputMaybe<JournalTypes>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type JournalInspiration = {
  __typename?: 'JournalInspiration';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translation?: Maybe<JournalInspirationTranslation>;
};

export type JournalInspirationTranslation = {
  __typename?: 'JournalInspirationTranslation';
  en?: Maybe<JournalInspirationTranslationItem>;
  uk?: Maybe<JournalInspirationTranslationItem>;
};

export type JournalInspirationTranslationItem = {
  __typename?: 'JournalInspirationTranslationItem';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum JournalTypes {
  DailyQuestion = 'DAILY_QUESTION',
  Gratitude = 'GRATITUDE',
  SelfReflection = 'SELF_REFLECTION',
  Thoughts = 'THOUGHTS'
}

export type JwtToken = {
  __typename?: 'JwtToken';
  is2FAEnabled?: Maybe<Scalars['Boolean']>;
  isFirstRegistration?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
};

export type LastMoodCheckInStreakResponse = {
  __typename?: 'LastMoodCheckInStreakResponse';
  from?: Maybe<Scalars['Date']>;
  streak?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Date']>;
};

export type LatestBuddyScore = {
  __typename?: 'LatestBuddyScore';
  anxiety?: Maybe<AnxietyScores>;
  createdAt: Scalars['Date'];
  depression?: Maybe<DepressionScores>;
  lastSurveyTime?: Maybe<Scalars['Date']>;
  stress?: Maybe<StressScores>;
};

export type LatestCccChallenge = {
  __typename?: 'LatestCCCChallenge';
  challengeEndDate: Scalars['Date'];
  challengeStartDate: Scalars['Date'];
  data: Array<Maybe<DailyCccResponseAggregate>>;
};

export type LatestPersonalityTestScore = {
  __typename?: 'LatestPersonalityTestScore';
  createdAt: Scalars['Date'];
  emotionalStability?: Maybe<EmotionalStabilityScores>;
  highlightedText?: Maybe<PersonalityHighlightedTextResponse>;
  id: Scalars['String'];
  selfEsteem?: Maybe<SelfEsteemScores>;
  user: User;
};

export type LatestScore = {
  __typename?: 'LatestScore';
  anxiety?: Maybe<AnxietyScores>;
  createdAt: Scalars['Date'];
  depression?: Maybe<DepressionScores>;
  highlightedText?: Maybe<HighlightedTextResponse>;
  id: Scalars['String'];
  lastCheckInTime?: Maybe<Scalars['Date']>;
  lastSurveyTime?: Maybe<Scalars['Date']>;
  stress?: Maybe<StressScores>;
  surveyResponse?: Maybe<Response>;
  user: User;
  wellbeingIndex?: Maybe<Scalars['Float']>;
  wellbeingIndexDelta?: Maybe<Scalars['Float']>;
};

export type LatestSuperbillForPatient = {
  __typename?: 'LatestSuperbillForPatient';
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  hasUnconfirmedSessions: Scalars['Boolean'];
  sendIn: Scalars['Date'];
};

export enum Levels {
  Elevated = 'ELEVATED',
  Low = 'LOW',
  Mild = 'MILD',
  Moderate = 'MODERATE',
  ModeratelyElevated = 'MODERATELY_ELEVATED'
}

export type ListUsersFilter = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type LoginHistoryItem = {
  __typename?: 'LoginHistoryItem';
  date?: Maybe<Scalars['Date']>;
  loginSource?: Maybe<LoginSource>;
};

export enum LoginSource {
  Dashboard = 'DASHBOARD',
  Mobile = 'MOBILE'
}

export type Message = {
  __typename?: 'Message';
  createdAt: Scalars['Date'];
  customMessage?: Maybe<Scalars['String']>;
  fromBuddy: Buddy;
  id: Scalars['String'];
  messageType: MessageType;
  react?: Maybe<ReactType>;
  read?: Maybe<Scalars['Boolean']>;
  standardMessage?: Maybe<BuddyStandardMessage>;
  text?: Maybe<Scalars['String']>;
  toBuddy: Buddy;
  updatedAt: Scalars['Date'];
};

export type MessageFilter = {
  buddyId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  messageTypes?: InputMaybe<Array<InputMaybe<MessageType>>>;
  read?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Sort>;
};

export enum MessageType {
  React = 'REACT',
  Text = 'TEXT'
}

export type Module = {
  __typename?: 'Module';
  default?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  id: Scalars['ID'];
  input?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ModuleItem>>;
  maxGeneratedItems?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type ModuleItem = {
  __typename?: 'ModuleItem';
  id?: Maybe<Scalars['ID']>;
  template?: Maybe<Template>;
};

export type ModuleItemInput = {
  template: Scalars['ID'];
};

export type ModuleSchedule = {
  __typename?: 'ModuleSchedule';
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<ModuleScheduleItem>>;
  module?: Maybe<Module>;
  organization?: Maybe<Organization>;
  patient?: Maybe<User>;
  startDate?: Maybe<Scalars['Date']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type ModuleScheduleItem = {
  __typename?: 'ModuleScheduleItem';
  delayTime?: Maybe<Scalars['Int']>;
  form?: Maybe<Form>;
  id?: Maybe<Scalars['ID']>;
  sendStatus?: Maybe<ModuleScheduleItemSendStatus>;
  status?: Maybe<ModuleScheduleItemStatus>;
  template?: Maybe<Template>;
};

export enum ModuleScheduleItemSendStatus {
  AfterDelay = 'AFTER_DELAY',
  AfterPrevious = 'AFTER_PREVIOUS'
}

export enum ModuleScheduleItemStatus {
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type ModuleSchedulesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<Sort>;
};

export type ModulesFilter = {
  sort?: InputMaybe<Sort>;
};

export type MoodAndScoreOfPatientResponse = {
  __typename?: 'MoodAndScoreOfPatientResponse';
  mood?: Maybe<MoodResponse>;
  score?: Maybe<Score>;
};

export type MoodContextCategory = {
  __typename?: 'MoodContextCategory';
  deleted?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  initialCategoryId?: Maybe<Scalars['ID']>;
  moderated: Scalars['Boolean'];
  moodContextItems?: Maybe<Array<Maybe<MoodContextItem>>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  predefined?: Maybe<Scalars['Boolean']>;
  translation?: Maybe<MoodContextCategoryTranslation>;
  user: User;
};

export type MoodContextCategoryInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
};

export type MoodContextCategoryOrderItem = {
  __typename?: 'MoodContextCategoryOrderItem';
  categoryId: Scalars['ID'];
};

export type MoodContextCategoryTranslation = {
  __typename?: 'MoodContextCategoryTranslation';
  ar?: Maybe<MoodContextCategoryTranslationItem>;
  en?: Maybe<MoodContextCategoryTranslationItem>;
  uk?: Maybe<MoodContextCategoryTranslationItem>;
};

export type MoodContextCategoryTranslationItem = {
  __typename?: 'MoodContextCategoryTranslationItem';
  name?: Maybe<Scalars['String']>;
};

export type MoodContextItem = {
  __typename?: 'MoodContextItem';
  iconName: Scalars['String'];
  id: Scalars['String'];
  moderated: Scalars['Boolean'];
  name: Scalars['String'];
  predefined?: Maybe<Scalars['Boolean']>;
  translation?: Maybe<MoodContextItemTranslation>;
};

export type MoodContextItemTranslation = {
  __typename?: 'MoodContextItemTranslation';
  ar?: Maybe<MoodContextTranslationItem>;
  en?: Maybe<MoodContextTranslationItem>;
  uk?: Maybe<MoodContextTranslationItem>;
};

export type MoodContextLabel = {
  __typename?: 'MoodContextLabel';
  category?: Maybe<MoodContextLabelCategories>;
  iconName?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  slug: Scalars['String'];
  translation?: Maybe<MoodContextLabelTranslation>;
};

export enum MoodContextLabelCategories {
  Activities = 'ACTIVITIES',
  Experiences = 'EXPERIENCES',
  Locations = 'LOCATIONS',
  Persons = 'PERSONS'
}

export type MoodContextLabelResponse = {
  __typename?: 'MoodContextLabelResponse';
  count?: Maybe<Scalars['Int']>;
  moodContextLabel?: Maybe<MoodContextLabel>;
};

export type MoodContextLabelTranslation = {
  __typename?: 'MoodContextLabelTranslation';
  en?: Maybe<MoodContextLabelTranslationItem>;
  uk?: Maybe<MoodContextLabelTranslationItem>;
};

export type MoodContextLabelTranslationItem = {
  __typename?: 'MoodContextLabelTranslationItem';
  label?: Maybe<Scalars['String']>;
};

export type MoodContextTranslationItem = {
  __typename?: 'MoodContextTranslationItem';
  name?: Maybe<Scalars['String']>;
};

export type MoodResponse = {
  __typename?: 'MoodResponse';
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  emotions?: Maybe<Array<Maybe<Emotion>>>;
  id: Scalars['String'];
  moodContextItems?: Maybe<Array<Maybe<MoodContextItem>>>;
  moodContextLabels?: Maybe<Array<Maybe<MoodContextLabel>>>;
  scores?: Maybe<Score>;
  selectedMood?: Maybe<Scalars['Int']>;
  user: User;
  userId: Scalars['String'];
};

export type MoodResponseFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type MoodStatisticsResponse = {
  __typename?: 'MoodStatisticsResponse';
  averageSelectedMood?: Maybe<Scalars['Int']>;
  mostSelectedEmotions?: Maybe<MostSelectedEmotions>;
};

export type MoodTip = {
  __typename?: 'MoodTip';
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  emotions?: Maybe<Array<Maybe<Emotion>>>;
  id: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  translation?: Maybe<MoodTipTranslation>;
};

export type MoodTipFilter = {
  emotionSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MoodTipResponse = {
  __typename?: 'MoodTipResponse';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  moodTip: MoodTip;
  user: User;
};

export type MoodTipTranslation = {
  __typename?: 'MoodTipTranslation';
  ar?: Maybe<MoodTipTranslationItem>;
  en?: Maybe<MoodTipTranslationItem>;
  uk?: Maybe<MoodTipTranslationItem>;
};

export type MoodTipTranslationItem = {
  __typename?: 'MoodTipTranslationItem';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MoodTipsResponse = {
  __typename?: 'MoodTipsResponse';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  moodTips?: Maybe<Array<Maybe<MoodTipsResponses>>>;
  user: User;
};

export type MoodTipsResponseFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type MoodTipsResponses = {
  __typename?: 'MoodTipsResponses';
  completed?: Maybe<Scalars['Boolean']>;
  moodTip?: Maybe<MoodTip>;
};

export type MostSelectedEmotions = {
  __typename?: 'MostSelectedEmotions';
  count?: Maybe<Scalars['Int']>;
  emotions?: Maybe<Array<Maybe<Emotion>>>;
};

export type MostUsedMoodContextItemResponse = {
  __typename?: 'MostUsedMoodContextItemResponse';
  count?: Maybe<Scalars['Int']>;
  moodContextItem?: Maybe<MoodContextItem>;
};

export type MostUsedMoodContextLabelsFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<Sentiments>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAddendumAndSign: Note;
  addDoctorToOrganization: Scalars['Boolean'];
  addFeature?: Maybe<User>;
  addPatientStripeCreditCard: Scalars['Boolean'];
  addPatientsToGroup: Group;
  addPatientsToSession?: Maybe<Session>;
  addStepCount?: Maybe<Scalars['Boolean']>;
  addStepCounts?: Maybe<Scalars['Boolean']>;
  adminCreateDoctor: User;
  adminCreateTemplate: Template;
  adminSetTemporaryPassword: User;
  adminUpdateTemplate: Template;
  applyDiagnosisToPatient?: Maybe<User>;
  assignModule: ModuleSchedule;
  assignTaskToGroup?: Maybe<Group>;
  buddyInvitation: BuddyInvitation;
  changeTemporaryPassword: Scalars['Boolean'];
  changeUserPassword: User;
  completeActivity?: Maybe<ActivityResponse>;
  completeTask?: Maybe<Task>;
  completeTranscript?: Maybe<Transcript>;
  createAndAssignFormToPatient: Form;
  createAndSendFormToPatient: Form;
  createCCCResponse?: Maybe<CccResponse>;
  createCMSForm: CmsForm;
  createDeferredDeepLink: DeferredDeepLink;
  createFeedback: Feedback;
  createForm: Form;
  createFormSchedule: FormSchedule;
  createGeolocation: Geolocation;
  createGroup: Group;
  createInvoice?: Maybe<Invoice>;
  createJournal: Journal;
  createModule: Module;
  createMoodContextCategory: MoodContextCategory;
  createMoodContextItem: MoodContextCategory;
  createMoodResponse: MoodResponse;
  createNote: Note;
  createOrUpdatePatientInsurance?: Maybe<Insurance>;
  createOrganization: Organization;
  createOrganizationMessage: OrganizationMessage;
  createOrganizationMessageReply: OrganizationMessage;
  createOrganizationService: OrganizationService;
  createSelfCarePlan: SelfCarePlan;
  createSession?: Maybe<Session>;
  createSubscription?: Maybe<Subscription>;
  createSurveyResponse: Response;
  createTask?: Maybe<Task>;
  createTemplate: Template;
  createTranscript: Transcript;
  createTranscriptFromAudioFile: Transcript;
  createUser?: Maybe<User>;
  deleteBuddy: Scalars['Boolean'];
  deleteCMSForm?: Maybe<Scalars['Boolean']>;
  deleteForm: Scalars['Boolean'];
  deleteFormSchedule?: Maybe<FormSchedule>;
  deleteGroup?: Maybe<Scalars['Boolean']>;
  deleteInvoice?: Maybe<Scalars['Boolean']>;
  deleteModule: Scalars['Boolean'];
  deleteMoodContextCategory: MoodContextCategory;
  deleteMoodContextItem: MoodContextCategory;
  deleteNote: Note;
  deleteOrganizationService?: Maybe<Scalars['Boolean']>;
  deleteOrganizationStripeBankAccount?: Maybe<Scalars['Boolean']>;
  deletePatientInsurance?: Maybe<Scalars['Boolean']>;
  deletePatientStripeCreditCard: Scalars['Boolean'];
  deleteSession?: Maybe<Scalars['Boolean']>;
  deleteTemplate: Template;
  deleteTestUser: User;
  deleteTranscript?: Maybe<Scalars['Boolean']>;
  deleteUser: Scalars['Boolean'];
  disableAppleHealth?: Maybe<Scalars['Boolean']>;
  enable2FA?: Maybe<Scalars['Boolean']>;
  enableAppleHealth?: Maybe<IntegrationToken>;
  generate2FAQrCodeUrl: Generate2FaQrCodeUrlResult;
  generateAvatarUploadUrl?: Maybe<AvatarUploadUrl>;
  generateFormData: Scalars['String'];
  generateModule: Module;
  generateOrganizationMessageFileUploadUrl: Scalars['String'];
  generatePrompts: Array<Maybe<Scalars['String']>>;
  generateRecommendedHomework?: Maybe<Array<Maybe<RecommendedActivity>>>;
  generateTemplate: Template;
  generateTemplateFileUploadUrl: Scalars['String'];
  generateTranscriptAudioFileUploadUrl: Scalars['String'];
  getAccessTokenForBreakoutRoom: AccessTokenResponse;
  getAccessTokenForSession: AccessTokenResponse;
  guestUpdateTemplateChatLog?: Maybe<ChatLog>;
  joinWaitingList: Scalars['Boolean'];
  linkGoogleFit?: Maybe<IntegrationToken>;
  linkProvider?: Maybe<IntegrationToken>;
  loginUserWithApple: JwtToken;
  loginUserWithGoogle: JwtToken;
  loginUserWithPassword: JwtToken;
  loginUserWithPhoneNumber: VerifyPhoneNumberPayload;
  markMessagesRead: UpdateResult;
  markNotificationsAsRead?: Maybe<Scalars['Int']>;
  markOrganizationMessageAsRead: OrganizationMessage;
  organizationInvitation: OrganizationInvitation;
  payInvoice?: Maybe<Invoice>;
  payInvoiceOnline?: Maybe<Invoice>;
  redeemBuddyInvitationCode: Scalars['Boolean'];
  redeemOrganizationInvitationCode: Scalars['Boolean'];
  refreshHealthData?: Maybe<Scalars['Boolean']>;
  refundInvoice?: Maybe<Invoice>;
  refundInvoiceOnline?: Maybe<Invoice>;
  registerUserByEmail: VerifyEmailPayload;
  registerUserByPhoneNumber?: Maybe<VerifyPhoneNumberPayload>;
  removeDiagnosisFromPatient?: Maybe<User>;
  removePatientFromSession?: Maybe<Session>;
  removePatientsFromGroup: Group;
  requestToContactUmoreTeam?: Maybe<Scalars['Boolean']>;
  resendEmailVerificationCode: User;
  resendFormToPatient: Form;
  resendPhoneNumberVerificationCode: Scalars['Boolean'];
  resetPasswordAndLogin: VerifyEmailPayload;
  respondToSession?: Maybe<Session>;
  revokeAppleToken: Scalars['Boolean'];
  saveFormResponse: Form;
  selectMoodTip?: Maybe<MoodTipResponse>;
  sendDoctorPatientAppInvitation: Scalars['Boolean'];
  sendForm: Form;
  sendFormToDoctor: Scalars['Boolean'];
  sendInvitation: Scalars['Boolean'];
  sendMessage: Message;
  sendReact: Message;
  sendResetEmailVerificationCode: ResetPasswordPayload;
  sendSegmentEvent: Scalars['Boolean'];
  sendStandardMessage: Message;
  setupOrganizationStripeAccount?: Maybe<Scalars['String']>;
  signNote: Note;
  unlinkGoogleFit?: Maybe<Scalars['Boolean']>;
  unlinkProvider?: Maybe<Scalars['Boolean']>;
  updateBillableCptCodeState?: Maybe<BillableCptCode>;
  updateCMSForm: CmsForm;
  updateCMSFormState: CmsForm;
  updateForm: Form;
  updateFormSchedulePauseStatus: FormSchedule;
  updateFormScheduleTime: FormSchedule;
  updateGroup: Group;
  updateJournal: Journal;
  updateModule: Module;
  updateMoodContextCategory: MoodContextCategory;
  updateMoodContextItem: Scalars['Boolean'];
  updateMoodResponse: MoodResponse;
  updateNote: Note;
  updateNotificationTokens: Scalars['Boolean'];
  updateOrganization: Organization;
  updateOrganizationLogo: Organization;
  updateOrganizationMessageFiles: OrganizationMessage;
  updateOrganizationService: OrganizationService;
  updateOrganizationStripeBankAccount?: Maybe<Scalars['Boolean']>;
  updatePatientArchivedStatus: User;
  updatePatientInsuranceImage?: Maybe<Insurance>;
  updatePatientProfile: User;
  updatePatientStripeCreditCard: Scalars['Boolean'];
  updateProfile: User;
  updateSelectedMoodTipStatus?: Maybe<MoodTipsResponse>;
  updateSelfCarePlan: SelfCarePlan;
  updateSelfCarePlanAppToolState: SelfCarePlan;
  updateSession?: Maybe<Session>;
  updateTemplate: Template;
  updateTemplateChatLog?: Maybe<ChatLog>;
  updateTranscript?: Maybe<Transcript>;
  updateTranscriptNote?: Maybe<Transcript>;
  updateUserActivityState: User;
  updateUserRouteState: User;
  uploadAvatar: User;
  validateVerificationCode: ResetPasswordPayload;
  verify2FACodeAndLogin: JwtToken;
  verifyEmail: JwtToken;
  verifyPhoneNumber: JwtToken;
  voteActivity: Feedback;
  voteMoodTip: Feedback;
  voteWidget: Feedback;
};


export type MutationAddAddendumAndSignArgs = {
  addendumText: Scalars['String'];
  deleted?: InputMaybe<Scalars['Boolean']>;
  noteId: Scalars['ID'];
};


export type MutationAddDoctorToOrganizationArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddFeatureArgs = {
  feature?: InputMaybe<Features>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddPatientStripeCreditCardArgs = {
  patientId: Scalars['String'];
  stripeTokenId: Scalars['String'];
};


export type MutationAddPatientsToGroupArgs = {
  groupId: Scalars['ID'];
  patients: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationAddPatientsToSessionArgs = {
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sessionId: Scalars['ID'];
};


export type MutationAddStepCountArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Int']>;
};


export type MutationAddStepCountsArgs = {
  steps?: InputMaybe<Array<InputMaybe<StepDataInput>>>;
};


export type MutationAdminCreateDoctorArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  temporaryPassword: Scalars['String'];
};


export type MutationAdminCreateTemplateArgs = {
  content: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  scorable: Scalars['Boolean'];
  scoresDescription?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  type: TemplateType;
};


export type MutationAdminSetTemporaryPasswordArgs = {
  email: Scalars['String'];
  temporaryPassword: Scalars['String'];
};


export type MutationAdminUpdateTemplateArgs = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  scorable?: InputMaybe<Scalars['Boolean']>;
  scoresDescription?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationApplyDiagnosisToPatientArgs = {
  assignedAt: Scalars['Date'];
  diagnosisId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignModuleArgs = {
  moduleId: Scalars['ID'];
  patientId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationAssignTaskToGroupArgs = {
  group?: InputMaybe<Scalars['ID']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type MutationChangeTemporaryPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationChangeUserPasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCompleteActivityArgs = {
  activityData?: InputMaybe<Scalars['String']>;
  activitySlug: Scalars['String'];
};


export type MutationCompleteTaskArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationCompleteTranscriptArgs = {
  transcriptId: Scalars['ID'];
};


export type MutationCreateAndAssignFormToPatientArgs = {
  content: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  templateId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationCreateAndSendFormToPatientArgs = {
  content: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  templateId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationCreateCccResponseArgs = {
  finalMood?: InputMaybe<Scalars['Int']>;
  finalThoughts?: InputMaybe<Scalars['String']>;
  initialMood: Scalars['Int'];
  initialThoughts?: InputMaybe<Scalars['String']>;
  initialThoughtsContradiction?: InputMaybe<Scalars['String']>;
  initialThoughtsSupport?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCmsFormArgs = {
  data: CmsFormDataInput;
  patientId: Scalars['ID'];
  sessionIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationCreateDeferredDeepLinkArgs = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type MutationCreateFeedbackArgs = {
  activityType?: InputMaybe<ActivityTypes>;
  isHelpful?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  surveyType?: InputMaybe<SurveyTypes>;
  type: FeedbackTypes;
  usefulness?: InputMaybe<Usefulness>;
};


export type MutationCreateFormArgs = {
  content: Scalars['String'];
};


export type MutationCreateFormScheduleArgs = {
  content?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  repeat: Repeat;
  sendNow?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  templateId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationCreateGeolocationArgs = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateGroupArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  topic?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GroupType>;
};


export type MutationCreateInvoiceArgs = {
  patientId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type MutationCreateJournalArgs = {
  answer: Scalars['String'];
  question: Scalars['String'];
  type: JournalTypes;
};


export type MutationCreateModuleArgs = {
  description?: InputMaybe<Scalars['String']>;
  items: Array<ModuleItemInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};


export type MutationCreateMoodContextCategoryArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateMoodContextItemArgs = {
  categoryId: Scalars['ID'];
  iconName: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateMoodResponseArgs = {
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  emotionSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moodContextItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  moodContextLabelSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedMood?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateNoteArgs = {
  date?: InputMaybe<Scalars['Date']>;
  patientId?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  type: NoteType;
};


export type MutationCreateOrUpdatePatientInsuranceArgs = {
  data: InsuranceDataInput;
  insuranceId?: InputMaybe<Scalars['ID']>;
  patientId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateOrganizationArgs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPaidTrial?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  npi?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOrganizationMessageArgs = {
  content: Scalars['String'];
  recipients?: InputMaybe<Array<Scalars['ID']>>;
  subject?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOrganizationMessageReplyArgs = {
  content: Scalars['String'];
  organizationMessageId: Scalars['ID'];
};


export type MutationCreateOrganizationServiceArgs = {
  cptCode: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  fee?: InputMaybe<Scalars['Float']>;
  isAddOn?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSelfCarePlanArgs = {
  diagnosis?: InputMaybe<Scalars['String']>;
  goals?: InputMaybe<Array<SelfCarePlanGoalInput>>;
  patientId: Scalars['ID'];
  steps: Array<SelfCarePlanStepInput>;
};


export type MutationCreateSessionArgs = {
  cptCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  hasVideo?: InputMaybe<Scalars['Boolean']>;
  hosts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  organizationId: Scalars['ID'];
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  selectedGroup?: InputMaybe<Scalars['ID']>;
  serviceCharge?: InputMaybe<Scalars['Float']>;
  servicePlace?: InputMaybe<Scalars['ID']>;
  serviceType?: InputMaybe<Scalars['ID']>;
  services?: InputMaybe<Array<InputMaybe<SessionServiceInput>>>;
  sessionType: SessionType;
  startDate: Scalars['Date'];
  status?: InputMaybe<SessionStatus>;
  title: Scalars['String'];
};


export type MutationCreateSubscriptionArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  expirationDate: Scalars['Date'];
  orderId: Scalars['String'];
  originalOrderId?: InputMaybe<Scalars['String']>;
  originalPurchaseTime?: InputMaybe<Scalars['Date']>;
  packageName?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
  productId: Scalars['String'];
  purchaseTime: Scalars['Date'];
  purchaseToken?: InputMaybe<Scalars['String']>;
  transactionReceipt?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSurveyResponseArgs = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  surveyType: SurveyTypes;
};


export type MutationCreateTaskArgs = {
  organization?: InputMaybe<Scalars['ID']>;
  taskType?: InputMaybe<TaskTypes>;
};


export type MutationCreateTemplateArgs = {
  content: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  scorable?: InputMaybe<Scalars['Boolean']>;
  scoresDescription?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  type?: InputMaybe<TemplateType>;
};


export type MutationCreateTranscriptArgs = {
  noteType?: InputMaybe<TranscriptNoteType>;
  patients?: InputMaybe<Array<Scalars['ID']>>;
  sessionType?: InputMaybe<TranscriptSessionType>;
  source?: InputMaybe<TranscriptSource>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateTranscriptFromAudioFileArgs = {
  fileUrl: Scalars['String'];
  patients?: InputMaybe<Array<Scalars['ID']>>;
  sessionType?: InputMaybe<TranscriptSessionType>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryDoctorId: Scalars['ID'];
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeleteBuddyArgs = {
  buddy?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteCmsFormArgs = {
  cmsFormId: Scalars['ID'];
};


export type MutationDeleteFormArgs = {
  formId: Scalars['ID'];
};


export type MutationDeleteFormScheduleArgs = {
  formScheduleId: Scalars['ID'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationDeleteInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationDeleteModuleArgs = {
  moduleId: Scalars['ID'];
};


export type MutationDeleteMoodContextCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMoodContextItemArgs = {
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteNoteArgs = {
  noteId: Scalars['ID'];
};


export type MutationDeleteOrganizationServiceArgs = {
  organizationServiceId: Scalars['ID'];
};


export type MutationDeletePatientInsuranceArgs = {
  insuranceId: Scalars['ID'];
};


export type MutationDeletePatientStripeCreditCardArgs = {
  cardId: Scalars['String'];
  patientId: Scalars['String'];
};


export type MutationDeleteSessionArgs = {
  reason?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};


export type MutationDeleteTemplateArgs = {
  templateId: Scalars['ID'];
};


export type MutationDeleteTestUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteTranscriptArgs = {
  transcriptId: Scalars['ID'];
};


export type MutationEnable2FaArgs = {
  code: Scalars['String'];
};


export type MutationGenerateFormDataArgs = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
  input: Scalars['String'];
  type?: InputMaybe<TemplateType>;
};


export type MutationGenerateModuleArgs = {
  input: Scalars['String'];
};


export type MutationGenerateOrganizationMessageFileUploadUrlArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  organizationMessageId: Scalars['ID'];
  replyId?: InputMaybe<Scalars['String']>;
};


export type MutationGeneratePromptsArgs = {
  input: Scalars['String'];
};


export type MutationGenerateRecommendedHomeworkArgs = {
  transcriptId: Scalars['ID'];
};


export type MutationGenerateTemplateArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  input: Scalars['String'];
  type: TemplateType;
};


export type MutationGenerateTemplateFileUploadUrlArgs = {
  contentType: Scalars['String'];
  fileExtension?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateTranscriptAudioFileUploadUrlArgs = {
  contentType: Scalars['String'];
  fileExtension?: InputMaybe<Scalars['String']>;
};


export type MutationGetAccessTokenForBreakoutRoomArgs = {
  sessionId: Scalars['ID'];
};


export type MutationGetAccessTokenForSessionArgs = {
  sessionId: Scalars['ID'];
};


export type MutationGuestUpdateTemplateChatLogArgs = {
  chatLogId?: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  input: Scalars['String'];
};


export type MutationJoinWaitingListArgs = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationLinkGoogleFitArgs = {
  authCode?: InputMaybe<Scalars['String']>;
};


export type MutationLinkProviderArgs = {
  authCode: Scalars['String'];
  provider: IntegrationTypes;
};


export type MutationLoginUserWithAppleArgs = {
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  identityToken: Scalars['String'];
};


export type MutationLoginUserWithGoogleArgs = {
  authCode?: InputMaybe<Scalars['String']>;
  loginSource?: InputMaybe<LoginSource>;
  redirectUri?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};


export type MutationLoginUserWithPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  loginSource?: InputMaybe<LoginSource>;
  password?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};


export type MutationLoginUserWithPhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationMarkMessagesReadArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationMarkNotificationsAsReadArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationMarkOrganizationMessageAsReadArgs = {
  organizationMessageId: Scalars['ID'];
};


export type MutationOrganizationInvitationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationPayInvoiceArgs = {
  invoiceId: Scalars['ID'];
  paymentDate?: InputMaybe<Scalars['Date']>;
  paymentMethod: PaymentMethod;
};


export type MutationPayInvoiceOnlineArgs = {
  cardId: Scalars['String'];
  invoiceId: Scalars['ID'];
};


export type MutationRedeemBuddyInvitationCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type MutationRedeemOrganizationInvitationCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type MutationRefundInvoiceArgs = {
  invoiceId: Scalars['ID'];
  refundDate?: InputMaybe<Scalars['Date']>;
  refundMethod: PaymentMethod;
};


export type MutationRefundInvoiceOnlineArgs = {
  invoiceId: Scalars['ID'];
  refundReason?: InputMaybe<StripeRefundReason>;
};


export type MutationRegisterUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  loginSource?: InputMaybe<LoginSource>;
  password?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterUserByPhoneNumberArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationRemoveDiagnosisFromPatientArgs = {
  diagnosisId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemovePatientFromSessionArgs = {
  patientId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};


export type MutationRemovePatientsFromGroupArgs = {
  groupId: Scalars['ID'];
  patients: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationResendEmailVerificationCodeArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationResendFormToPatientArgs = {
  formId: Scalars['ID'];
};


export type MutationResendPhoneNumberVerificationCodeArgs = {
  token: Scalars['String'];
};


export type MutationResetPasswordAndLoginArgs = {
  code?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  loginSource?: InputMaybe<LoginSource>;
  newPassword?: InputMaybe<Scalars['String']>;
};


export type MutationRespondToSessionArgs = {
  acceptanceState: AcceptanceState;
  sessionId: Scalars['ID'];
};


export type MutationRevokeAppleTokenArgs = {
  authorizationCode: Scalars['String'];
};


export type MutationSaveFormResponseArgs = {
  completed?: InputMaybe<Scalars['Boolean']>;
  formId: Scalars['ID'];
  response: Scalars['String'];
};


export type MutationSelectMoodTipArgs = {
  moodTipId: Scalars['String'];
};


export type MutationSendFormArgs = {
  formId: Scalars['ID'];
};


export type MutationSendFormToDoctorArgs = {
  email: Scalars['String'];
  formId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};


export type MutationSendInvitationArgs = {
  customEmailMessage?: InputMaybe<Scalars['String']>;
  customSMSMessage?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
};


export type MutationSendMessageArgs = {
  message: Scalars['String'];
  to: Scalars['ID'];
};


export type MutationSendReactArgs = {
  react: ReactType;
  to: Scalars['ID'];
};


export type MutationSendResetEmailVerificationCodeArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationSendSegmentEventArgs = {
  eventName: Scalars['String'];
  properties?: InputMaybe<Scalars['Object']>;
};


export type MutationSendStandardMessageArgs = {
  slug: Scalars['String'];
  to: Scalars['ID'];
};


export type MutationSetupOrganizationStripeAccountArgs = {
  urlPath?: InputMaybe<Scalars['String']>;
};


export type MutationSignNoteArgs = {
  noteId: Scalars['ID'];
};


export type MutationUnlinkProviderArgs = {
  provider: IntegrationTypes;
};


export type MutationUpdateBillableCptCodeStateArgs = {
  billableCptCodeId: Scalars['ID'];
  isBilled: Scalars['Boolean'];
};


export type MutationUpdateCmsFormArgs = {
  cmsFormId: Scalars['ID'];
  data: CmsFormDataInput;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationUpdateCmsFormStateArgs = {
  cmsFormId: Scalars['ID'];
  state: CmsFormState;
};


export type MutationUpdateFormArgs = {
  content?: InputMaybe<Scalars['String']>;
  formId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationUpdateFormSchedulePauseStatusArgs = {
  formScheduleId: Scalars['ID'];
};


export type MutationUpdateFormScheduleTimeArgs = {
  formScheduleId: Scalars['ID'];
  repeat?: InputMaybe<Repeat>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateGroupArgs = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  groupId: Scalars['ID'];
  inactive?: InputMaybe<Scalars['Boolean']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  topic?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateJournalArgs = {
  answer: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateModuleArgs = {
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ModuleItemInput>>;
  moduleId: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMoodContextCategoryArgs = {
  id: Scalars['ID'];
  moodContextItems?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMoodContextItemArgs = {
  iconName: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateMoodResponseArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationUpdateNoteArgs = {
  addendumText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  noteId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NoteType>;
};


export type MutationUpdateNotificationTokensArgs = {
  apnsToken?: InputMaybe<Scalars['String']>;
  fcmToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationArgs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receiveHighPhq9Email?: InputMaybe<Scalars['Boolean']>;
  receiveHighPhq9Notification?: InputMaybe<Scalars['Boolean']>;
  receiveHighSurveyEmail?: InputMaybe<Scalars['Boolean']>;
  receiveHighSurveyNotification?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stripeStatementDescriptor?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  transcriptDefaultSettings?: InputMaybe<TranscriptDefaultSettingsInput>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationLogoArgs = {
  base64?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationMessageFilesArgs = {
  fileName: Scalars['String'];
  organizationMessageId: Scalars['ID'];
  replyId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationServiceArgs = {
  duration?: InputMaybe<Scalars['Int']>;
  fee?: InputMaybe<Scalars['Float']>;
  isAddOn?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationServiceId: Scalars['ID'];
};


export type MutationUpdateOrganizationStripeBankAccountArgs = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  stripeStatementDescriptor?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePatientArchivedStatusArgs = {
  archived: Scalars['Boolean'];
  patientId: Scalars['ID'];
};


export type MutationUpdatePatientInsuranceImageArgs = {
  base64: Scalars['String'];
  insuranceId: Scalars['ID'];
  side: ImageSide;
};


export type MutationUpdatePatientProfileArgs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingType?: InputMaybe<BillingType>;
  city?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Genders>;
  healthInsurance?: InputMaybe<HealthInsurance>;
  healthInsuranceNumber?: InputMaybe<Scalars['String']>;
  healthInsuranceProvider?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  primaryDoctorId?: InputMaybe<Scalars['ID']>;
  pronoun?: InputMaybe<Pronouns>;
  receiveAutomaticInvoice?: InputMaybe<Scalars['Boolean']>;
  receiveAutomaticSuperbill?: InputMaybe<Scalars['Boolean']>;
  receiveReminders?: InputMaybe<Scalars['Boolean']>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  superbillDisabled?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePatientStripeCreditCardArgs = {
  cardId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  patientId: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  ageRange?: InputMaybe<AgeRanges>;
  apnTokens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  customIcons?: InputMaybe<Array<InputMaybe<CustomIconsInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  defaultSignature?: InputMaybe<DefaultSignatureInput>;
  doctorRole?: InputMaybe<Scalars['String']>;
  doctorTitle?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Educations>;
  email?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<EmploymentTypes>;
  ethnicOrigin?: InputMaybe<EthnicOrigins>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Genders>;
  generalNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  healthInsurance?: InputMaybe<HealthInsurance>;
  healthInsuranceNumber?: InputMaybe<Scalars['String']>;
  healthInsuranceProvider?: InputMaybe<Scalars['String']>;
  isNotificationOnboarded?: InputMaybe<Scalars['Boolean']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenceExpiryDate?: InputMaybe<Scalars['Date']>;
  licenceNumber?: InputMaybe<Scalars['String']>;
  licenceState?: InputMaybe<Scalars['String']>;
  moodContextCategoriesOrder?: InputMaybe<Array<InputMaybe<MoodContextCategoryInput>>>;
  npi?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  pronoun?: InputMaybe<Pronouns>;
  sharedData?: InputMaybe<Array<InputMaybe<SharedData>>>;
  signupPurposes?: InputMaybe<Array<InputMaybe<SignupPurposes>>>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  tokens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  yearOfBirth?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSelectedMoodTipStatusArgs = {
  completed: Scalars['Boolean'];
  moodTipId: Scalars['String'];
};


export type MutationUpdateSelfCarePlanArgs = {
  diagnosis?: InputMaybe<Scalars['String']>;
  goals?: InputMaybe<Array<SelfCarePlanGoalInput>>;
  selfCarePlanId: Scalars['ID'];
  steps?: InputMaybe<Array<SelfCarePlanStepInput>>;
};


export type MutationUpdateSelfCarePlanAppToolStateArgs = {
  appToolId: Scalars['ID'];
  selfCarePlanId: Scalars['ID'];
  state: Scalars['Boolean'];
  stepId: Scalars['ID'];
};


export type MutationUpdateSessionArgs = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  cptCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  hasVideo?: InputMaybe<Scalars['Boolean']>;
  hosts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notes?: InputMaybe<Scalars['String']>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  selectedGroup?: InputMaybe<Scalars['ID']>;
  serviceCharge?: InputMaybe<Scalars['Float']>;
  servicePlace?: InputMaybe<Scalars['ID']>;
  serviceType?: InputMaybe<Scalars['ID']>;
  services?: InputMaybe<Array<InputMaybe<SessionServiceInput>>>;
  sessionId: Scalars['ID'];
  sessionType?: InputMaybe<SessionType>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<SessionStatus>;
  title?: InputMaybe<Scalars['String']>;
  transcripts?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateTemplateArgs = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  scoresDescription?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationUpdateTemplateChatLogArgs = {
  content: Scalars['String'];
  input: Scalars['String'];
  templateId: Scalars['ID'];
};


export type MutationUpdateTranscriptArgs = {
  customPrompt?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  noteType?: InputMaybe<TranscriptNoteType>;
  patients?: InputMaybe<Array<Scalars['ID']>>;
  sessionDate?: InputMaybe<Scalars['Date']>;
  sessionType?: InputMaybe<TranscriptSessionType>;
  source?: InputMaybe<TranscriptSource>;
  summary?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  transcriptId: Scalars['ID'];
};


export type MutationUpdateTranscriptNoteArgs = {
  input: Scalars['String'];
  transcriptId: Scalars['ID'];
};


export type MutationUpdateUserActivityStateArgs = {
  activity: Scalars['String'];
  state: UserActivityState;
};


export type MutationUpdateUserRouteStateArgs = {
  route: Routes;
  state: UserActivityState;
};


export type MutationUploadAvatarArgs = {
  base64: Scalars['String'];
};


export type MutationValidateVerificationCodeArgs = {
  code?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
};


export type MutationVerify2FaCodeAndLoginArgs = {
  code: Scalars['String'];
  loginSource?: InputMaybe<LoginSource>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


export type MutationVerifyEmailArgs = {
  code?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyPhoneNumberArgs = {
  code: Scalars['String'];
  token: Scalars['String'];
};


export type MutationVoteActivityArgs = {
  activitySlug: Scalars['String'];
  vote: Scalars['Boolean'];
};


export type MutationVoteMoodTipArgs = {
  moodTipId: Scalars['String'];
  vote: Scalars['Boolean'];
};


export type MutationVoteWidgetArgs = {
  vote: Scalars['Boolean'];
  widgetType: WidgetType;
};

export type NeededScore = {
  __typename?: 'NeededScore';
  anxiety?: Maybe<Scalars['Float']>;
  depression?: Maybe<Scalars['Float']>;
  stress?: Maybe<Scalars['Float']>;
};

export type Note = {
  __typename?: 'Note';
  addendums?: Maybe<Array<Maybe<Addendum>>>;
  createdAt: Scalars['Date'];
  date: Scalars['Date'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  organization: Organization;
  patient?: Maybe<User>;
  session?: Maybe<Session>;
  signature?: Maybe<Signature>;
  text?: Maybe<Scalars['String']>;
  type: NoteType;
  updatedAt: Scalars['Date'];
};

export enum NoteType {
  ProgressNote = 'PROGRESS_NOTE',
  Text = 'TEXT',
  TreatmentPlan = 'TREATMENT_PLAN'
}

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Date'];
  data?: Maybe<NotificationData>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  receiverOrganization?: Maybe<Organization>;
  senderUser?: Maybe<User>;
  session?: Maybe<Session>;
  type: NotificationType;
  updatedAt: Scalars['Date'];
};

export type NotificationData = {
  __typename?: 'NotificationData';
  anxietyLevel?: Maybe<Levels>;
  depressionLevel?: Maybe<Levels>;
  form?: Maybe<Form>;
  optionSlug?: Maybe<Scalars['String']>;
  stressLevel?: Maybe<Levels>;
  surveyType?: Maybe<SurveyTypes>;
};

export enum NotificationType {
  FormResponseSubmitted = 'FORM_RESPONSE_SUBMITTED',
  UserAcceptedSession = 'USER_ACCEPTED_SESSION',
  UserCompletedWellbeingSurvey = 'USER_COMPLETED_WELLBEING_SURVEY',
  UserDeclinedSession = 'USER_DECLINED_SESSION',
  UserRegisteredWithMobileApp = 'USER_REGISTERED_WITH_MOBILE_APP',
  UserScoredHighInPhq9 = 'USER_SCORED_HIGH_IN_PHQ9',
  UserScoredHighInSurvey = 'USER_SCORED_HIGH_IN_SURVEY'
}

export type Option = {
  __typename?: 'Option';
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  translation?: Maybe<OptionTranslation>;
};

export type OptionGroup = {
  __typename?: 'OptionGroup';
  id: Scalars['String'];
  options: Array<Maybe<OptionOrderedGroup>>;
  slug: Scalars['String'];
};

export type OptionOrderedGroup = {
  __typename?: 'OptionOrderedGroup';
  option: Option;
  sequenceNumber: Scalars['Int'];
};

export type OptionTranslation = {
  __typename?: 'OptionTranslation';
  ar?: Maybe<OptionTranslationItem>;
  en?: Maybe<OptionTranslationItem>;
  uk?: Maybe<OptionTranslationItem>;
};

export type OptionTranslationItem = {
  __typename?: 'OptionTranslationItem';
  text?: Maybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  currentPeriodFormLimits?: Maybe<CurrentPeriodLimits>;
  currentPeriodTranscriptionCount?: Maybe<Scalars['Int']>;
  currentPeriodTranscriptionLimits?: Maybe<CurrentPeriodLimits>;
  didContactUmoreTeam?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  freeTrialEndDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  npi?: Maybe<Scalars['String']>;
  owner: User;
  phoneNumber?: Maybe<Scalars['String']>;
  receiveHighPhq9Email?: Maybe<Scalars['Boolean']>;
  receiveHighPhq9Notification?: Maybe<Scalars['Boolean']>;
  receiveHighSurveyEmail?: Maybe<Scalars['Boolean']>;
  receiveHighSurveyNotification?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  stripeStatementDescriptor?: Maybe<Scalars['String']>;
  subscriptionEndDate?: Maybe<Scalars['Date']>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  taxId?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  transcriptDefaultSettings?: Maybe<TranscriptDefaultSettings>;
  zipCode?: Maybe<Scalars['String']>;
};

export type OrganizationBillableCptCodesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type OrganizationCmsFormsFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sessionId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<Sort>;
  state?: InputMaybe<Array<InputMaybe<CmsFormState>>>;
};

export type OrganizationFormSchedulesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<Sort>;
};

export type OrganizationFormsFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  isPartOfModule?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sent?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<TemplateType>;
  types?: InputMaybe<Array<InputMaybe<TemplateType>>>;
};

export type OrganizationGroupsFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<Array<InputMaybe<GroupType>>>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  code: Scalars['String'];
  id: Scalars['String'];
  organization: Organization;
};

export type OrganizationInvoicesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<Sort>;
  state?: InputMaybe<Array<InputMaybe<InvoiceState>>>;
};

export type OrganizationMessage = {
  __typename?: 'OrganizationMessage';
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  files?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  organization: Organization;
  owner: User;
  readBy: Array<Maybe<ReadBy>>;
  recipients: Array<Maybe<User>>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type OrganizationMessageFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type OrganizationNotesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<Sort>;
};

export type OrganizationNotificationsFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type OrganizationService = {
  __typename?: 'OrganizationService';
  cptCode: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  duration?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isAddOn?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organization: Organization;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type OrganizationSessionsFilter = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  selectedGroupId?: InputMaybe<Scalars['ID']>;
  sessionType?: InputMaybe<Array<InputMaybe<SessionType>>>;
  sort?: InputMaybe<Sort>;
  status?: InputMaybe<Array<InputMaybe<SessionStatus>>>;
};

export type PatientFormsFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  isPartOfModule?: InputMaybe<Scalars['Boolean']>;
  sent?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Sort>;
  types?: InputMaybe<Array<InputMaybe<TemplateType>>>;
};

export type PatientInsuranceFilter = {
  inactive?: InputMaybe<Scalars['Boolean']>;
  insuranceType?: InputMaybe<InsuranceType>;
  sort?: InputMaybe<Sort>;
};

export type PatientsFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export enum PaymentMethod {
  BankPayment = 'BANK_PAYMENT',
  Cash = 'CASH',
  Check = 'CHECK',
  OnlinePayment = 'ONLINE_PAYMENT',
  Other = 'OTHER',
  Paypal = 'PAYPAL'
}

export type PersonalityHighlightedTextResponse = {
  __typename?: 'PersonalityHighlightedTextResponse';
  negative?: Maybe<PersonalityHighlightedTextResponseItem>;
  positive?: Maybe<PersonalityHighlightedTextResponseItem>;
};

export type PersonalityHighlightedTextResponseItem = {
  __typename?: 'PersonalityHighlightedTextResponseItem';
  bad?: Maybe<Array<Maybe<HighlightedTextTranslation>>>;
  good?: Maybe<Array<Maybe<HighlightedTextTranslation>>>;
};

export enum PersonalityTest {
  EmotionalStability = 'EMOTIONAL_STABILITY',
  SelfEsteem = 'SELF_ESTEEM'
}

export type PersonalityTestFilter = {
  triggeredBy: PersonalityTest;
};

export enum PersonalityTestLevels {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW',
  SomeWhatHigh = 'SOME_WHAT_HIGH',
  SomeWhatLow = 'SOME_WHAT_LOW'
}

export enum Pronouns {
  HeHim = 'HE_HIM',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM'
}

export type Query = {
  __typename?: 'Query';
  CCCResponses?: Maybe<Array<Maybe<CccResponse>>>;
  actionSummaries: ActionSummaries;
  activitiesForRoute?: Maybe<Array<Maybe<Activity>>>;
  activitiesResponses?: Maybe<Array<Maybe<ActivityResponse>>>;
  activityBySlug?: Maybe<ActivityMetaData>;
  adminFetchOrganizationByEmail?: Maybe<Array<Maybe<Organization>>>;
  aggregateMoodByDay?: Maybe<Array<Maybe<DailyMoodAggregate>>>;
  aggregateMoodByDayOfPatient?: Maybe<Array<Maybe<DailyMoodAggregate>>>;
  aggregateSessionsByMonth?: Maybe<Array<Maybe<AggregateSession>>>;
  aggregateStepCountByDay?: Maybe<Array<Maybe<AggregateDailyStepData>>>;
  aggregateStepCountByDayOfPatient?: Maybe<Array<Maybe<AggregateDailyStepData>>>;
  appUsage?: Maybe<Array<Maybe<AppUsage>>>;
  avatarUrl?: Maybe<Scalars['String']>;
  buddyMoodResponses?: Maybe<Array<Maybe<BuddyMoodResponse>>>;
  buddyStandardMessages?: Maybe<Array<Maybe<BuddyStandardMessage>>>;
  calculateRecentScore?: Maybe<Score>;
  calculateScoreFromAnswers?: Maybe<AnswerScores>;
  cmsFormHistory?: Maybe<Array<Maybe<CmsFormHistory>>>;
  convertCurrency?: Maybe<CurrencyConversion>;
  countries?: Maybe<Array<Maybe<Country>>>;
  crisisContacts?: Maybe<Array<Maybe<CrisisContact>>>;
  dailyQuestion?: Maybe<DailyQuestion>;
  dataTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  deferredDeepLink?: Maybe<DeferredDeepLink>;
  diagnoses?: Maybe<Array<Maybe<Diagnosis>>>;
  diaryEntries?: Maybe<DiaryEntriesAggregatesResult>;
  diaryEntriesByItem?: Maybe<DiaryEntriesByItemResult>;
  diaryEntriesForBuddy?: Maybe<DiaryEntriesAggregatesResult>;
  doctors?: Maybe<Array<Maybe<User>>>;
  emotions?: Maybe<Array<Maybe<Emotion>>>;
  emotionsForMood?: Maybe<Array<Maybe<Emotion>>>;
  emotionsForMoodVersion2?: Maybe<Array<Maybe<Emotion>>>;
  features?: Maybe<Array<Maybe<Features>>>;
  feedbacks?: Maybe<Array<Maybe<Feedback>>>;
  feedbacksByActivitySlug?: Maybe<Array<Maybe<Feedback>>>;
  feedbacksBySurveyType?: Maybe<Array<Maybe<Feedback>>>;
  feedbacksByType?: Maybe<Array<Maybe<Feedback>>>;
  feedbacksByWidgetType?: Maybe<Array<Maybe<Feedback>>>;
  flourishingRatio?: Maybe<FlourishingRatioResponse>;
  form?: Maybe<Form>;
  geolocations?: Maybe<Array<Maybe<Geolocation>>>;
  getLastSubscriptionForUser?: Maybe<Subscription>;
  hasUnconfirmedSessions?: Maybe<Scalars['Boolean']>;
  healthData?: Maybe<Scalars['Float']>;
  integrationToken?: Maybe<IntegrationToken>;
  integrationTokens?: Maybe<Array<Maybe<IntegrationToken>>>;
  invoicePdfUrl?: Maybe<Scalars['String']>;
  journalInspirations?: Maybe<Array<Maybe<JournalInspiration>>>;
  journals?: Maybe<Array<Maybe<Journal>>>;
  lastMoodCheckInStreak?: Maybe<LastMoodCheckInStreakResponse>;
  latestBuddyScore?: Maybe<LatestBuddyScore>;
  latestCCCChallenge?: Maybe<LatestCccChallenge>;
  latestPersonalityTestScore?: Maybe<LatestPersonalityTestScore>;
  latestScore?: Maybe<LatestScore>;
  latestSelectedUserMoodTip?: Maybe<MoodTipResponse>;
  latestSelectedUserMoodTips?: Maybe<MoodTipsResponse>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  me?: Maybe<User>;
  messages?: Maybe<Array<Message>>;
  module?: Maybe<Module>;
  moduleSchedule?: Maybe<ModuleSchedule>;
  moduleSchedules?: Maybe<Array<Maybe<ModuleSchedule>>>;
  modules?: Maybe<Array<Maybe<Module>>>;
  moodAndScoreOfPatient?: Maybe<MoodAndScoreOfPatientResponse>;
  moodContextCategories?: Maybe<Array<Maybe<MoodContextCategory>>>;
  moodContextLabels?: Maybe<Array<Maybe<MoodContextLabel>>>;
  moodResponse?: Maybe<MoodResponse>;
  moodResponses?: Maybe<Array<Maybe<MoodResponse>>>;
  moodResponsesOfPatient?: Maybe<Array<Maybe<MoodResponse>>>;
  moodStatistics?: Maybe<MoodStatisticsResponse>;
  moodStatisticsOfPatient?: Maybe<MoodStatisticsResponse>;
  moodTipFeedback?: Maybe<Feedback>;
  moodTips?: Maybe<Array<Maybe<MoodTip>>>;
  moodTipsForUser?: Maybe<Array<Maybe<MoodTip>>>;
  moodTipsResponses?: Maybe<Array<Maybe<MoodTipResponse>>>;
  mostUsedMoodContextItems?: Maybe<Array<Maybe<MostUsedMoodContextItemResponse>>>;
  mostUsedMoodContextLabels?: Maybe<Array<Maybe<MoodContextLabelResponse>>>;
  notePdfUrl?: Maybe<Scalars['String']>;
  organizationBillableCptCodes?: Maybe<Array<Maybe<BillableCptCode>>>;
  organizationCMSForms?: Maybe<Array<Maybe<CmsForm>>>;
  organizationFormSchedules?: Maybe<Array<Maybe<FormSchedule>>>;
  organizationForms?: Maybe<Array<Maybe<Form>>>;
  organizationGroups?: Maybe<Array<Maybe<Group>>>;
  organizationHubSpotSubscription?: Maybe<HubSpotSubscription>;
  organizationInvoices?: Maybe<Array<Maybe<Invoice>>>;
  organizationMessage?: Maybe<OrganizationMessage>;
  organizationMessageFileUrl: Scalars['String'];
  organizationMessages?: Maybe<Array<Maybe<OrganizationMessage>>>;
  organizationNotes?: Maybe<Array<Maybe<Note>>>;
  organizationNotifications?: Maybe<Array<Maybe<Notification>>>;
  organizationServices?: Maybe<Array<Maybe<OrganizationService>>>;
  organizationSessions?: Maybe<Array<Maybe<Session>>>;
  organizationStripeAccount?: Maybe<StripeBankAccount>;
  patientAppUsage?: Maybe<Array<Maybe<AppUsage>>>;
  patientForms?: Maybe<Array<Maybe<Form>>>;
  patientInsurances?: Maybe<Array<Maybe<Insurance>>>;
  patientStripeCreditCards?: Maybe<Array<Maybe<StripeCreditCard>>>;
  patients?: Maybe<Array<Maybe<User>>>;
  quoteOfTheDay?: Maybe<Quote>;
  recommendedActivities?: Maybe<Array<Maybe<Activity>>>;
  recommendedHomework?: Maybe<Array<Maybe<RecommendedActivity>>>;
  responses?: Maybe<Array<Maybe<Response>>>;
  responsesBySurveyType?: Maybe<Array<Maybe<Response>>>;
  scores?: Maybe<Array<Maybe<Score>>>;
  scoresOfPatient?: Maybe<Array<Maybe<Score>>>;
  searchDefaultTemplates?: Maybe<Array<Maybe<Template>>>;
  searchOrganizationTemplates?: Maybe<Array<Maybe<Template>>>;
  selfCarePlan?: Maybe<SelfCarePlan>;
  selfCarePlanOfPatient?: Maybe<SelfCarePlan>;
  sentMessages?: Maybe<Array<Message>>;
  servicePlaces?: Maybe<Array<Maybe<ServicePlace>>>;
  serviceTypes?: Maybe<Array<Maybe<ServiceType>>>;
  session?: Maybe<Session>;
  sessions?: Maybe<Array<Maybe<Session>>>;
  sleepData?: Maybe<Array<Maybe<SleepData>>>;
  sleepDuration?: Maybe<Scalars['String']>;
  sortedEmotionsByType?: Maybe<SortedEmotionsByTypeResponse>;
  sortedHelpfulActivities?: Maybe<Array<Maybe<SortedActivitiesResponse>>>;
  sortedHelpfulActivitiesForUser?: Maybe<Array<Maybe<SortedActivitiesResponse>>>;
  superbill?: Maybe<Superbill>;
  superbillPdfUrl?: Maybe<Scalars['String']>;
  survey?: Maybe<Survey>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  template?: Maybe<Template>;
  templateChatLog?: Maybe<ChatLog>;
  templates?: Maybe<TemplatesResult>;
  transcript?: Maybe<Transcript>;
  transcripts?: Maybe<Array<Maybe<Transcript>>>;
  userGroup?: Maybe<Group>;
  userLocationInfo?: Maybe<UserLocationInfo>;
};


export type QueryCccResponsesArgs = {
  filter?: InputMaybe<CccResponseFilter>;
};


export type QueryActionSummariesArgs = {
  filter: ActionSummariesFilter;
};


export type QueryActivitiesForRouteArgs = {
  route?: InputMaybe<Routes>;
};


export type QueryActivitiesResponsesArgs = {
  filter?: InputMaybe<ActivityResponseFilter>;
};


export type QueryActivityBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryAdminFetchOrganizationByEmailArgs = {
  email: Scalars['String'];
};


export type QueryAggregateMoodByDayArgs = {
  filter?: InputMaybe<AggregateMoodByDayFilter>;
};


export type QueryAggregateMoodByDayOfPatientArgs = {
  filter?: InputMaybe<AggregateMoodByDayFilter>;
  patientId: Scalars['ID'];
};


export type QueryAggregateSessionsByMonthArgs = {
  filter?: InputMaybe<AggregateSessionsByMonthFilter>;
  patientId: Scalars['ID'];
};


export type QueryAggregateStepCountByDayArgs = {
  filter?: InputMaybe<AggregateStepFilter>;
};


export type QueryAggregateStepCountByDayOfPatientArgs = {
  filter?: InputMaybe<AggregateStepFilter>;
  patientId: Scalars['ID'];
};


export type QueryAppUsageArgs = {
  filter?: InputMaybe<AppUsageFilter>;
};


export type QueryBuddyMoodResponsesArgs = {
  buddyId: Scalars['ID'];
  filter?: InputMaybe<MoodResponseFilter>;
};


export type QueryCalculateScoreFromAnswersArgs = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
};


export type QueryCmsFormHistoryArgs = {
  cmsFormId: Scalars['ID'];
  filter?: InputMaybe<CmsFormHistoryFilter>;
};


export type QueryConvertCurrencyArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryCrisisContactsArgs = {
  filter?: InputMaybe<CrisisContactFilter>;
};


export type QueryDeferredDeepLinkArgs = {
  key: Scalars['String'];
};


export type QueryDiaryEntriesArgs = {
  filter?: InputMaybe<DiaryEntriesFilter>;
};


export type QueryDiaryEntriesByItemArgs = {
  filter?: InputMaybe<DiaryEntriesFilter>;
};


export type QueryDiaryEntriesForBuddyArgs = {
  filter?: InputMaybe<DiaryEntriesFilter>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryDoctorsArgs = {
  filter?: InputMaybe<DoctorsFilter>;
};


export type QueryEmotionsForMoodArgs = {
  mood?: InputMaybe<Scalars['Int']>;
};


export type QueryEmotionsForMoodVersion2Args = {
  mood?: InputMaybe<Scalars['Int']>;
};


export type QueryFeedbacksByActivitySlugArgs = {
  filter?: InputMaybe<FeedbacksByActivitySlugFilter>;
};


export type QueryFeedbacksBySurveyTypeArgs = {
  surveyType: SurveyTypes;
};


export type QueryFeedbacksByTypeArgs = {
  type: FeedbackTypes;
};


export type QueryFeedbacksByWidgetTypeArgs = {
  filter?: InputMaybe<FeedbacksByWidgetTypeFilter>;
};


export type QueryFlourishingRatioArgs = {
  filter?: InputMaybe<FlourishingRatioFilter>;
};


export type QueryFormArgs = {
  formId: Scalars['ID'];
};


export type QueryGeolocationsArgs = {
  timeGt?: InputMaybe<Scalars['Date']>;
  timeLt?: InputMaybe<Scalars['Date']>;
};


export type QueryHasUnconfirmedSessionsArgs = {
  month: Scalars['Int'];
  patientId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QueryHealthDataArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  healthDataType?: InputMaybe<HealthDataTypes>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryIntegrationTokenArgs = {
  type?: InputMaybe<IntegrationTypes>;
};


export type QueryInvoicePdfUrlArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryJournalInspirationsArgs = {
  type?: InputMaybe<JournalTypes>;
};


export type QueryJournalsArgs = {
  filter?: InputMaybe<JournalFilter>;
};


export type QueryLatestBuddyScoreArgs = {
  buddyId: Scalars['ID'];
};


export type QueryLatestPersonalityTestScoreArgs = {
  filter?: InputMaybe<PersonalityTestFilter>;
};


export type QueryLatestScoreArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryListUsersArgs = {
  filter?: InputMaybe<ListUsersFilter>;
};


export type QueryMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type QueryModuleArgs = {
  moduleId: Scalars['ID'];
};


export type QueryModuleScheduleArgs = {
  moduleScheduleId: Scalars['ID'];
};


export type QueryModuleSchedulesArgs = {
  filter?: InputMaybe<ModuleSchedulesFilter>;
};


export type QueryModulesArgs = {
  filter?: InputMaybe<ModulesFilter>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryMoodAndScoreOfPatientArgs = {
  filter: UserScoreAndMoodFilter;
};


export type QueryMoodResponseArgs = {
  id: Scalars['ID'];
};


export type QueryMoodResponsesArgs = {
  filter?: InputMaybe<MoodResponseFilter>;
};


export type QueryMoodResponsesOfPatientArgs = {
  filter?: InputMaybe<MoodResponseFilter>;
  patientId: Scalars['ID'];
};


export type QueryMoodStatisticsArgs = {
  filter?: InputMaybe<MoodResponseFilter>;
};


export type QueryMoodStatisticsOfPatientArgs = {
  filter?: InputMaybe<MoodResponseFilter>;
  patientId: Scalars['ID'];
};


export type QueryMoodTipFeedbackArgs = {
  moodTipId: Scalars['String'];
};


export type QueryMoodTipsArgs = {
  filter?: InputMaybe<MoodTipFilter>;
};


export type QueryMoodTipsForUserArgs = {
  filter?: InputMaybe<MoodTipFilter>;
};


export type QueryMoodTipsResponsesArgs = {
  filter?: InputMaybe<MoodTipsResponseFilter>;
};


export type QueryMostUsedMoodContextItemsArgs = {
  filter?: InputMaybe<MostUsedMoodContextLabelsFilter>;
};


export type QueryMostUsedMoodContextLabelsArgs = {
  filter?: InputMaybe<MostUsedMoodContextLabelsFilter>;
};


export type QueryNotePdfUrlArgs = {
  noteId: Scalars['ID'];
};


export type QueryOrganizationBillableCptCodesArgs = {
  filter?: InputMaybe<OrganizationBillableCptCodesFilter>;
};


export type QueryOrganizationCmsFormsArgs = {
  filter?: InputMaybe<OrganizationCmsFormsFilter>;
};


export type QueryOrganizationFormSchedulesArgs = {
  filter?: InputMaybe<OrganizationFormSchedulesFilter>;
};


export type QueryOrganizationFormsArgs = {
  filter?: InputMaybe<OrganizationFormsFilter>;
};


export type QueryOrganizationGroupsArgs = {
  filter?: InputMaybe<OrganizationGroupsFilter>;
};


export type QueryOrganizationInvoicesArgs = {
  filter?: InputMaybe<OrganizationInvoicesFilter>;
};


export type QueryOrganizationMessageArgs = {
  organizationMessageId: Scalars['ID'];
};


export type QueryOrganizationMessageFileUrlArgs = {
  fileName: Scalars['String'];
  organizationMessageId: Scalars['ID'];
  replyId?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationMessagesArgs = {
  filter?: InputMaybe<OrganizationMessageFilter>;
};


export type QueryOrganizationNotesArgs = {
  filter?: InputMaybe<OrganizationNotesFilter>;
};


export type QueryOrganizationNotificationsArgs = {
  filter?: InputMaybe<OrganizationNotificationsFilter>;
};


export type QueryOrganizationSessionsArgs = {
  filter?: InputMaybe<OrganizationSessionsFilter>;
};


export type QueryPatientAppUsageArgs = {
  filter?: InputMaybe<AppUsageFilter>;
  patientId: Scalars['ID'];
};


export type QueryPatientFormsArgs = {
  filter?: InputMaybe<PatientFormsFilter>;
};


export type QueryPatientInsurancesArgs = {
  filter?: InputMaybe<PatientInsuranceFilter>;
  patientId: Scalars['ID'];
};


export type QueryPatientStripeCreditCardsArgs = {
  patientId: Scalars['String'];
};


export type QueryPatientsArgs = {
  filter?: InputMaybe<PatientsFilter>;
};


export type QueryRecommendedActivitiesArgs = {
  filter?: InputMaybe<RecommendedActivitiesFilter>;
};


export type QueryRecommendedHomeworkArgs = {
  transcriptId: Scalars['ID'];
};


export type QueryResponsesArgs = {
  filter?: InputMaybe<ResponseFilter>;
};


export type QueryResponsesBySurveyTypeArgs = {
  surveyType: SurveyTypes;
};


export type QueryScoresArgs = {
  filter?: InputMaybe<ScoreFilter>;
};


export type QueryScoresOfPatientArgs = {
  filter?: InputMaybe<ScoreFilter>;
  patientId: Scalars['ID'];
};


export type QuerySearchDefaultTemplatesArgs = {
  filter?: InputMaybe<TemplatesFilter>;
  term: Scalars['String'];
};


export type QuerySearchOrganizationTemplatesArgs = {
  filter?: InputMaybe<TemplatesFilter>;
  term: Scalars['String'];
};


export type QuerySelfCarePlanOfPatientArgs = {
  patientId: Scalars['ID'];
};


export type QuerySentMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type QuerySessionArgs = {
  sessionId: Scalars['ID'];
};


export type QuerySessionsArgs = {
  filter?: InputMaybe<SessionFilter>;
};


export type QuerySleepDataArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QuerySortedHelpfulActivitiesArgs = {
  filter?: InputMaybe<SortedActivitiesFilter>;
};


export type QuerySortedHelpfulActivitiesForUserArgs = {
  filter?: InputMaybe<SortedActivitiesFilter>;
};


export type QuerySuperbillArgs = {
  month: Scalars['Int'];
  patientId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QuerySuperbillPdfUrlArgs = {
  month: Scalars['Int'];
  patientId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QuerySurveyArgs = {
  type: SurveyTypes;
};


export type QueryTemplateArgs = {
  slug?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['ID']>;
};


export type QueryTemplateChatLogArgs = {
  templateId: Scalars['ID'];
};


export type QueryTemplatesArgs = {
  filter?: InputMaybe<TemplatesFilter>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryTranscriptArgs = {
  transcriptId: Scalars['ID'];
};


export type QueryTranscriptsArgs = {
  filter?: InputMaybe<TranscriptFilter>;
};


export type QueryUserGroupArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type Question = {
  __typename?: 'Question';
  id?: Maybe<Scalars['String']>;
  optionGroup?: Maybe<OptionGroup>;
  slug?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  translation?: Maybe<SurveyTranslation>;
  type?: Maybe<QuestionType>;
};

export type QuestionOrder = {
  __typename?: 'QuestionOrder';
  id: Scalars['String'];
  jumpTo?: Maybe<Scalars['Int']>;
  neededScore?: Maybe<NeededScore>;
  question: Question;
  sequenceNumber: Scalars['Int'];
  shouldCalculate?: Maybe<Scalars['Boolean']>;
};

export enum QuestionType {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export type Quote = {
  __typename?: 'Quote';
  id?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  text: Scalars['String'];
  timeOfDay?: Maybe<QuoteTimeOfDay>;
  translation?: Maybe<QuoteTranslation>;
};

export enum QuoteTimeOfDay {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING',
  Night = 'NIGHT'
}

export type QuoteTranslation = {
  __typename?: 'QuoteTranslation';
  ar?: Maybe<QuoteTranslationItem>;
  en?: Maybe<QuoteTranslationItem>;
  uk?: Maybe<QuoteTranslationItem>;
};

export type QuoteTranslationItem = {
  __typename?: 'QuoteTranslationItem';
  text?: Maybe<Scalars['String']>;
};

export enum ReactType {
  Wave = 'WAVE'
}

export type ReadBy = {
  __typename?: 'ReadBy';
  user: User;
};

export type RecommendedActivitiesFilter = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type RecommendedActivity = {
  __typename?: 'RecommendedActivity';
  module?: Maybe<Module>;
  template?: Maybe<Template>;
};

export enum RelationToInsured {
  Child = 'CHILD',
  Other = 'OTHER',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export enum Repeat {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY'
}

export type Reply = {
  __typename?: 'Reply';
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  files?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  readBy: Array<Maybe<ReadBy>>;
  sender: User;
  updatedAt: Scalars['Date'];
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  email: Scalars['String'];
};

export type Response = {
  __typename?: 'Response';
  answers?: Maybe<Array<Maybe<Answer>>>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  survey: Survey;
  user: User;
};

export type ResponseFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  surveyTypes?: InputMaybe<Array<InputMaybe<SurveyTypes>>>;
};

export type ResponseScores = {
  __typename?: 'ResponseScores';
  anxiety?: Maybe<AnxietyScores>;
  depression?: Maybe<DepressionScores>;
  stress?: Maybe<StressScores>;
  wellbeingIndex?: Maybe<Scalars['Float']>;
};

export enum Roles {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR'
}

export enum Routes {
  StressRoute = 'STRESS_ROUTE'
}

export type RoutesState = {
  __typename?: 'RoutesState';
  completeTime?: Maybe<Scalars['Date']>;
  slug?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Date']>;
};

export type Score = {
  __typename?: 'Score';
  anxiety?: Maybe<AnxietyScores>;
  createdAt: Scalars['Date'];
  depression?: Maybe<DepressionScores>;
  emotionalStability?: Maybe<EmotionalStabilityScores>;
  id: Scalars['String'];
  selfEsteem?: Maybe<SelfEsteemScores>;
  stress?: Maybe<StressScores>;
  surveyResponse?: Maybe<Response>;
  triggeredBy?: Maybe<ScoreTriggers>;
  user: User;
  wellbeingIndex?: Maybe<Scalars['Float']>;
  wellbeingIndexDelta?: Maybe<Scalars['Float']>;
};

export type ScoreFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  triggeredBy?: InputMaybe<ScoreTriggers>;
};

export enum ScoreTriggers {
  EmotionalStability = 'EMOTIONAL_STABILITY',
  Mood = 'MOOD',
  SelfEsteem = 'SELF_ESTEEM',
  Survey = 'SURVEY'
}

export type SelfCarePlan = {
  __typename?: 'SelfCarePlan';
  createdAt: Scalars['Date'];
  diagnosis?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<SelfCarePlanGoal>>>;
  id: Scalars['ID'];
  patient: User;
  steps: Array<Maybe<SelfCarePlanStep>>;
  updatedAt: Scalars['Date'];
};

export type SelfCarePlanGoal = {
  __typename?: 'SelfCarePlanGoal';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SelfCarePlanGoalInput = {
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SelfCarePlanStep = {
  __typename?: 'SelfCarePlanStep';
  actionPlanDescription?: Maybe<Scalars['String']>;
  actionPlanTitle?: Maybe<Scalars['String']>;
  appTools?: Maybe<Array<Maybe<AppTool>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SelfCarePlanStepInput = {
  actionPlanDescription?: InputMaybe<Scalars['String']>;
  actionPlanTitle?: InputMaybe<Scalars['String']>;
  appTools?: InputMaybe<Array<InputMaybe<AppToolInput>>>;
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SelfEsteemScores = {
  __typename?: 'SelfEsteemScores';
  level?: Maybe<PersonalityTestLevels>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

export type SentMessage = {
  __typename?: 'SentMessage';
  createdAt: Scalars['Date'];
  customMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  messageType: MessageType;
  react?: Maybe<ReactType>;
  read?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
};

export enum Sentiments {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type ServicePlace = {
  __typename?: 'ServicePlace';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type ServiceType = {
  __typename?: 'ServiceType';
  cptCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAddOn?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type Session = {
  __typename?: 'Session';
  acceptanceStates?: Maybe<Scalars['AcceptanceStates']>;
  breakoutRoom?: Maybe<Scalars['String']>;
  cmsForms?: Maybe<Array<Maybe<CmsForm>>>;
  confirmed?: Maybe<Scalars['Boolean']>;
  cptCode?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  hasVideo?: Maybe<Scalars['Boolean']>;
  hosts?: Maybe<Array<Maybe<User>>>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  notes?: Maybe<Scalars['String']>;
  organization: Organization;
  patients?: Maybe<Array<Maybe<User>>>;
  reason?: Maybe<Scalars['String']>;
  selectedGroup?: Maybe<Group>;
  serviceCharge?: Maybe<Scalars['Float']>;
  servicePlace?: Maybe<ServicePlace>;
  serviceType?: Maybe<ServiceType>;
  services?: Maybe<Array<Maybe<SessionService>>>;
  sessionType: SessionType;
  startDate: Scalars['Date'];
  status: SessionStatus;
  title: Scalars['String'];
  transcripts?: Maybe<Scalars['String']>;
};

export type SessionFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  status?: InputMaybe<SessionStatus>;
};

export type SessionService = {
  __typename?: 'SessionService';
  cptCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  modifiers?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
};

export type SessionServiceInput = {
  cptCode?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['Float']>;
  modifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export enum SessionStatus {
  Canceled = 'CANCELED',
  LateCanceled = 'LATE_CANCELED',
  NoShowUp = 'NO_SHOW_UP',
  On = 'ON'
}

export enum SessionType {
  Couple = 'COUPLE',
  Group = 'GROUP',
  OneToOne = 'ONE_TO_ONE',
  Webinar = 'WEBINAR'
}

export enum SharedData {
  Emotions = 'EMOTIONS',
  SadScores = 'SAD_SCORES'
}

export type Signature = {
  __typename?: 'Signature';
  credentials?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  ipAddress: Scalars['String'];
  licenceNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum SignupPurposes {
  ImproveMyMentalWellBeing = 'IMPROVE_MY_MENTAL_WELL_BEING',
  LearnWhatInfluencesMyFeelings = 'LEARN_WHAT_INFLUENCES_MY_FEELINGS',
  Other = 'OTHER',
  TrackChangesInMyFeelings = 'TRACK_CHANGES_IN_MY_FEELINGS',
  UnderstandHowIFeel = 'UNDERSTAND_HOW_I_FEEL'
}

export type SleepData = {
  __typename?: 'SleepData';
  endTimeNanos?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  startTimeNanos?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Int']>;
};

export enum Sort {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortedActivitiesFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
};

export type SortedActivitiesResponse = {
  __typename?: 'SortedActivitiesResponse';
  _id: Scalars['String'];
  count: Scalars['Int'];
};

export type StepData = {
  __typename?: 'StepData';
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
  value?: Maybe<Scalars['Int']>;
};

export type StepDataInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type StressScores = {
  __typename?: 'StressScores';
  level?: Maybe<Levels>;
  percentage?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

export type StripeBankAccount = {
  __typename?: 'StripeBankAccount';
  accountHolderName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  currentDeadLine?: Maybe<Scalars['Date']>;
  currentlyDue?: Maybe<Array<Maybe<Scalars['String']>>>;
  last4?: Maybe<Scalars['String']>;
  pastDue?: Maybe<Array<Maybe<Scalars['String']>>>;
  routingNumber?: Maybe<Scalars['String']>;
};

export enum StripeBusinessType {
  Company = 'company',
  Individual = 'individual'
}

export type StripeCreditCard = {
  __typename?: 'StripeCreditCard';
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export enum StripeRefundReason {
  Duplicate = 'duplicate',
  Fraudulent = 'fraudulent',
  RequestedByCustomer = 'requested_by_customer'
}

export type Subscription = {
  __typename?: 'Subscription';
  expirationDate: Scalars['Date'];
  orderId: Scalars['String'];
  originalOrderId?: Maybe<Scalars['String']>;
  originalPurchaseTime?: Maybe<Scalars['Date']>;
  packageName?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  productId: Scalars['String'];
  purchaseTime: Scalars['Date'];
  purchaseToken?: Maybe<Scalars['String']>;
  transactionReceipt?: Maybe<Scalars['String']>;
  user: User;
};

export enum SubscriptionPlan {
  FreePlan = 'FREE_PLAN',
  FreeTrial = 'FREE_TRIAL',
  OneTimePayment = 'ONE_TIME_PAYMENT',
  PaidTrial = 'PAID_TRIAL',
  Premium = 'PREMIUM',
  Standard = 'STANDARD',
  Team = 'TEAM'
}

export type Superbill = {
  __typename?: 'Superbill';
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  id: Scalars['ID'];
  month?: Maybe<Scalars['Int']>;
  organization: Organization;
  patient: User;
  state: SuperbillState;
  year?: Maybe<Scalars['Int']>;
};

export enum SuperbillState {
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type Survey = {
  __typename?: 'Survey';
  id: Scalars['String'];
  questions: Array<Maybe<QuestionOrder>>;
  type: Scalars['String'];
};

export type SurveyTranslation = {
  __typename?: 'SurveyTranslation';
  ar?: Maybe<SurveyTranslationItem>;
  en?: Maybe<SurveyTranslationItem>;
  uk?: Maybe<SurveyTranslationItem>;
};

export type SurveyTranslationItem = {
  __typename?: 'SurveyTranslationItem';
  highlightedText?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum SurveyTypes {
  DynamicPss10Gad7Phq8 = 'DYNAMIC_PSS10_GAD7_PHQ8',
  EmotionalStability = 'EMOTIONAL_STABILITY',
  LonelinessScale = 'LONELINESS_SCALE',
  Pss4 = 'PSS4',
  Pss10 = 'PSS10',
  Pss10Gad7Phq8 = 'PSS10_GAD7_PHQ8',
  Pss10Gad7Phq9 = 'PSS10_GAD7_PHQ9',
  Pss10PlusPhq4 = 'PSS10_PLUS_PHQ4',
  Pss14 = 'PSS14',
  SelfEsteem = 'SELF_ESTEEM',
  SpottingStress = 'SPOTTING_STRESS'
}

export type Task = {
  __typename?: 'Task';
  createdAt?: Maybe<Scalars['Date']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['ID']>;
  organization?: Maybe<Organization>;
  taskType?: Maybe<TaskTypes>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum TaskTypes {
  WellbeingSurvey = 'WELLBEING_SURVEY'
}

export enum TaxFederationIdType {
  Ein = 'EIN',
  Ssn = 'SSN'
}

export type Template = {
  __typename?: 'Template';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  default: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  scorable?: Maybe<Scalars['Boolean']>;
  scoresDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  type?: Maybe<TemplateType>;
  updatedAt: Scalars['Date'];
};

export enum TemplateType {
  Assessment = 'ASSESSMENT',
  Intake = 'INTAKE',
  Technique = 'TECHNIQUE',
  TreatmentPlan = 'TREATMENT_PLAN',
  Worksheet = 'WORKSHEET'
}

export type TemplatesFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<TemplateType>;
};

export type TemplatesResult = {
  __typename?: 'TemplatesResult';
  data?: Maybe<Array<Maybe<Template>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  createdAt: Scalars['Date'];
  customPrompt?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  noteType?: Maybe<TranscriptNoteType>;
  organization: Organization;
  patients?: Maybe<Array<User>>;
  sessionDate?: Maybe<Scalars['Date']>;
  sessionType?: Maybe<TranscriptSessionType>;
  source?: Maybe<TranscriptSource>;
  status?: Maybe<TranscriptStatus>;
  summary?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transcriptionDuration?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
};

export type TranscriptDefaultSettings = {
  __typename?: 'TranscriptDefaultSettings';
  customPrompt?: Maybe<Scalars['String']>;
  noteType?: Maybe<TranscriptNoteType>;
};

export type TranscriptDefaultSettingsInput = {
  customPrompt?: InputMaybe<Scalars['String']>;
  noteType?: InputMaybe<TranscriptNoteType>;
};

export type TranscriptFilter = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<Sort>;
};

export enum TranscriptNoteType {
  Birp = 'BIRP',
  Dap = 'DAP',
  Intake = 'INTAKE',
  Sirp = 'SIRP',
  Soap = 'SOAP'
}

export enum TranscriptSessionType {
  InPerson = 'IN_PERSON',
  Telehealth = 'TELEHEALTH'
}

export enum TranscriptSource {
  AudioFile = 'AUDIO_FILE',
  Live = 'LIVE',
  TextFile = 'TEXT_FILE'
}

export enum TranscriptStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Processing = 'Processing',
  Started = 'Started'
}

export type UpdateResult = {
  __typename?: 'UpdateResult';
  matchedCount?: Maybe<Scalars['Int']>;
  modifiedCount?: Maybe<Scalars['Int']>;
};

export enum Usefulness {
  BetterThanBefore = 'BETTER_THAN_BEFORE',
  SameAsBefore = 'SAME_AS_BEFORE',
  WorseThanBefore = 'WORSE_THAN_BEFORE'
}

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']>;
  activitiesState?: Maybe<Array<Maybe<ActivitiesState>>>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  ageRange?: Maybe<AgeRanges>;
  apnTokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  appleUserId?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  avatarUrl?: Maybe<Scalars['String']>;
  billingType?: Maybe<BillingType>;
  buddies?: Maybe<Array<Maybe<Buddy>>>;
  city?: Maybe<Scalars['String']>;
  completedTasks?: Maybe<Array<Maybe<CompletedTask>>>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  currentMonthAppUsage?: Maybe<Array<Maybe<AppUsage>>>;
  customIcons?: Maybe<Array<Maybe<CustomIcon>>>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  defaultSignature?: Maybe<DefaultSignature>;
  diagnoses?: Maybe<Array<Maybe<UserDiagnoses>>>;
  doctorRole?: Maybe<Scalars['String']>;
  doctorTitle?: Maybe<Scalars['String']>;
  education?: Maybe<Educations>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  emailVerifyCode?: Maybe<Scalars['Int']>;
  emailVerifyLocked?: Maybe<Scalars['Boolean']>;
  emailVerifyToken?: Maybe<Scalars['String']>;
  employmentType?: Maybe<EmploymentTypes>;
  ethnicOrigin?: Maybe<EthnicOrigins>;
  eu?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Array<Maybe<Features>>>;
  firstName?: Maybe<Scalars['String']>;
  gUserId?: Maybe<Scalars['String']>;
  gender?: Maybe<Genders>;
  generalNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  group?: Maybe<Group>;
  healthInsurance?: Maybe<HealthInsurance>;
  healthInsuranceNumber?: Maybe<Scalars['String']>;
  healthInsuranceProvider?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insurances?: Maybe<Array<Maybe<Insurance>>>;
  invitationSendDate?: Maybe<Scalars['Date']>;
  isNotificationOnboarded?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isTestUser?: Maybe<Scalars['Boolean']>;
  lastCompletedSession?: Maybe<Session>;
  lastName?: Maybe<Scalars['String']>;
  latestAppUsage?: Maybe<AppUsage>;
  latestSuperbill?: Maybe<LatestSuperbillForPatient>;
  licenceExpiryDate?: Maybe<Scalars['Date']>;
  licenceNumber?: Maybe<Scalars['String']>;
  licenceState?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  loginHistory?: Maybe<Array<Maybe<LoginHistoryItem>>>;
  loginToken?: Maybe<Scalars['String']>;
  moodContextCategoriesOrder?: Maybe<Array<Maybe<MoodContextCategoryOrderItem>>>;
  npi?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryDoctor?: Maybe<User>;
  pronoun?: Maybe<Pronouns>;
  receiveAutomaticInvoice?: Maybe<Scalars['Boolean']>;
  receiveAutomaticSuperbill?: Maybe<Scalars['Boolean']>;
  receiveReminders?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Maybe<Roles>>>;
  routesState?: Maybe<Array<Maybe<RoutesState>>>;
  sadScores?: Maybe<LatestScore>;
  secondaryEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  selfCarePlan?: Maybe<SelfCarePlan>;
  sharedData?: Maybe<Array<Maybe<SharedData>>>;
  signupPurposes?: Maybe<Array<Maybe<SignupPurposes>>>;
  state?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  superbillDisabled?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']>;
  withTemporaryPassword?: Maybe<Scalars['Boolean']>;
  yearOfBirth?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum UserActivityState {
  Completed = 'COMPLETED',
  Started = 'STARTED'
}

export type UserDiagnoses = {
  __typename?: 'UserDiagnoses';
  assignedAt?: Maybe<Scalars['Date']>;
  diagnosis: Diagnosis;
};

export type UserLocationInfo = {
  __typename?: 'UserLocationInfo';
  countryCode?: Maybe<Scalars['String']>;
  eu?: Maybe<Scalars['Boolean']>;
};

export type UserScoreAndMoodFilter = {
  dateTo?: InputMaybe<Scalars['Date']>;
  userId: Scalars['ID'];
};

export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  token: Scalars['String'];
  user: User;
};

export type VerifyPhoneNumberPayload = {
  __typename?: 'VerifyPhoneNumberPayload';
  token: Scalars['String'];
};

export enum WidgetType {
  Cambridge = 'CAMBRIDGE',
  MoodChange = 'MOOD_CHANGE'
}

export enum ActivityState {
  Completed = 'COMPLETED',
  Locked = 'LOCKED',
  Started = 'STARTED',
  Unlocked = 'UNLOCKED'
}

export type SortedEmotionsByTypeResponse = {
  __typename?: 'sortedEmotionsByTypeResponse';
  negative?: Maybe<Array<Maybe<Emotion>>>;
  positive?: Maybe<Array<Maybe<Emotion>>>;
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: string | null, withTemporaryPassword?: boolean | null, doctorTitle?: string | null, licenceState?: string | null, licenceNumber?: string | null, licenceExpiryDate?: number | null, npi?: string | null, doctorRole?: string | null, gender?: Genders | null, ageRange?: AgeRanges | null, employmentType?: EmploymentTypes | null, firstName?: string | null, lastName?: string | null, timezone?: string | null, isOnboarded?: boolean | null, countryCode?: string | null, eu?: boolean | null, createdAt?: number | null, email?: string | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, features?: Array<Features | null> | null, avatarUrl?: string | null, roles?: Array<Roles | null> | null, receiveAutomaticInvoice?: boolean | null, receiveAutomaticSuperbill?: boolean | null, receiveReminders?: boolean | null, twoFactorEnabled?: boolean | null, organization?: { __typename?: 'Organization', id: string, name: string, timezone: string, email?: string | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, taxId?: string | null, npi?: string | null, logo?: string | null, stripeAccountId?: string | null, stripeStatementDescriptor?: string | null, subscriptionPlan?: SubscriptionPlan | null, freeTrialEndDate?: number | null, subscriptionEndDate?: number | null, receiveHighSurveyNotification?: boolean | null, receiveHighPhq9Notification?: boolean | null, receiveHighSurveyEmail?: boolean | null, receiveHighPhq9Email?: boolean | null, owner: { __typename?: 'User', id?: string | null, email?: string | null }, currentPeriodTranscriptionLimits?: { __typename?: 'CurrentPeriodLimits', count?: number | null, limit?: number | null } | null, currentPeriodFormLimits?: { __typename?: 'CurrentPeriodLimits', count?: number | null, limit?: number | null } | null, transcriptDefaultSettings?: { __typename?: 'TranscriptDefaultSettings', noteType?: TranscriptNoteType | null, customPrompt?: string | null } | null } | null, buddies?: Array<{ __typename?: 'Buddy', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, moodOfToday?: number | null } | null> | null, customIcons?: Array<{ __typename?: 'CustomIcon', itemId: string, iconName: string } | null> | null, defaultSignature?: { __typename?: 'DefaultSignature', name: string, credentials?: string | null, licenceNumber?: string | null } | null } | null };

export type AccountLoginHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountLoginHistoryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: string | null, loginHistory?: Array<{ __typename?: 'LoginHistoryItem', loginSource?: LoginSource | null, date?: number | null } | null> | null } | null };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, timezone: string, email?: string | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, taxId?: string | null, npi?: string | null, logo?: string | null, stripeAccountId?: string | null, stripeStatementDescriptor?: string | null, subscriptionPlan?: SubscriptionPlan | null, freeTrialEndDate?: number | null, subscriptionEndDate?: number | null, receiveHighSurveyNotification?: boolean | null, receiveHighPhq9Notification?: boolean | null, receiveHighSurveyEmail?: boolean | null, receiveHighPhq9Email?: boolean | null, currentPeriodTranscriptionCount?: number | null, owner: { __typename?: 'User', id?: string | null, email?: string | null } } | null } | null };

export type LoginUserWithPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  loginSource?: InputMaybe<LoginSource>;
}>;


export type LoginUserWithPasswordMutation = { __typename?: 'Mutation', loginUserWithPassword: { __typename?: 'JwtToken', token: string, is2FAEnabled?: boolean | null } };

export type LoginUserWithGoogleMutationVariables = Exact<{
  authCode: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  loginSource?: InputMaybe<LoginSource>;
}>;


export type LoginUserWithGoogleMutation = { __typename?: 'Mutation', loginUserWithGoogle: { __typename?: 'JwtToken', token: string, isFirstRegistration?: boolean | null } };

export type RegisterUserByEmailMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  loginSource?: InputMaybe<LoginSource>;
}>;


export type RegisterUserByEmailMutation = { __typename?: 'Mutation', registerUserByEmail: { __typename?: 'VerifyEmailPayload', token: string } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
  code: Scalars['Int'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'JwtToken', token: string } };

export type ResendEmailVerificationCodeMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ResendEmailVerificationCodeMutation = { __typename?: 'Mutation', resendEmailVerificationCode: { __typename?: 'User', emailVerifyCode?: number | null } };

export type ListUsersQueryVariables = Exact<{
  filter?: InputMaybe<ListUsersFilter>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: number | null, features?: Array<Features | null> | null } | null> | null };

export type AddFeatureMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  feature?: InputMaybe<Features>;
}>;


export type AddFeatureMutation = { __typename?: 'Mutation', addFeature?: { __typename?: 'User', id?: string | null } | null };

export type DiaryEntriesForBuddyQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type DiaryEntriesForBuddyQuery = { __typename?: 'Query', diaryEntriesForBuddy?: { __typename?: 'DiaryEntriesAggregatesResult', total?: number | null, data?: Array<{ __typename?: 'DiaryEntriesAggregates', diaryEntries?: Array<{ __typename?: 'DiaryEntry', answer?: string | null, question?: string | null, type?: JournalTypes | null, createdAt?: number | null, diaryEntryType?: DiaryEntryType | null, userId?: string | null, selectedMood?: number | null, date?: number | null, description?: string | null, diaryEntryDate?: number | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, emotions?: Array<{ __typename?: 'Emotion', text?: string | null } | null> | null, scores?: { __typename?: 'Score', wellbeingIndex?: number | null, stress?: { __typename?: 'StressScores', percentage?: number | null } | null, anxiety?: { __typename?: 'AnxietyScores', percentage?: number | null } | null, depression?: { __typename?: 'DepressionScores', percentage?: number | null } | null } | null, moodContextLabels?: Array<{ __typename?: 'MoodContextLabel', label: string } | null> | null, moodContextItems?: Array<{ __typename?: 'MoodContextItem', iconName: string, name: string } | null> | null } | null> | null } | null> | null } | null };

export type DoctorsQueryVariables = Exact<{
  filter?: InputMaybe<DoctorsFilter>;
}>;


export type DoctorsQuery = { __typename?: 'Query', doctors?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null> | null };

export type CreateGroupMutationVariables = Exact<{
  type?: InputMaybe<GroupType>;
  name?: InputMaybe<Scalars['String']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, patients?: Array<{ __typename?: 'User', id?: string | null } | null> | null } };

export type OrganizationGroupsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationGroupsFilter>;
}>;


export type OrganizationGroupsQuery = { __typename?: 'Query', organizationGroups?: Array<{ __typename?: 'Group', color?: string | null, description?: string | null, id: string, type?: GroupType | null, name?: string | null, objective?: string | null, topic?: string | null, inactive?: boolean | null, createdAt?: number | null, updatedAt?: number | null, mentors?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null> | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, gender?: Genders | null, yearOfBirth?: number | null, group?: { __typename?: 'Group', id: string, name?: string | null, color?: string | null } | null, sadScores?: { __typename?: 'LatestScore', wellbeingIndex?: number | null, stress?: { __typename?: 'StressScores', level?: Levels | null, percentage?: number | null } | null, anxiety?: { __typename?: 'AnxietyScores', level?: Levels | null, percentage?: number | null } | null, depression?: { __typename?: 'DepressionScores', level?: Levels | null, percentage?: number | null } | null } | null, lastCompletedSession?: { __typename?: 'Session', startDate: number, duration?: number | null, title: string, id: string } | null } | null> | null } | null> | null };

export type UpdateGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
  inactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: string, name?: string | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } };

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup?: boolean | null };

export type PatientsQueryVariables = Exact<{
  filter?: InputMaybe<PatientsFilter>;
}>;


export type PatientsQuery = { __typename?: 'Query', patients?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, invitationSendDate?: number | null, secondaryEmails?: Array<string | null> | null, active?: boolean | null, receiveReminders?: boolean | null, isTestUser?: boolean | null, createdAt?: number | null, archived?: boolean | null, primaryDoctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type OrganizationInvitationMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationInvitationMutation = { __typename?: 'Mutation', organizationInvitation: { __typename?: 'OrganizationInvitation', code: string, id: string, organization: { __typename?: 'Organization', id: string, name: string } } };

export type ServicePlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicePlacesQuery = { __typename?: 'Query', servicePlaces?: Array<{ __typename?: 'ServicePlace', id: string, code: string, description: string } | null> | null };

export type ServiceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceTypesQuery = { __typename?: 'Query', serviceTypes?: Array<{ __typename?: 'ServiceType', id: string, name?: string | null, cptCode?: string | null, isAddOn?: boolean | null } | null> | null };

export type CreateSessionMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  title: Scalars['String'];
  startDate: Scalars['Date'];
  sessionType: SessionType;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  hosts?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  hasVideo?: InputMaybe<Scalars['Boolean']>;
  servicePlace?: InputMaybe<Scalars['ID']>;
  services?: InputMaybe<Array<InputMaybe<SessionServiceInput>> | InputMaybe<SessionServiceInput>>;
  status?: InputMaybe<SessionStatus>;
  selectedGroup?: InputMaybe<Scalars['ID']>;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'Session', id: string, title: string } | null };

export type UpdateSessionMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SessionStatus>;
  sessionType?: InputMaybe<SessionType>;
  startDate?: InputMaybe<Scalars['Date']>;
  patients?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  hosts?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  hasVideo?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  servicePlace?: InputMaybe<Scalars['ID']>;
  services?: InputMaybe<Array<InputMaybe<SessionServiceInput>> | InputMaybe<SessionServiceInput>>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  selectedGroup?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession?: { __typename?: 'Session', id: string } | null };

export type DeleteSessionMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type DeleteSessionMutation = { __typename?: 'Mutation', deleteSession?: boolean | null };

export type OrganizationSessionsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationSessionsFilter>;
}>;


export type OrganizationSessionsQuery = { __typename?: 'Query', organizationSessions?: Array<{ __typename?: 'Session', id: string, status: SessionStatus, breakoutRoom?: string | null, description?: string | null, duration?: number | null, sessionType: SessionType, hasVideo?: boolean | null, startDate: number, title: string, notes?: string | null, transcripts?: string | null, confirmed?: boolean | null, acceptanceStates?: { [key: string]: AcceptanceState } | null, deleted?: boolean | null, hosts?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, licenceNumber?: string | null, npi?: string | null } | null> | null, organization: { __typename?: 'Organization', id: string, name: string }, patients?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, gender?: Genders | null, pronoun?: Pronouns | null, dateOfBirth?: number | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, superbillDisabled?: boolean | null, isTestUser?: boolean | null } | null> | null, servicePlace?: { __typename?: 'ServicePlace', id: string, code: string, description: string } | null, services?: Array<{ __typename?: 'SessionService', cptCode?: string | null, name?: string | null, fee?: number | null, modifiers?: Array<string | null> | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, amount?: number | null, state: InvoiceState, createdAt: number, updatedAt: number, invoiceNumber: number, paymentDate?: number | null, paymentMethod?: PaymentMethod | null, stripePaymentId?: string | null, stripePaymentStatus?: string | null, stripeProcessingFee?: number | null, refundDate?: number | null, refundMethod?: PaymentMethod | null, stripeRefundStatus?: string | null, stripeRefundId?: string | null, organization: { __typename?: 'Organization', id: string }, patient: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | null> | null, selectedGroup?: { __typename?: 'Group', id: string } | null, cmsForms?: Array<{ __typename?: 'CMSForm', id: string, state: CmsFormState, patient: { __typename?: 'User', id?: string | null } } | null> | null } | null> | null };

export type SessionQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type SessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, status: SessionStatus, breakoutRoom?: string | null, description?: string | null, duration?: number | null, sessionType: SessionType, hasVideo?: boolean | null, startDate: number, title: string, notes?: string | null, transcripts?: string | null, confirmed?: boolean | null, acceptanceStates?: { [key: string]: AcceptanceState } | null, deleted?: boolean | null, hosts?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, licenceNumber?: string | null, npi?: string | null } | null> | null, organization: { __typename?: 'Organization', id: string, name: string }, patients?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, gender?: Genders | null, pronoun?: Pronouns | null, dateOfBirth?: number | null, phoneNumber?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, superbillDisabled?: boolean | null, isTestUser?: boolean | null } | null> | null, servicePlace?: { __typename?: 'ServicePlace', id: string, code: string, description: string } | null, services?: Array<{ __typename?: 'SessionService', cptCode?: string | null, name?: string | null, fee?: number | null, modifiers?: Array<string | null> | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, amount?: number | null, state: InvoiceState, createdAt: number, updatedAt: number, invoiceNumber: number, paymentDate?: number | null, paymentMethod?: PaymentMethod | null, stripePaymentId?: string | null, stripePaymentStatus?: string | null, stripeProcessingFee?: number | null, refundDate?: number | null, refundMethod?: PaymentMethod | null, stripeRefundStatus?: string | null, stripeRefundId?: string | null, organization: { __typename?: 'Organization', id: string }, patient: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | null> | null, selectedGroup?: { __typename?: 'Group', id: string } | null, cmsForms?: Array<{ __typename?: 'CMSForm', id: string, state: CmsFormState, patient: { __typename?: 'User', id?: string | null } } | null> | null } | null };

export type PatientSessionsQueryVariables = Exact<{
  filter?: InputMaybe<SessionFilter>;
}>;


export type PatientSessionsQuery = { __typename?: 'Query', sessions?: Array<{ __typename?: 'Session', breakoutRoom?: string | null, description?: string | null, duration?: number | null, sessionType: SessionType, id: string, startDate: number, status: SessionStatus, title: string, acceptanceStates?: { [key: string]: AcceptanceState } | null, organization: { __typename?: 'Organization', name: string }, hosts?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, doctorTitle?: string | null } | null> | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null> | null } | null> | null };

export type PatientSessionQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type PatientSessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', breakoutRoom?: string | null, description?: string | null, duration?: number | null, sessionType: SessionType, id: string, startDate: number, status: SessionStatus, title: string, acceptanceStates?: { [key: string]: AcceptanceState } | null, organization: { __typename?: 'Organization', name: string }, hosts?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, doctorTitle?: string | null } | null> | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null> | null } | null };

export type GetAccessTokenForSessionMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type GetAccessTokenForSessionMutation = { __typename?: 'Mutation', getAccessTokenForSession: { __typename?: 'AccessTokenResponse', accessToken: string } };

export type AddPatientsToGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  patients: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type AddPatientsToGroupMutation = { __typename?: 'Mutation', addPatientsToGroup: { __typename?: 'Group', id: string, color?: string | null, description?: string | null, name?: string | null, objective?: string | null, patients?: Array<{ __typename?: 'User', id?: string | null } | null> | null } };

export type RemovePatientsFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  patients: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type RemovePatientsFromGroupMutation = { __typename?: 'Mutation', removePatientsFromGroup: { __typename?: 'Group', color?: string | null, description?: string | null, id: string, name?: string | null, mentors?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null } | null> | null } };

export type MoodAndScoreOfPatientQueryVariables = Exact<{
  filter: UserScoreAndMoodFilter;
}>;


export type MoodAndScoreOfPatientQuery = { __typename?: 'Query', moodAndScoreOfPatient?: { __typename?: 'MoodAndScoreOfPatientResponse', mood?: { __typename?: 'MoodResponse', id: string, date: number, selectedMood?: number | null } | null, score?: { __typename?: 'Score', anxiety?: { __typename?: 'AnxietyScores', level?: Levels | null, percentage?: number | null, score?: number | null } | null, depression?: { __typename?: 'DepressionScores', level?: Levels | null, percentage?: number | null, score?: number | null } | null, stress?: { __typename?: 'StressScores', level?: Levels | null, percentage?: number | null, score?: number | null } | null } | null } | null };

export type DiagnosesQueryVariables = Exact<{ [key: string]: never; }>;


export type DiagnosesQuery = { __typename?: 'Query', diagnoses?: Array<{ __typename?: 'Diagnosis', code: string, description: string, id: string } | null> | null };

export type ApplyDiagnosisToPatientMutationVariables = Exact<{
  userId: Scalars['ID'];
  diagnosisId: Scalars['ID'];
  assignedAt: Scalars['Date'];
}>;


export type ApplyDiagnosisToPatientMutation = { __typename?: 'Mutation', applyDiagnosisToPatient?: { __typename?: 'User', id?: string | null } | null };

export type RemoveDiagnosisFromPatientMutationVariables = Exact<{
  userId: Scalars['ID'];
  diagnosisId: Scalars['ID'];
}>;


export type RemoveDiagnosisFromPatientMutation = { __typename?: 'Mutation', removeDiagnosisFromPatient?: { __typename?: 'User', id?: string | null } | null };

export type AggregateSessionsByMonthQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type AggregateSessionsByMonthQuery = { __typename?: 'Query', aggregateSessionsByMonth?: Array<{ __typename?: 'AggregateSession', hasUnconfirmedSessions?: boolean | null, month?: number | null, year?: number | null } | null> | null };

export type HasUnconfirmedSessionsQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
  patientId: Scalars['ID'];
}>;


export type HasUnconfirmedSessionsQuery = { __typename?: 'Query', hasUnconfirmedSessions?: boolean | null };

export type SuperbillQueryVariables = Exact<{
  patientId: Scalars['ID'];
  month: Scalars['Int'];
  year: Scalars['Int'];
}>;


export type SuperbillQuery = { __typename?: 'Query', superbill?: { __typename?: 'Superbill', id: string, dateFrom: number, dateTo: number, state: SuperbillState } | null };

export type SuperbillPdfUrlQueryVariables = Exact<{
  patientId: Scalars['ID'];
  month: Scalars['Int'];
  year: Scalars['Int'];
}>;


export type SuperbillPdfUrlQuery = { __typename?: 'Query', superbillPdfUrl?: string | null };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  primaryDoctorId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, avatarUrl?: string | null } | null };

export type UpdatePatientProfileMutationVariables = Exact<{
  patientId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Genders>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  preferredName?: InputMaybe<Scalars['String']>;
  pronoun?: InputMaybe<Pronouns>;
  healthInsurance?: InputMaybe<HealthInsurance>;
  healthInsuranceNumber?: InputMaybe<Scalars['String']>;
  healthInsuranceProvider?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  primaryDoctorId?: InputMaybe<Scalars['ID']>;
  superbillDisabled?: InputMaybe<Scalars['Boolean']>;
  receiveReminders?: InputMaybe<Scalars['Boolean']>;
  receiveAutomaticInvoice?: InputMaybe<Scalars['Boolean']>;
  receiveAutomaticSuperbill?: InputMaybe<Scalars['Boolean']>;
  billingType?: InputMaybe<BillingType>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdatePatientProfileMutation = { __typename?: 'Mutation', updatePatientProfile: { __typename?: 'User', id?: string | null } };

export type SendInvitationMutationVariables = Exact<{
  patientId: Scalars['ID'];
  customEmailMessage?: InputMaybe<Scalars['String']>;
  customSmsMessage?: InputMaybe<Scalars['String']>;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', sendInvitation: boolean };

export type SendDoctorPatientAppInvitationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendDoctorPatientAppInvitationMutation = { __typename?: 'Mutation', sendDoctorPatientAppInvitation: boolean };

export type UpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  licenceState?: InputMaybe<Scalars['String']>;
  licenceNumber?: InputMaybe<Scalars['String']>;
  licenceExpiryDate?: InputMaybe<Scalars['Date']>;
  npi?: InputMaybe<Scalars['String']>;
  doctorRole?: InputMaybe<Scalars['String']>;
  doctorTitle?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  defaultSignature?: InputMaybe<DefaultSignatureInput>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', id?: string | null } };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String'];
  timezone: Scalars['String'];
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isPaidTrial?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string } };

export type UploadAvatarMutationVariables = Exact<{
  base64: Scalars['String'];
}>;


export type UploadAvatarMutation = { __typename?: 'Mutation', uploadAvatar: { __typename?: 'User', id?: string | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  stripeStatementDescriptor?: InputMaybe<Scalars['String']>;
  receiveHighSurveyNotification?: InputMaybe<Scalars['Boolean']>;
  receiveHighPhq9Notification?: InputMaybe<Scalars['Boolean']>;
  receiveHighSurveyEmail?: InputMaybe<Scalars['Boolean']>;
  receiveHighPhq9Email?: InputMaybe<Scalars['Boolean']>;
  transcriptDefaultSettings?: InputMaybe<TranscriptDefaultSettingsInput>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string } };

export type UpdateOrganizationLogoMutationVariables = Exact<{
  base64?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganizationLogoMutation = { __typename?: 'Mutation', updateOrganizationLogo: { __typename?: 'Organization', id: string } };

export type ChangeUserPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
}>;


export type ChangeUserPasswordMutation = { __typename?: 'Mutation', changeUserPassword: { __typename?: 'User', id?: string | null } };

export type ChangeTemporaryPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
}>;


export type ChangeTemporaryPasswordMutation = { __typename?: 'Mutation', changeTemporaryPassword: boolean };

export type AdminSetTemporaryPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  temporaryPassword: Scalars['String'];
}>;


export type AdminSetTemporaryPasswordMutation = { __typename?: 'Mutation', adminSetTemporaryPassword: { __typename?: 'User', id?: string | null } };

export type MoodResponsesOfPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<MoodResponseFilter>;
}>;


export type MoodResponsesOfPatientQuery = { __typename?: 'Query', moodResponsesOfPatient?: Array<{ __typename?: 'MoodResponse', id: string, description?: string | null, userId: string, selectedMood?: number | null, date: number, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null }, emotions?: Array<{ __typename?: 'Emotion', id?: string | null, slug?: string | null, text?: string | null, moods?: Array<number | null> | null, descriptionReplaceText?: string | null, type?: EmotionType | null, translation?: { __typename?: 'EmotionTranslation', en?: { __typename?: 'EmotionTranslationItem', text?: string | null, description?: string | null } | null } | null } | null> | null, moodContextItems?: Array<{ __typename?: 'MoodContextItem', id: string, name: string, iconName: string, predefined?: boolean | null, moderated: boolean, translation?: { __typename?: 'MoodContextItemTranslation', en?: { __typename?: 'MoodContextTranslationItem', name?: string | null } | null } | null } | null> | null, moodContextLabels?: Array<{ __typename?: 'MoodContextLabel', slug: string, label: string, iconName?: string | null, translation?: { __typename?: 'MoodContextLabelTranslation', en?: { __typename?: 'MoodContextLabelTranslationItem', label?: string | null } | null } | null } | null> | null } | null> | null };

export type LatestScoreQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type LatestScoreQuery = { __typename?: 'Query', latestScore?: { __typename?: 'LatestScore', wellbeingIndex?: number | null, wellbeingIndexDelta?: number | null, lastSurveyTime?: number | null, lastCheckInTime?: number | null, createdAt: number, stress?: { __typename?: 'StressScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null, anxiety?: { __typename?: 'AnxietyScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null, depression?: { __typename?: 'DepressionScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null, highlightedText?: { __typename?: 'HighlightedTextResponse', anxiety?: Array<{ __typename?: 'HighlightedTextTranslation', en?: { __typename?: 'HighlightedTextTranslationItem', highlightedText?: string | null } | null } | null> | null, depression?: Array<{ __typename?: 'HighlightedTextTranslation', en?: { __typename?: 'HighlightedTextTranslationItem', highlightedText?: string | null } | null } | null> | null, stress?: Array<{ __typename?: 'HighlightedTextTranslation', en?: { __typename?: 'HighlightedTextTranslationItem', highlightedText?: string | null } | null } | null> | null } | null, surveyResponse?: { __typename?: 'Response', createdAt?: number | null, survey: { __typename?: 'Survey', type: string, questions: Array<{ __typename?: 'QuestionOrder', question: { __typename?: 'Question', slug?: string | null, subTitle?: string | null, text?: string | null, optionGroup?: { __typename?: 'OptionGroup', options: Array<{ __typename?: 'OptionOrderedGroup', option: { __typename?: 'Option', slug?: string | null, text?: string | null } } | null> } | null } } | null> }, answers?: Array<{ __typename?: 'Answer', question: { __typename?: 'Question', slug?: string | null }, option?: { __typename?: 'Option', slug?: string | null } | null } | null> | null } | null } | null };

export type ScoresOfPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<ScoreFilter>;
}>;


export type ScoresOfPatientQuery = { __typename?: 'Query', scoresOfPatient?: Array<{ __typename?: 'Score', wellbeingIndex?: number | null, wellbeingIndexDelta?: number | null, triggeredBy?: ScoreTriggers | null, createdAt: number, stress?: { __typename?: 'StressScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null, anxiety?: { __typename?: 'AnxietyScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null, depression?: { __typename?: 'DepressionScores', score?: number | null, percentage?: number | null, level?: Levels | null } | null } | null> | null };

export type MutationMutationVariables = Exact<{
  email: Scalars['String'];
  temporaryPassword: Scalars['String'];
}>;


export type MutationMutation = { __typename?: 'Mutation', adminSetTemporaryPassword: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } };

export type AggregateMoodByDayOfPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<AggregateMoodByDayFilter>;
}>;


export type AggregateMoodByDayOfPatientQuery = { __typename?: 'Query', aggregateMoodByDayOfPatient?: Array<{ __typename?: 'DailyMoodAggregate', year: number, month: number, day: number, averageSelectedMood: number, checkinCount: number } | null> | null };

export type MoodStatisticsOfPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<MoodResponseFilter>;
}>;


export type MoodStatisticsOfPatientQuery = { __typename?: 'Query', moodStatisticsOfPatient?: { __typename?: 'MoodStatisticsResponse', averageSelectedMood?: number | null, mostSelectedEmotions?: { __typename?: 'MostSelectedEmotions', count?: number | null, emotions?: Array<{ __typename?: 'Emotion', id?: string | null, text?: string | null } | null> | null } | null } | null };

export type OrganizationInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationInvoicesFilter>;
}>;


export type OrganizationInvoicesQuery = { __typename?: 'Query', organizationInvoices?: Array<{ __typename?: 'Invoice', id: string, paymentDate?: number | null, paymentMethod?: PaymentMethod | null, stripePaymentId?: string | null, stripePaymentStatus?: string | null, stripeProcessingFee?: number | null, refundDate?: number | null, refundMethod?: PaymentMethod | null, stripeRefundStatus?: string | null, stripeRefundId?: string | null, invoiceNumber: number, updatedAt: number, createdAt: number, state: InvoiceState, amount?: number | null, organization: { __typename?: 'Organization', id: string }, patient: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, receiveAutomaticInvoice?: boolean | null } } | null> | null };

export type InvoicePdfUrlQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type InvoicePdfUrlQuery = { __typename?: 'Query', invoicePdfUrl?: string | null };

export type PayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  paymentMethod: PaymentMethod;
  paymentDate?: InputMaybe<Scalars['Date']>;
}>;


export type PayInvoiceMutation = { __typename?: 'Mutation', payInvoice?: { __typename?: 'Invoice', id: string } | null };

export type DeleteInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice?: boolean | null };

export type RefundInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  refundDate?: InputMaybe<Scalars['Date']>;
  refundMethod: PaymentMethod;
}>;


export type RefundInvoiceMutation = { __typename?: 'Mutation', refundInvoice?: { __typename?: 'Invoice', id: string } | null };

export type CreateInvoiceMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice?: { __typename?: 'Invoice', id: string } | null };

export type AdminCreateDoctorMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  temporaryPassword: Scalars['String'];
}>;


export type AdminCreateDoctorMutation = { __typename?: 'Mutation', adminCreateDoctor: { __typename?: 'User', id?: string | null } };

export type SetupOrganizationStripeAccountMutationVariables = Exact<{
  urlPath?: InputMaybe<Scalars['String']>;
}>;


export type SetupOrganizationStripeAccountMutation = { __typename?: 'Mutation', setupOrganizationStripeAccount?: string | null };

export type OrganizationStripeAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationStripeAccountQuery = { __typename?: 'Query', organizationStripeAccount?: { __typename?: 'StripeBankAccount', pastDue?: Array<string | null> | null, currentlyDue?: Array<string | null> | null, currentDeadLine?: number | null, accountHolderName?: string | null, bankName?: string | null, routingNumber?: string | null, last4?: string | null } | null };

export type AddPatientStripeCreditCardMutationVariables = Exact<{
  stripeTokenId: Scalars['String'];
  patientId: Scalars['String'];
}>;


export type AddPatientStripeCreditCardMutation = { __typename?: 'Mutation', addPatientStripeCreditCard: boolean };

export type PatientStripeCreditCardsQueryVariables = Exact<{
  patientId: Scalars['String'];
}>;


export type PatientStripeCreditCardsQuery = { __typename?: 'Query', patientStripeCreditCards?: Array<{ __typename?: 'StripeCreditCard', id?: string | null, brand?: string | null, expMonth?: string | null, expYear?: string | null, last4?: string | null } | null> | null };

export type UpdatePatientStripeCreditCardMutationVariables = Exact<{
  patientId: Scalars['String'];
  cardId: Scalars['String'];
  expYear?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePatientStripeCreditCardMutation = { __typename?: 'Mutation', updatePatientStripeCreditCard: boolean };

export type DeletePatientStripeCreditCardMutationVariables = Exact<{
  patientId: Scalars['String'];
  cardId: Scalars['String'];
}>;


export type DeletePatientStripeCreditCardMutation = { __typename?: 'Mutation', deletePatientStripeCreditCard: boolean };

export type PayInvoiceOnlineMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  cardId: Scalars['String'];
}>;


export type PayInvoiceOnlineMutation = { __typename?: 'Mutation', payInvoiceOnline?: { __typename?: 'Invoice', id: string } | null };

export type RefundInvoiceOnlineMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  refundReason?: InputMaybe<StripeRefundReason>;
}>;


export type RefundInvoiceOnlineMutation = { __typename?: 'Mutation', refundInvoiceOnline?: { __typename?: 'Invoice', id: string } | null };

export type CreateCmsFormMutationVariables = Exact<{
  sessionIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  patientId: Scalars['ID'];
  data: CmsFormDataInput;
}>;


export type CreateCmsFormMutation = { __typename?: 'Mutation', createCMSForm: { __typename?: 'CMSForm', id: string } };

export type UpdateCmsFormMutationVariables = Exact<{
  cmsFormId: Scalars['ID'];
  data: CmsFormDataInput;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type UpdateCmsFormMutation = { __typename?: 'Mutation', updateCMSForm: { __typename?: 'CMSForm', id: string } };

export type UpdateCmsFormStateMutationVariables = Exact<{
  cmsFormId: Scalars['ID'];
  state: CmsFormState;
}>;


export type UpdateCmsFormStateMutation = { __typename?: 'Mutation', updateCMSFormState: { __typename?: 'CMSForm', id: string } };

export type DeleteCmsFormMutationVariables = Exact<{
  cmsFormId: Scalars['ID'];
}>;


export type DeleteCmsFormMutation = { __typename?: 'Mutation', deleteCMSForm?: boolean | null };

export type OrganizationCmsFormsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationCmsFormsFilter>;
}>;


export type OrganizationCmsFormsQuery = { __typename?: 'Query', organizationCMSForms?: Array<{ __typename?: 'CMSForm', id: string, state: CmsFormState, updatedAt: number, createdAt: number, patient: { __typename?: 'User', lastName?: string | null, firstName?: string | null }, sessions?: Array<{ __typename?: 'Session', startDate: number } | null> | null, data: { __typename?: 'CMSFormData', insuranceName?: string | null, insuranceAddress1?: string | null, insuranceAddress2?: string | null, insuranceCity?: string | null, insuranceState?: string | null, insuranceZipCode?: string | null, insuranceMemberId?: string | null, insuranceType?: CmsFormInsuranceType | null, patientName?: string | null, patientDateOfBirth?: number | null, patientGender?: Genders | null, patientAddress?: string | null, patientCity?: string | null, patientState?: string | null, patientZipCode?: string | null, patientPhoneNumber?: string | null, patientRelationToInsured?: RelationToInsured | null, patientAccountNumber?: string | null, insuredName?: string | null, insuredAddress?: string | null, insuredCity?: string | null, insuredState?: string | null, insuredZipCode?: string | null, insuredPhoneNumber?: string | null, insuredPolicyGroup?: string | null, insuredDateOfBirth?: number | null, insuredGender?: Genders | null, insuredInsuranceName?: string | null, isOtherInsuranceAvailable?: boolean | null, otherInsuredName?: string | null, otherInsuredMemberId?: string | null, otherInsuredInsuranceName?: string | null, isEmploymentRelated?: boolean | null, isAutoAccident?: boolean | null, autoAccidentState?: string | null, isOtherAccident?: boolean | null, claimCodes?: string | null, isWithInsuredSignatureOnFile?: boolean | null, dateOfCurrentIllness?: number | null, currentIllnessId?: string | null, otherDate?: number | null, unableToWorkDateFrom?: number | null, unableToWorkDateTo?: number | null, referringProviderId?: string | null, referringProviderName?: string | null, referringProviderSecondaryIdType?: string | null, referringProviderSecondaryId?: string | null, referringProviderNpi?: string | null, hospitalizationDateFrom?: number | null, hospitalizationDateTo?: number | null, additionalClaimInformation?: string | null, isOutsideLab?: boolean | null, outsideLabCharges?: number | null, icdInd?: string | null, diagnoses?: Array<string | null> | null, resubmissionCode?: number | null, originalRefNum?: string | null, authorizationNumber?: string | null, taxFederationId?: string | null, taxFederationIdType?: TaxFederationIdType | null, assignmentAccepted?: boolean | null, amountPaid?: number | null, signatureDate?: number | null, facilityName?: string | null, facilityAddress1?: string | null, facilityAddress2?: string | null, facilityCity?: string | null, facilityState?: string | null, facilityZipCode?: string | null, facilityNpi?: string | null, providerName?: string | null, providerAddress1?: string | null, providerAddress2?: string | null, providerCity?: string | null, providerState?: string | null, providerZipCode?: string | null, providerPhoneNumber?: string | null, providerNpi?: string | null, providerTaxonomyCode?: string | null, createdAt?: number | null, services?: Array<{ __typename?: 'CMSFormService', dateFrom?: number | null, dateTo?: number | null, placeOfService?: string | null, isEmergency?: boolean | null, cptCode?: string | null, modifier1?: string | null, modifier2?: string | null, modifier3?: string | null, modifier4?: string | null, diagnosis?: string | null, charges?: number | null, units?: string | null, epsdt?: string | null, provider?: string | null } | null> | null } } | null> | null };

export type CmsFormHistoryQueryVariables = Exact<{
  cmsFormId: Scalars['ID'];
  filter?: InputMaybe<CmsFormHistoryFilter>;
}>;


export type CmsFormHistoryQuery = { __typename?: 'Query', cmsFormHistory?: Array<{ __typename?: 'CMSFormHistory', id: string, cmsFormId: string, state: CmsFormState, createdAt: number, updatedAt: number, data: { __typename?: 'CMSFormData', insuranceName?: string | null, insuranceAddress1?: string | null, insuranceAddress2?: string | null, insuranceCity?: string | null, insuranceState?: string | null, insuranceZipCode?: string | null, insuranceMemberId?: string | null, insuranceType?: CmsFormInsuranceType | null, patientName?: string | null, patientDateOfBirth?: number | null, patientGender?: Genders | null, patientAddress?: string | null, patientCity?: string | null, patientState?: string | null, patientZipCode?: string | null, patientPhoneNumber?: string | null, patientRelationToInsured?: RelationToInsured | null, patientAccountNumber?: string | null, insuredName?: string | null, insuredAddress?: string | null, insuredCity?: string | null, insuredState?: string | null, insuredZipCode?: string | null, insuredPhoneNumber?: string | null, insuredPolicyGroup?: string | null, insuredDateOfBirth?: number | null, insuredGender?: Genders | null, insuredInsuranceName?: string | null, isOtherInsuranceAvailable?: boolean | null, otherInsuredName?: string | null, otherInsuredMemberId?: string | null, otherInsuredInsuranceName?: string | null, isEmploymentRelated?: boolean | null, isAutoAccident?: boolean | null, autoAccidentState?: string | null, isOtherAccident?: boolean | null, claimCodes?: string | null, isWithInsuredSignatureOnFile?: boolean | null, dateOfCurrentIllness?: number | null, currentIllnessId?: string | null, otherDate?: number | null, unableToWorkDateFrom?: number | null, unableToWorkDateTo?: number | null, referringProviderId?: string | null, referringProviderName?: string | null, referringProviderSecondaryIdType?: string | null, referringProviderSecondaryId?: string | null, referringProviderNpi?: string | null, hospitalizationDateFrom?: number | null, hospitalizationDateTo?: number | null, additionalClaimInformation?: string | null, isOutsideLab?: boolean | null, outsideLabCharges?: number | null, icdInd?: string | null, diagnoses?: Array<string | null> | null, resubmissionCode?: number | null, originalRefNum?: string | null, authorizationNumber?: string | null, taxFederationId?: string | null, taxFederationIdType?: TaxFederationIdType | null, assignmentAccepted?: boolean | null, amountPaid?: number | null, signatureDate?: number | null, facilityName?: string | null, facilityAddress1?: string | null, facilityAddress2?: string | null, facilityCity?: string | null, facilityState?: string | null, facilityZipCode?: string | null, facilityNpi?: string | null, providerName?: string | null, providerAddress1?: string | null, providerAddress2?: string | null, providerCity?: string | null, providerState?: string | null, providerZipCode?: string | null, providerPhoneNumber?: string | null, providerNpi?: string | null, providerTaxonomyCode?: string | null, createdAt?: number | null, services?: Array<{ __typename?: 'CMSFormService', dateFrom?: number | null, dateTo?: number | null, placeOfService?: string | null, isEmergency?: boolean | null, cptCode?: string | null, modifier1?: string | null, modifier2?: string | null, modifier3?: string | null, modifier4?: string | null, diagnosis?: string | null, charges?: number | null, units?: string | null, epsdt?: string | null, provider?: string | null } | null> | null } } | null> | null };

export type CreateOrUpdatePatientInsuranceMutationVariables = Exact<{
  insuranceId?: InputMaybe<Scalars['ID']>;
  patientId?: InputMaybe<Scalars['ID']>;
  data: InsuranceDataInput;
}>;


export type CreateOrUpdatePatientInsuranceMutation = { __typename?: 'Mutation', createOrUpdatePatientInsurance?: { __typename?: 'Insurance', id: string } | null };

export type UpdatePatientInsuranceImageMutationVariables = Exact<{
  insuranceId: Scalars['ID'];
  base64: Scalars['String'];
  side: ImageSide;
}>;


export type UpdatePatientInsuranceImageMutation = { __typename?: 'Mutation', updatePatientInsuranceImage?: { __typename?: 'Insurance', id: string, insuranceFrontImage?: string | null, insuranceBackImage?: string | null } | null };

export type DeletePatientInsuranceMutationVariables = Exact<{
  insuranceId: Scalars['ID'];
}>;


export type DeletePatientInsuranceMutation = { __typename?: 'Mutation', deletePatientInsurance?: boolean | null };

export type PatientInsurancesQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<PatientInsuranceFilter>;
}>;


export type PatientInsurancesQuery = { __typename?: 'Query', patientInsurances?: Array<{ __typename?: 'Insurance', id: string, patientRelationToInsured: RelationToInsured, insuranceType: InsuranceType, insurancePayerId?: string | null, insuranceName?: string | null, insuranceAddress1?: string | null, insuranceAddress2?: string | null, insuranceCity?: string | null, insuranceState?: string | null, insuranceZipCode?: string | null, insuredFirstName?: string | null, insuredLastName?: string | null, insuredMiddleName?: string | null, insuredAddress1?: string | null, insuredAddress2?: string | null, insuredCity?: string | null, insuredState?: string | null, insuredZipCode?: string | null, insuredPhoneNumber?: string | null, insuredDateOfBirth?: number | null, insuredGender?: Genders | null, policyMemberId?: string | null, policyGroupId?: string | null, policyPlanId?: string | null, policyCopay?: number | null, policyDeductible?: number | null, policyMaximumAmount?: number | null, signatureOnFile?: boolean | null, acceptAssignment?: boolean | null, inactive?: boolean | null, createdAt: number, updatedAt: number, insuranceFrontImage?: string | null, insuranceBackImage?: string | null, patient: { __typename?: 'User', id?: string | null } } | null> | null };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead?: number | null };

export type OrganizationNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationNotificationsFilter>;
}>;


export type OrganizationNotificationsQuery = { __typename?: 'Query', organizationNotifications?: Array<{ __typename?: 'Notification', id: string, isRead: boolean, type: NotificationType, updatedAt: number, createdAt: number, senderUser?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null, data?: { __typename?: 'NotificationData', stressLevel?: Levels | null, anxietyLevel?: Levels | null, depressionLevel?: Levels | null, surveyType?: SurveyTypes | null, optionSlug?: string | null, form?: { __typename?: 'Form', id: string, type?: TemplateType | null, title?: string | null } | null } | null } | null> | null };

export type RequestToContactUmoreTeamMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestToContactUmoreTeamMutation = { __typename?: 'Mutation', requestToContactUmoreTeam?: boolean | null };

export type DeleteTestUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type DeleteTestUserMutation = { __typename?: 'Mutation', deleteTestUser: { __typename?: 'User', id?: string | null } };

export type Generate2FaQrCodeUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type Generate2FaQrCodeUrlMutation = { __typename?: 'Mutation', generate2FAQrCodeUrl: { __typename?: 'Generate2FAQrCodeUrlResult', otpAuthUrl: string, twoFactorSecret: string } };

export type Enable2FaMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type Enable2FaMutation = { __typename?: 'Mutation', enable2FA?: boolean | null };

export type Verify2FaCodeAndLoginMutationVariables = Exact<{
  token: Scalars['String'];
  code: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
}>;


export type Verify2FaCodeAndLoginMutation = { __typename?: 'Mutation', verify2FACodeAndLogin: { __typename?: 'JwtToken', token: string } };

export type CreateOrganizationServiceMutationVariables = Exact<{
  cptCode: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Int']>;
  isAddOn?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateOrganizationServiceMutation = { __typename?: 'Mutation', createOrganizationService: { __typename?: 'OrganizationService', id: string, cptCode: string, name?: string | null, fee?: number | null, duration?: number | null, isAddOn?: boolean | null, isDefault?: boolean | null, createdAt?: number | null, updatedAt?: number | null } };

export type UpdateOrganizationServiceMutationVariables = Exact<{
  organizationServiceId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Int']>;
  isAddOn?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateOrganizationServiceMutation = { __typename?: 'Mutation', updateOrganizationService: { __typename?: 'OrganizationService', id: string, cptCode: string, name?: string | null, fee?: number | null, duration?: number | null, isAddOn?: boolean | null, isDefault?: boolean | null, createdAt?: number | null, updatedAt?: number | null, organization: { __typename?: 'Organization', id: string } } };

export type DeleteOrganizationServiceMutationVariables = Exact<{
  organizationServiceId: Scalars['ID'];
}>;


export type DeleteOrganizationServiceMutation = { __typename?: 'Mutation', deleteOrganizationService?: boolean | null };

export type OrganizationServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationServicesQuery = { __typename?: 'Query', organizationServices?: Array<{ __typename?: 'OrganizationService', id: string, cptCode: string, name?: string | null, fee?: number | null, duration?: number | null, isAddOn?: boolean | null, isDefault?: boolean | null } | null> | null };

export type CreateNoteMutationVariables = Exact<{
  type: NoteType;
  text: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', id: string } };

export type UpdateNoteMutationVariables = Exact<{
  noteId: Scalars['ID'];
  type?: InputMaybe<NoteType>;
  text?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Note', id: string } };

export type DeleteNoteMutationVariables = Exact<{
  noteId: Scalars['ID'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'Note', id: string, deleted: boolean } };

export type SignNoteMutationVariables = Exact<{
  noteId: Scalars['ID'];
}>;


export type SignNoteMutation = { __typename?: 'Mutation', signNote: { __typename?: 'Note', id: string } };

export type AddAddendumAndSignMutationVariables = Exact<{
  noteId: Scalars['ID'];
  addendumText: Scalars['String'];
  deleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddAddendumAndSignMutation = { __typename?: 'Mutation', addAddendumAndSign: { __typename?: 'Note', id: string } };

export type OrganizationNotesQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationNotesFilter>;
}>;


export type OrganizationNotesQuery = { __typename?: 'Query', organizationNotes?: Array<{ __typename?: 'Note', id: string, type: NoteType, date: number, text?: string | null, deleted: boolean, session?: { __typename?: 'Session', id: string, startDate: number, duration?: number | null } | null, patient?: { __typename?: 'User', id?: string | null } | null, signature?: { __typename?: 'Signature', name: string, credentials?: string | null, licenceNumber?: string | null, date: number, ipAddress: string } | null, addendums?: Array<{ __typename?: 'Addendum', text: string, signature: { __typename?: 'Signature', name: string, credentials?: string | null, licenceNumber?: string | null, date: number, ipAddress: string } } | null> | null } | null> | null };

export type NotePdfUrlQueryVariables = Exact<{
  noteId: Scalars['ID'];
}>;


export type NotePdfUrlQuery = { __typename?: 'Query', notePdfUrl?: string | null };

export type CreateDeferredDeepLinkMutationVariables = Exact<{
  key: Scalars['String'];
  value: Scalars['String'];
}>;


export type CreateDeferredDeepLinkMutation = { __typename?: 'Mutation', createDeferredDeepLink: { __typename?: 'DeferredDeepLink', id: string } };

export type OrganizationBillableCptCodesQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationBillableCptCodesFilter>;
}>;


export type OrganizationBillableCptCodesQuery = { __typename?: 'Query', organizationBillableCptCodes?: Array<{ __typename?: 'BillableCptCode', id: string, cptCode: string, description: string, estimatedAmount: number, isBilled: boolean, createdAt: number, updatedAt: number, patient: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | null> | null };

export type UpdateBillableCptCodeStateMutationVariables = Exact<{
  billableCptCodeId: Scalars['ID'];
  isBilled: Scalars['Boolean'];
}>;


export type UpdateBillableCptCodeStateMutation = { __typename?: 'Mutation', updateBillableCptCodeState?: { __typename?: 'BillableCptCode', id: string } | null };

export type PatientAppUsageQueryVariables = Exact<{
  patientId: Scalars['ID'];
  filter?: InputMaybe<AppUsageFilter>;
}>;


export type PatientAppUsageQuery = { __typename?: 'Query', patientAppUsage?: Array<{ __typename?: 'AppUsage', date: number, action: EventType, activitySlug?: string | null, journalType?: JournalTypes | null } | null> | null };

export type OrganizationMessagesQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationMessageFilter>;
}>;


export type OrganizationMessagesQuery = { __typename?: 'Query', organizationMessages?: Array<{ __typename?: 'OrganizationMessage', id: string, subject?: string | null, content: string, files?: Array<string | null> | null, updatedAt: number, createdAt: number, readBy: Array<{ __typename?: 'ReadBy', user: { __typename?: 'User', id?: string | null } } | null>, recipients: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null>, owner: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }, replies?: Array<{ __typename?: 'Reply', id: string, content: string, files?: Array<string | null> | null, createdAt: number, updatedAt: number, readBy: Array<{ __typename?: 'ReadBy', user: { __typename?: 'User', id?: string | null } } | null>, sender: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | null> | null } | null> | null };

export type CreateOrganizationMessageMutationVariables = Exact<{
  content: Scalars['String'];
  recipients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
}>;


export type CreateOrganizationMessageMutation = { __typename?: 'Mutation', createOrganizationMessage: { __typename?: 'OrganizationMessage', id: string } };

export type OrganizationMessageQueryVariables = Exact<{
  organizationMessageId: Scalars['ID'];
}>;


export type OrganizationMessageQuery = { __typename?: 'Query', organizationMessage?: { __typename?: 'OrganizationMessage', id: string, subject?: string | null, content: string, files?: Array<string | null> | null, updatedAt: number, createdAt: number, readBy: Array<{ __typename?: 'ReadBy', user: { __typename?: 'User', id?: string | null } } | null>, recipients: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null>, owner: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }, replies?: Array<{ __typename?: 'Reply', id: string, content: string, files?: Array<string | null> | null, createdAt: number, updatedAt: number, readBy: Array<{ __typename?: 'ReadBy', user: { __typename?: 'User', id?: string | null } } | null>, sender: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | null> | null } | null };

export type CreateOrganizationMessageReplyMutationVariables = Exact<{
  organizationMessageId: Scalars['ID'];
  content: Scalars['String'];
}>;


export type CreateOrganizationMessageReplyMutation = { __typename?: 'Mutation', createOrganizationMessageReply: { __typename?: 'OrganizationMessage', id: string, replies?: Array<{ __typename?: 'Reply', id: string } | null> | null } };

export type MarkOrganizationMessageAsReadMutationVariables = Exact<{
  organizationMessageId: Scalars['ID'];
}>;


export type MarkOrganizationMessageAsReadMutation = { __typename?: 'Mutation', markOrganizationMessageAsRead: { __typename?: 'OrganizationMessage', id: string } };

export type GenerateOrganizationMessageFileUploadUrlMutationVariables = Exact<{
  organizationMessageId: Scalars['ID'];
  fileName: Scalars['String'];
  contentType: Scalars['String'];
  replyId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateOrganizationMessageFileUploadUrlMutation = { __typename?: 'Mutation', generateOrganizationMessageFileUploadUrl: string };

export type UpdateOrganizationMessageFilesMutationVariables = Exact<{
  organizationMessageId: Scalars['ID'];
  fileName: Scalars['String'];
  replyId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganizationMessageFilesMutation = { __typename?: 'Mutation', updateOrganizationMessageFiles: { __typename?: 'OrganizationMessage', id: string } };

export type OrganizationMessageFileUrlQueryVariables = Exact<{
  organizationMessageId: Scalars['ID'];
  fileName: Scalars['String'];
  replyId?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationMessageFileUrlQuery = { __typename?: 'Query', organizationMessageFileUrl: string };

export type CreateSelfCarePlanMutationVariables = Exact<{
  patientId: Scalars['ID'];
  steps: Array<SelfCarePlanStepInput> | SelfCarePlanStepInput;
  diagnosis?: InputMaybe<Scalars['String']>;
  goals?: InputMaybe<Array<SelfCarePlanGoalInput> | SelfCarePlanGoalInput>;
}>;


export type CreateSelfCarePlanMutation = { __typename?: 'Mutation', createSelfCarePlan: { __typename?: 'SelfCarePlan', id: string, createdAt: number, updatedAt: number, diagnosis?: string | null, patient: { __typename?: 'User', id?: string | null }, goals?: Array<{ __typename?: 'SelfCarePlanGoal', id: string, title: string, description?: string | null } | null> | null, steps: Array<{ __typename?: 'SelfCarePlanStep', id: string, title: string, description?: string | null, actionPlanTitle?: string | null, actionPlanDescription?: string | null, appTools?: Array<{ __typename?: 'AppTool', id: string, slug: string, completed: boolean, isActive: boolean } | null> | null } | null> } };

export type SelfCarePlanOfPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type SelfCarePlanOfPatientQuery = { __typename?: 'Query', selfCarePlanOfPatient?: { __typename?: 'SelfCarePlan', id: string, createdAt: number, updatedAt: number, diagnosis?: string | null, patient: { __typename?: 'User', id?: string | null }, goals?: Array<{ __typename?: 'SelfCarePlanGoal', id: string, title: string, description?: string | null } | null> | null, steps: Array<{ __typename?: 'SelfCarePlanStep', id: string, title: string, description?: string | null, actionPlanTitle?: string | null, actionPlanDescription?: string | null, appTools?: Array<{ __typename?: 'AppTool', id: string, slug: string, completed: boolean, isActive: boolean } | null> | null } | null> } | null };

export type UpdateSelfCarePlanMutationVariables = Exact<{
  selfCarePlanId: Scalars['ID'];
  steps?: InputMaybe<Array<SelfCarePlanStepInput> | SelfCarePlanStepInput>;
  diagnosis?: InputMaybe<Scalars['String']>;
  goals?: InputMaybe<Array<SelfCarePlanGoalInput> | SelfCarePlanGoalInput>;
}>;


export type UpdateSelfCarePlanMutation = { __typename?: 'Mutation', updateSelfCarePlan: { __typename?: 'SelfCarePlan', id: string, createdAt: number, updatedAt: number, diagnosis?: string | null, patient: { __typename?: 'User', id?: string | null }, goals?: Array<{ __typename?: 'SelfCarePlanGoal', id: string, title: string, description?: string | null } | null> | null, steps: Array<{ __typename?: 'SelfCarePlanStep', id: string, title: string, description?: string | null, actionPlanTitle?: string | null, actionPlanDescription?: string | null, appTools?: Array<{ __typename?: 'AppTool', id: string, slug: string, completed: boolean, isActive: boolean } | null> | null } | null> } };

export type GenerateFormDataMutationVariables = Exact<{
  input: Scalars['String'];
  attachments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  type?: InputMaybe<TemplateType>;
}>;


export type GenerateFormDataMutation = { __typename?: 'Mutation', generateFormData: string };

export type UpdateTemplateChatLogMutationVariables = Exact<{
  input: Scalars['String'];
  content: Scalars['String'];
  templateId: Scalars['ID'];
}>;


export type UpdateTemplateChatLogMutation = { __typename?: 'Mutation', updateTemplateChatLog?: { __typename?: 'ChatLog', id: string, messages: Array<{ __typename?: 'ChatLogMessage', role: string, content: string } | null> } | null };

export type GuestUpdateTemplateChatLogMutationVariables = Exact<{
  input: Scalars['String'];
  content: Scalars['String'];
  chatLogId?: InputMaybe<Scalars['ID']>;
}>;


export type GuestUpdateTemplateChatLogMutation = { __typename?: 'Mutation', guestUpdateTemplateChatLog?: { __typename?: 'ChatLog', id: string, messages: Array<{ __typename?: 'ChatLogMessage', role: string, content: string } | null> } | null };

export type TemplateChatLogQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type TemplateChatLogQuery = { __typename?: 'Query', templateChatLog?: { __typename?: 'ChatLog', id: string, messages: Array<{ __typename?: 'ChatLogMessage', role: string, content: string } | null> } | null };

export type GeneratePromptsMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type GeneratePromptsMutation = { __typename?: 'Mutation', generatePrompts: Array<string | null> };

export type CreateFormMutationVariables = Exact<{
  content: Scalars['String'];
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'Form', id: string, content: string, createdAt: number, updatedAt: number } };

export type FormQueryVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type FormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', id: string, content: string, title?: string | null, type?: TemplateType | null, createdAt: number, updatedAt: number, responses?: Array<string | null> | null, responseDates?: Array<number | null> | null, repeatable?: boolean | null, completed?: boolean | null } | null };

export type SendFormToDoctorMutationVariables = Exact<{
  formId: Scalars['ID'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type SendFormToDoctorMutation = { __typename?: 'Mutation', sendFormToDoctor: boolean };

export type JoinWaitingListMutationVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type JoinWaitingListMutation = { __typename?: 'Mutation', joinWaitingList: boolean };

export type SendSegmentEventMutationVariables = Exact<{
  eventName: Scalars['String'];
  properties?: InputMaybe<Scalars['Object']>;
}>;


export type SendSegmentEventMutation = { __typename?: 'Mutation', sendSegmentEvent: boolean };

export type CreateAndSendFormToPatientMutationVariables = Exact<{
  content: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  templateId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
}>;


export type CreateAndSendFormToPatientMutation = { __typename?: 'Mutation', createAndSendFormToPatient: { __typename?: 'Form', id: string } };

export type CreateAndAssignFormToPatientMutationVariables = Exact<{
  content: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  templateId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
}>;


export type CreateAndAssignFormToPatientMutation = { __typename?: 'Mutation', createAndAssignFormToPatient: { __typename?: 'Form', id: string } };

export type SaveFormResponseMutationVariables = Exact<{
  formId: Scalars['ID'];
  response: Scalars['String'];
  completed?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveFormResponseMutation = { __typename?: 'Mutation', saveFormResponse: { __typename?: 'Form', id: string } };

export type OrganizationFormsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFormsFilter>;
}>;


export type OrganizationFormsQuery = { __typename?: 'Query', organizationForms?: Array<{ __typename?: 'Form', id: string, content: string, title?: string | null, type?: TemplateType | null, scorable?: boolean | null, completed?: boolean | null, responses?: Array<string | null> | null, responseDates?: Array<number | null> | null, scores?: { [key: string]: number } | null, sent?: boolean | null, createdAt: number, updatedAt: number, template?: { __typename?: 'Template', id: string, title: string, logo?: string | null, description?: string | null, scoresDescription?: string | null } | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, moduleSchedule?: { __typename?: 'ModuleSchedule', id: string, title?: string | null } | null } | null> | null };

export type PatientFormsQueryVariables = Exact<{
  filter?: InputMaybe<PatientFormsFilter>;
}>;


export type PatientFormsQuery = { __typename?: 'Query', patientForms?: Array<{ __typename?: 'Form', id: string, content: string, title?: string | null, type?: TemplateType | null, scorable?: boolean | null, completed?: boolean | null, responses?: Array<string | null> | null, responseDates?: Array<number | null> | null, scores?: { [key: string]: number } | null, sent?: boolean | null, createdAt: number, updatedAt: number, template?: { __typename?: 'Template', id: string, title: string, logo?: string | null, description?: string | null, scoresDescription?: string | null } | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, moduleSchedule?: { __typename?: 'ModuleSchedule', id: string, title?: string | null } | null } | null> | null };

export type UpdateFormMutationVariables = Exact<{
  formId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
  content?: InputMaybe<Scalars['String']>;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string } };

export type DeleteFormMutationVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm: boolean };

export type GenerateTemplateFileUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  fileExtension?: InputMaybe<Scalars['String']>;
}>;


export type GenerateTemplateFileUploadUrlMutation = { __typename?: 'Mutation', generateTemplateFileUploadUrl: string };

export type AdminFetchOrganizationByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type AdminFetchOrganizationByEmailQuery = { __typename?: 'Query', adminFetchOrganizationByEmail?: Array<{ __typename?: 'Organization', id: string, email?: string | null, name: string } | null> | null };

export type AdminCreateTemplateMutationVariables = Exact<{
  title: Scalars['String'];
  type: TemplateType;
  content: Scalars['String'];
  scorable: Scalars['Boolean'];
  scoresDescription?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type AdminCreateTemplateMutation = { __typename?: 'Mutation', adminCreateTemplate: { __typename?: 'Template', id: string } };

export type AdminUpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
  content?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  scorable?: InputMaybe<Scalars['Boolean']>;
  scoresDescription?: InputMaybe<Scalars['String']>;
}>;


export type AdminUpdateTemplateMutation = { __typename?: 'Mutation', adminUpdateTemplate: { __typename?: 'Template', id: string } };

export type TemplateQueryVariables = Exact<{
  templateId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type TemplateQuery = { __typename?: 'Query', template?: { __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type TemplatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TemplatesFilter>;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates?: { __typename?: 'TemplatesResult', total?: number | null, data?: Array<{ __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type SearchDefaultTemplatesQueryVariables = Exact<{
  term: Scalars['String'];
  filter?: InputMaybe<TemplatesFilter>;
}>;


export type SearchDefaultTemplatesQuery = { __typename?: 'Query', searchDefaultTemplates?: Array<{ __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type SearchOrganizationTemplatesQueryVariables = Exact<{
  term: Scalars['String'];
  filter?: InputMaybe<TemplatesFilter>;
}>;


export type SearchOrganizationTemplatesQuery = { __typename?: 'Query', searchOrganizationTemplates?: Array<{ __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type CreateTemplateMutationVariables = Exact<{
  title: Scalars['String'];
  content: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  logo?: InputMaybe<Scalars['String']>;
  scorable?: InputMaybe<Scalars['Boolean']>;
  scoresDescription?: InputMaybe<Scalars['String']>;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'Template', id: string, content?: string | null, default: boolean, logo?: string | null, title: string, type?: TemplateType | null, description?: string | null, tags?: Array<string | null> | null, scorable?: boolean | null, scoresDescription?: string | null } };

export type GenerateTemplateMutationVariables = Exact<{
  input: Scalars['String'];
  type: TemplateType;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GenerateTemplateMutation = { __typename?: 'Mutation', generateTemplate: { __typename?: 'Template', id: string, content?: string | null, default: boolean, logo?: string | null, title: string, type?: TemplateType | null, description?: string | null, tags?: Array<string | null> | null, scorable?: boolean | null, scoresDescription?: string | null } };

export type UpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  logo?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TemplateType>;
  content?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Template', id: string } };

export type DeleteTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'Template', id: string } };

export type SendResetEmailVerificationCodeMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetEmailVerificationCodeMutation = { __typename?: 'Mutation', sendResetEmailVerificationCode: { __typename?: 'ResetPasswordPayload', email: string } };

export type ValidateVerificationCodeMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['Int'];
}>;


export type ValidateVerificationCodeMutation = { __typename?: 'Mutation', validateVerificationCode: { __typename?: 'ResetPasswordPayload', email: string } };

export type ResetPasswordAndLoginMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['Int'];
  newPassword: Scalars['String'];
}>;


export type ResetPasswordAndLoginMutation = { __typename?: 'Mutation', resetPasswordAndLogin: { __typename?: 'VerifyEmailPayload', token: string } };

export type CreateFormScheduleMutationVariables = Exact<{
  content?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  repeat: Repeat;
  templateId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
}>;


export type CreateFormScheduleMutation = { __typename?: 'Mutation', createFormSchedule: { __typename?: 'FormSchedule', id: string } };

export type DeleteFormScheduleMutationVariables = Exact<{
  formScheduleId: Scalars['ID'];
}>;


export type DeleteFormScheduleMutation = { __typename?: 'Mutation', deleteFormSchedule?: { __typename?: 'FormSchedule', id: string } | null };

export type UpdateFormSchedulePauseStatusMutationVariables = Exact<{
  formScheduleId: Scalars['ID'];
}>;


export type UpdateFormSchedulePauseStatusMutation = { __typename?: 'Mutation', updateFormSchedulePauseStatus: { __typename?: 'FormSchedule', id: string } };

export type UpdateFormScheduleTimeMutationVariables = Exact<{
  formScheduleId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
  repeat?: InputMaybe<Repeat>;
}>;


export type UpdateFormScheduleTimeMutation = { __typename?: 'Mutation', updateFormScheduleTime: { __typename?: 'FormSchedule', id: string, repeat: Repeat, startDate?: number | null } };

export type OrganizationFormSchedulesQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFormSchedulesFilter>;
}>;


export type OrganizationFormSchedulesQuery = { __typename?: 'Query', organizationFormSchedules?: Array<{ __typename?: 'FormSchedule', id: string, startDate?: number | null, repeat: Repeat, nextOccurrence?: number | null, isPaused?: boolean | null, template?: { __typename?: 'Template', title: string, type?: TemplateType | null } | null, patient: { __typename?: 'User', firstName?: string | null, lastName?: string | null }, doctor: { __typename?: 'User', firstName?: string | null, lastName?: string | null } } | null> | null };

export type UpdatePatientArchivedStatusMutationVariables = Exact<{
  patientId: Scalars['ID'];
  archived: Scalars['Boolean'];
}>;


export type UpdatePatientArchivedStatusMutation = { __typename?: 'Mutation', updatePatientArchivedStatus: { __typename?: 'User', id?: string | null, archived?: boolean | null } };

export type ResendFormToPatientMutationVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type ResendFormToPatientMutation = { __typename?: 'Mutation', resendFormToPatient: { __typename?: 'Form', id: string } };

export type SendFormMutationVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type SendFormMutation = { __typename?: 'Mutation', sendForm: { __typename?: 'Form', id: string } };

export type OrganizationHubSpotSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationHubSpotSubscriptionQuery = { __typename?: 'Query', organizationHubSpotSubscription?: { __typename?: 'HubSpotSubscription', nextPaymentDueDate?: number | null, lastPaymentDate?: number | null, subscriptionStatus?: HubSpotSubscriptionStatus | null, updatePaymentMethodLink?: string | null } | null };

export type GenerateModuleMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type GenerateModuleMutation = { __typename?: 'Mutation', generateModule: { __typename?: 'Module', id: string, title?: string | null, description?: string | null, tags?: Array<string> | null, default?: boolean | null, items?: Array<{ __typename?: 'ModuleItem', template?: { __typename?: 'Template', id: string, title: string, description?: string | null, tags?: Array<string | null> | null, content?: string | null } | null }> | null } };

export type CreateModuleMutationVariables = Exact<{
  title: Scalars['String'];
  items: Array<ModuleItemInput> | ModuleItemInput;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', createModule: { __typename?: 'Module', id: string, title?: string | null, description?: string | null, tags?: Array<string> | null, default?: boolean | null, items?: Array<{ __typename?: 'ModuleItem', id?: string | null, template?: { __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, createdAt: number, updatedAt: number, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null }> | null } };

export type DeleteModuleMutationVariables = Exact<{
  moduleId: Scalars['ID'];
}>;


export type DeleteModuleMutation = { __typename?: 'Mutation', deleteModule: boolean };

export type UpdateModuleMutationVariables = Exact<{
  moduleId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  items?: InputMaybe<Array<ModuleItemInput> | ModuleItemInput>;
}>;


export type UpdateModuleMutation = { __typename?: 'Mutation', updateModule: { __typename?: 'Module', id: string } };

export type AssignModuleMutationVariables = Exact<{
  moduleId: Scalars['ID'];
  patientId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
}>;


export type AssignModuleMutation = { __typename?: 'Mutation', assignModule: { __typename?: 'ModuleSchedule', id: string } };

export type ModuleQueryVariables = Exact<{
  moduleId: Scalars['ID'];
}>;


export type ModuleQuery = { __typename?: 'Query', module?: { __typename?: 'Module', id: string, title?: string | null, description?: string | null, tags?: Array<string> | null, default?: boolean | null, items?: Array<{ __typename?: 'ModuleItem', id?: string | null, template?: { __typename?: 'Template', content?: string | null, default: boolean, description?: string | null, id: string, logo?: string | null, scorable?: boolean | null, scoresDescription?: string | null, slug?: string | null, tags?: Array<string | null> | null, title: string, type?: TemplateType | null, createdAt: number, updatedAt: number, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null }> | null } | null };

export type ModulesQueryVariables = Exact<{
  filter?: InputMaybe<ModulesFilter>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
}>;


export type ModulesQuery = { __typename?: 'Query', modules?: Array<{ __typename?: 'Module', id: string, title?: string | null, description?: string | null, tags?: Array<string> | null, default?: boolean | null, doctor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, items?: Array<{ __typename?: 'ModuleItem', id?: string | null }> | null } | null> | null };

export type ModuleScheduleQueryVariables = Exact<{
  moduleScheduleId: Scalars['ID'];
}>;


export type ModuleScheduleQuery = { __typename?: 'Query', moduleSchedule?: { __typename?: 'ModuleSchedule', id: string, title?: string | null, description?: string | null, tags?: Array<string> | null, startDate?: number | null, items?: Array<{ __typename?: 'ModuleScheduleItem', delayTime?: number | null, sendStatus?: ModuleScheduleItemSendStatus | null, status?: ModuleScheduleItemStatus | null, form?: { __typename?: 'Form', id: string, title?: string | null, completed?: boolean | null, responses?: Array<string | null> | null, responseDates?: Array<number | null> | null, content: string, createdAt: number, updatedAt: number } | null, template?: { __typename?: 'Template', id: string, title: string, content?: string | null, createdAt: number, updatedAt: number, default: boolean } | null }> | null, module?: { __typename?: 'Module', title?: string | null, description?: string | null } | null } | null };

export type UpdateTranscriptMutationVariables = Exact<{
  transcriptId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  patients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  summary?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  sessionDate?: InputMaybe<Scalars['Date']>;
  sessionType?: InputMaybe<TranscriptSessionType>;
  noteType?: InputMaybe<TranscriptNoteType>;
  source?: InputMaybe<TranscriptSource>;
  customPrompt?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTranscriptMutation = { __typename?: 'Mutation', updateTranscript?: { __typename?: 'Transcript', id: string } | null };

export type TranscriptQueryVariables = Exact<{
  transcriptId: Scalars['ID'];
}>;


export type TranscriptQuery = { __typename?: 'Query', transcript?: { __typename?: 'Transcript', id: string, createdAt: number, note?: string | null, noteType?: TranscriptNoteType | null, transcriptionDuration?: number | null, sessionType?: TranscriptSessionType | null, status?: TranscriptStatus | null, source?: TranscriptSource | null, sessionDate?: number | null, customPrompt?: string | null, summary?: string | null, text?: string | null, title?: string | null, updatedAt: number, organization: { __typename?: 'Organization', id: string }, doctor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null } | null };

export type TranscriptsQueryVariables = Exact<{
  filter: TranscriptFilter;
}>;


export type TranscriptsQuery = { __typename?: 'Query', transcripts?: Array<{ __typename?: 'Transcript', id: string, createdAt: number, note?: string | null, noteType?: TranscriptNoteType | null, transcriptionDuration?: number | null, sessionType?: TranscriptSessionType | null, source?: TranscriptSource | null, sessionDate?: number | null, status?: TranscriptStatus | null, summary?: string | null, text?: string | null, title?: string | null, updatedAt: number, organization: { __typename?: 'Organization', id: string }, doctor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, patients?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null } | null> | null };

export type DeleteTranscriptMutationVariables = Exact<{
  transcriptId: Scalars['ID'];
}>;


export type DeleteTranscriptMutation = { __typename?: 'Mutation', deleteTranscript?: boolean | null };

export type CompleteTranscriptMutationVariables = Exact<{
  transcriptId: Scalars['ID'];
}>;


export type CompleteTranscriptMutation = { __typename?: 'Mutation', completeTranscript?: { __typename?: 'Transcript', id: string } | null };

export type GenerateRecommendedHomeworkMutationVariables = Exact<{
  transcriptId: Scalars['ID'];
}>;


export type GenerateRecommendedHomeworkMutation = { __typename?: 'Mutation', generateRecommendedHomework?: Array<{ __typename?: 'RecommendedActivity', module?: { __typename?: 'Module', id: string, description?: string | null, title?: string | null, tags?: Array<string> | null, items?: Array<{ __typename?: 'ModuleItem', template?: { __typename?: 'Template', id: string } | null }> | null } | null, template?: { __typename?: 'Template', id: string, title: string, description?: string | null, tags?: Array<string | null> | null, content?: string | null } | null } | null> | null };

export type RecommendedHomeworkQueryVariables = Exact<{
  transcriptId: Scalars['ID'];
}>;


export type RecommendedHomeworkQuery = { __typename?: 'Query', recommendedHomework?: Array<{ __typename?: 'RecommendedActivity', module?: { __typename?: 'Module', id: string, description?: string | null, title?: string | null, tags?: Array<string> | null, items?: Array<{ __typename?: 'ModuleItem', template?: { __typename?: 'Template', id: string, title: string } | null }> | null } | null, template?: { __typename?: 'Template', id: string, title: string, description?: string | null, type?: TemplateType | null, tags?: Array<string | null> | null, logo?: string | null, content?: string | null, default: boolean } | null } | null> | null };

export type UpdateTranscriptNoteMutationVariables = Exact<{
  transcriptId: Scalars['ID'];
  input: Scalars['String'];
}>;


export type UpdateTranscriptNoteMutation = { __typename?: 'Mutation', updateTranscriptNote?: { __typename?: 'Transcript', id: string } | null };

export type GenerateTranscriptAudioFileUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  fileExtension?: InputMaybe<Scalars['String']>;
}>;


export type GenerateTranscriptAudioFileUploadUrlMutation = { __typename?: 'Mutation', generateTranscriptAudioFileUploadUrl: string };

export type CreateTranscriptFromAudioFileMutationVariables = Exact<{
  fileUrl: Scalars['String'];
  patients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  sessionType?: InputMaybe<TranscriptSessionType>;
}>;


export type CreateTranscriptFromAudioFileMutation = { __typename?: 'Mutation', createTranscriptFromAudioFile: { __typename?: 'Transcript', id: string } };

export type CreateTranscriptMutationVariables = Exact<{
  noteType?: InputMaybe<TranscriptNoteType>;
  patients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sessionType?: InputMaybe<TranscriptSessionType>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<TranscriptSource>;
}>;


export type CreateTranscriptMutation = { __typename?: 'Mutation', createTranscript: { __typename?: 'Transcript', id: string } };

export type UserLocationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserLocationInfoQuery = { __typename?: 'Query', userLocationInfo?: { __typename?: 'UserLocationInfo', eu?: boolean | null, countryCode?: string | null } | null };


export const MeDocument = gql`
    query Me {
  me {
    id
    withTemporaryPassword
    doctorTitle
    licenceState
    licenceNumber
    licenceExpiryDate
    npi
    doctorRole
    gender
    ageRange
    employmentType
    firstName
    lastName
    timezone
    isOnboarded
    countryCode
    eu
    createdAt
    email
    phoneNumber
    address1
    address2
    city
    state
    zipCode
    features
    avatarUrl
    roles
    organization {
      id
      name
      owner {
        id
        email
      }
      timezone
      email
      phoneNumber
      address1
      address2
      city
      state
      zipCode
      taxId
      npi
      logo
      stripeAccountId
      stripeStatementDescriptor
      subscriptionPlan
      freeTrialEndDate
      subscriptionEndDate
      receiveHighSurveyNotification
      receiveHighPhq9Notification
      receiveHighSurveyEmail
      receiveHighPhq9Email
      currentPeriodTranscriptionLimits {
        count
        limit
      }
      currentPeriodFormLimits {
        count
        limit
      }
      transcriptDefaultSettings {
        noteType
        customPrompt
      }
    }
    buddies {
      id
      firstName
      lastName
      avatarUrl
      moodOfToday
    }
    customIcons {
      itemId
      iconName
    }
    receiveAutomaticInvoice
    receiveAutomaticSuperbill
    receiveReminders
    twoFactorEnabled
    defaultSignature {
      name
      credentials
      licenceNumber
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const AccountLoginHistoryDocument = gql`
    query AccountLoginHistory {
  me {
    id
    loginHistory {
      loginSource
      date
    }
  }
}
    `;

/**
 * __useAccountLoginHistoryQuery__
 *
 * To run a query within a React component, call `useAccountLoginHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLoginHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLoginHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountLoginHistoryQuery(baseOptions?: Apollo.QueryHookOptions<AccountLoginHistoryQuery, AccountLoginHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLoginHistoryQuery, AccountLoginHistoryQueryVariables>(AccountLoginHistoryDocument, options);
      }
export function useAccountLoginHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLoginHistoryQuery, AccountLoginHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLoginHistoryQuery, AccountLoginHistoryQueryVariables>(AccountLoginHistoryDocument, options);
        }
export type AccountLoginHistoryQueryHookResult = ReturnType<typeof useAccountLoginHistoryQuery>;
export type AccountLoginHistoryLazyQueryHookResult = ReturnType<typeof useAccountLoginHistoryLazyQuery>;
export type AccountLoginHistoryQueryResult = Apollo.QueryResult<AccountLoginHistoryQuery, AccountLoginHistoryQueryVariables>;
export const OrganizationDocument = gql`
    query Organization {
  me {
    id
    organization {
      id
      name
      owner {
        id
        email
      }
      timezone
      email
      phoneNumber
      address1
      address2
      city
      state
      zipCode
      taxId
      npi
      logo
      stripeAccountId
      stripeStatementDescriptor
      subscriptionPlan
      freeTrialEndDate
      subscriptionEndDate
      receiveHighSurveyNotification
      receiveHighPhq9Notification
      receiveHighSurveyEmail
      receiveHighPhq9Email
      currentPeriodTranscriptionCount
    }
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const LoginUserWithPasswordDocument = gql`
    mutation LoginUserWithPassword($email: String!, $password: String!, $rememberMe: Boolean, $loginSource: LoginSource) {
  loginUserWithPassword(
    email: $email
    password: $password
    rememberMe: $rememberMe
    loginSource: $loginSource
  ) {
    token
    is2FAEnabled
  }
}
    `;
export type LoginUserWithPasswordMutationFn = Apollo.MutationFunction<LoginUserWithPasswordMutation, LoginUserWithPasswordMutationVariables>;

/**
 * __useLoginUserWithPasswordMutation__
 *
 * To run a mutation, you first call `useLoginUserWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserWithPasswordMutation, { data, loading, error }] = useLoginUserWithPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      rememberMe: // value for 'rememberMe'
 *      loginSource: // value for 'loginSource'
 *   },
 * });
 */
export function useLoginUserWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserWithPasswordMutation, LoginUserWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserWithPasswordMutation, LoginUserWithPasswordMutationVariables>(LoginUserWithPasswordDocument, options);
      }
export type LoginUserWithPasswordMutationHookResult = ReturnType<typeof useLoginUserWithPasswordMutation>;
export type LoginUserWithPasswordMutationResult = Apollo.MutationResult<LoginUserWithPasswordMutation>;
export type LoginUserWithPasswordMutationOptions = Apollo.BaseMutationOptions<LoginUserWithPasswordMutation, LoginUserWithPasswordMutationVariables>;
export const LoginUserWithGoogleDocument = gql`
    mutation LoginUserWithGoogle($authCode: String!, $redirectUri: String, $rememberMe: Boolean, $loginSource: LoginSource) {
  loginUserWithGoogle(
    authCode: $authCode
    redirectUri: $redirectUri
    rememberMe: $rememberMe
    loginSource: $loginSource
  ) {
    token
    isFirstRegistration
  }
}
    `;
export type LoginUserWithGoogleMutationFn = Apollo.MutationFunction<LoginUserWithGoogleMutation, LoginUserWithGoogleMutationVariables>;

/**
 * __useLoginUserWithGoogleMutation__
 *
 * To run a mutation, you first call `useLoginUserWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserWithGoogleMutation, { data, loading, error }] = useLoginUserWithGoogleMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      redirectUri: // value for 'redirectUri'
 *      rememberMe: // value for 'rememberMe'
 *      loginSource: // value for 'loginSource'
 *   },
 * });
 */
export function useLoginUserWithGoogleMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserWithGoogleMutation, LoginUserWithGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserWithGoogleMutation, LoginUserWithGoogleMutationVariables>(LoginUserWithGoogleDocument, options);
      }
export type LoginUserWithGoogleMutationHookResult = ReturnType<typeof useLoginUserWithGoogleMutation>;
export type LoginUserWithGoogleMutationResult = Apollo.MutationResult<LoginUserWithGoogleMutation>;
export type LoginUserWithGoogleMutationOptions = Apollo.BaseMutationOptions<LoginUserWithGoogleMutation, LoginUserWithGoogleMutationVariables>;
export const RegisterUserByEmailDocument = gql`
    mutation RegisterUserByEmail($firstName: String!, $lastName: String!, $email: String!, $password: String!, $loginSource: LoginSource) {
  registerUserByEmail(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
    loginSource: $loginSource
  ) {
    token
  }
}
    `;
export type RegisterUserByEmailMutationFn = Apollo.MutationFunction<RegisterUserByEmailMutation, RegisterUserByEmailMutationVariables>;

/**
 * __useRegisterUserByEmailMutation__
 *
 * To run a mutation, you first call `useRegisterUserByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserByEmailMutation, { data, loading, error }] = useRegisterUserByEmailMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      loginSource: // value for 'loginSource'
 *   },
 * });
 */
export function useRegisterUserByEmailMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserByEmailMutation, RegisterUserByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserByEmailMutation, RegisterUserByEmailMutationVariables>(RegisterUserByEmailDocument, options);
      }
export type RegisterUserByEmailMutationHookResult = ReturnType<typeof useRegisterUserByEmailMutation>;
export type RegisterUserByEmailMutationResult = Apollo.MutationResult<RegisterUserByEmailMutation>;
export type RegisterUserByEmailMutationOptions = Apollo.BaseMutationOptions<RegisterUserByEmailMutation, RegisterUserByEmailMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($token: String!, $code: Int!) {
  verifyEmail(token: $token, code: $code) {
    token
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResendEmailVerificationCodeDocument = gql`
    mutation ResendEmailVerificationCode($token: String!) {
  resendEmailVerificationCode(token: $token) {
    emailVerifyCode
  }
}
    `;
export type ResendEmailVerificationCodeMutationFn = Apollo.MutationFunction<ResendEmailVerificationCodeMutation, ResendEmailVerificationCodeMutationVariables>;

/**
 * __useResendEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationCodeMutation, { data, loading, error }] = useResendEmailVerificationCodeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendEmailVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationCodeMutation, ResendEmailVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationCodeMutation, ResendEmailVerificationCodeMutationVariables>(ResendEmailVerificationCodeDocument, options);
      }
export type ResendEmailVerificationCodeMutationHookResult = ReturnType<typeof useResendEmailVerificationCodeMutation>;
export type ResendEmailVerificationCodeMutationResult = Apollo.MutationResult<ResendEmailVerificationCodeMutation>;
export type ResendEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationCodeMutation, ResendEmailVerificationCodeMutationVariables>;
export const ListUsersDocument = gql`
    query ListUsers($filter: ListUsersFilter) {
  listUsers(filter: $filter) {
    id
    firstName
    lastName
    email
    createdAt
    features
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const AddFeatureDocument = gql`
    mutation AddFeature($userId: ID, $feature: Features) {
  addFeature(userId: $userId, feature: $feature) {
    id
  }
}
    `;
export type AddFeatureMutationFn = Apollo.MutationFunction<AddFeatureMutation, AddFeatureMutationVariables>;

/**
 * __useAddFeatureMutation__
 *
 * To run a mutation, you first call `useAddFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeatureMutation, { data, loading, error }] = useAddFeatureMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useAddFeatureMutation(baseOptions?: Apollo.MutationHookOptions<AddFeatureMutation, AddFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeatureMutation, AddFeatureMutationVariables>(AddFeatureDocument, options);
      }
export type AddFeatureMutationHookResult = ReturnType<typeof useAddFeatureMutation>;
export type AddFeatureMutationResult = Apollo.MutationResult<AddFeatureMutation>;
export type AddFeatureMutationOptions = Apollo.BaseMutationOptions<AddFeatureMutation, AddFeatureMutationVariables>;
export const DiaryEntriesForBuddyDocument = gql`
    query DiaryEntriesForBuddy($userId: ID) {
  diaryEntriesForBuddy(userId: $userId) {
    total
    data {
      diaryEntries {
        answer
        question
        type
        createdAt
        diaryEntryType
        userId
        user {
          firstName
          lastName
        }
        selectedMood
        emotions {
          text
        }
        date
        scores {
          wellbeingIndex
          stress {
            percentage
          }
          anxiety {
            percentage
          }
          depression {
            percentage
          }
        }
        description
        diaryEntryDate
        moodContextLabels {
          label
        }
        moodContextItems {
          iconName
          name
        }
      }
    }
  }
}
    `;

/**
 * __useDiaryEntriesForBuddyQuery__
 *
 * To run a query within a React component, call `useDiaryEntriesForBuddyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaryEntriesForBuddyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaryEntriesForBuddyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDiaryEntriesForBuddyQuery(baseOptions?: Apollo.QueryHookOptions<DiaryEntriesForBuddyQuery, DiaryEntriesForBuddyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiaryEntriesForBuddyQuery, DiaryEntriesForBuddyQueryVariables>(DiaryEntriesForBuddyDocument, options);
      }
export function useDiaryEntriesForBuddyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiaryEntriesForBuddyQuery, DiaryEntriesForBuddyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiaryEntriesForBuddyQuery, DiaryEntriesForBuddyQueryVariables>(DiaryEntriesForBuddyDocument, options);
        }
export type DiaryEntriesForBuddyQueryHookResult = ReturnType<typeof useDiaryEntriesForBuddyQuery>;
export type DiaryEntriesForBuddyLazyQueryHookResult = ReturnType<typeof useDiaryEntriesForBuddyLazyQuery>;
export type DiaryEntriesForBuddyQueryResult = Apollo.QueryResult<DiaryEntriesForBuddyQuery, DiaryEntriesForBuddyQueryVariables>;
export const DoctorsDocument = gql`
    query Doctors($filter: DoctorsFilter) {
  doctors(filter: $filter) {
    id
    firstName
    lastName
    avatarUrl
  }
}
    `;

/**
 * __useDoctorsQuery__
 *
 * To run a query within a React component, call `useDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDoctorsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorsQuery, DoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorsQuery, DoctorsQueryVariables>(DoctorsDocument, options);
      }
export function useDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorsQuery, DoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorsQuery, DoctorsQueryVariables>(DoctorsDocument, options);
        }
export type DoctorsQueryHookResult = ReturnType<typeof useDoctorsQuery>;
export type DoctorsLazyQueryHookResult = ReturnType<typeof useDoctorsLazyQuery>;
export type DoctorsQueryResult = Apollo.QueryResult<DoctorsQuery, DoctorsQueryVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($type: GroupType, $name: String, $mentors: [ID], $patients: [ID], $description: String, $objective: String, $color: String, $topic: String) {
  createGroup(
    type: $type
    name: $name
    mentors: $mentors
    patients: $patients
    description: $description
    objective: $objective
    color: $color
    topic: $topic
  ) {
    id
    patients {
      id
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      mentors: // value for 'mentors'
 *      patients: // value for 'patients'
 *      description: // value for 'description'
 *      objective: // value for 'objective'
 *      color: // value for 'color'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const OrganizationGroupsDocument = gql`
    query OrganizationGroups($filter: OrganizationGroupsFilter) {
  organizationGroups(filter: $filter) {
    color
    description
    id
    type
    mentors {
      id
      firstName
      lastName
      avatarUrl
    }
    name
    objective
    topic
    patients {
      id
      firstName
      lastName
      avatarUrl
      gender
      yearOfBirth
      group {
        id
        name
        color
      }
      sadScores {
        wellbeingIndex
        stress {
          level
          percentage
        }
        anxiety {
          level
          percentage
        }
        depression {
          level
          percentage
        }
      }
      lastCompletedSession {
        startDate
        duration
        title
        id
      }
    }
    inactive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useOrganizationGroupsQuery__
 *
 * To run a query within a React component, call `useOrganizationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>(OrganizationGroupsDocument, options);
      }
export function useOrganizationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>(OrganizationGroupsDocument, options);
        }
export type OrganizationGroupsQueryHookResult = ReturnType<typeof useOrganizationGroupsQuery>;
export type OrganizationGroupsLazyQueryHookResult = ReturnType<typeof useOrganizationGroupsLazyQuery>;
export type OrganizationGroupsQueryResult = Apollo.QueryResult<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($groupId: ID!, $name: String, $mentors: [ID], $patients: [ID], $description: String, $objective: String, $color: String, $topic: String, $inactive: Boolean) {
  updateGroup(
    groupId: $groupId
    name: $name
    mentors: $mentors
    patients: $patients
    description: $description
    objective: $objective
    color: $color
    topic: $topic
    inactive: $inactive
  ) {
    id
    name
    patients {
      id
      firstName
      lastName
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      name: // value for 'name'
 *      mentors: // value for 'mentors'
 *      patients: // value for 'patients'
 *      description: // value for 'description'
 *      objective: // value for 'objective'
 *      color: // value for 'color'
 *      topic: // value for 'topic'
 *      inactive: // value for 'inactive'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($groupId: ID!) {
  deleteGroup(groupId: $groupId)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const PatientsDocument = gql`
    query Patients($filter: PatientsFilter) {
  patients(filter: $filter) {
    id
    email
    firstName
    lastName
    avatarUrl
    phoneNumber
    address1
    address2
    invitationSendDate
    secondaryEmails
    primaryDoctor {
      id
      firstName
      lastName
    }
    active
    receiveReminders
    isTestUser
    createdAt
    archived
  }
}
    `;

/**
 * __usePatientsQuery__
 *
 * To run a query within a React component, call `usePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientsQuery(baseOptions?: Apollo.QueryHookOptions<PatientsQuery, PatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientsQuery, PatientsQueryVariables>(PatientsDocument, options);
      }
export function usePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientsQuery, PatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientsQuery, PatientsQueryVariables>(PatientsDocument, options);
        }
export type PatientsQueryHookResult = ReturnType<typeof usePatientsQuery>;
export type PatientsLazyQueryHookResult = ReturnType<typeof usePatientsLazyQuery>;
export type PatientsQueryResult = Apollo.QueryResult<PatientsQuery, PatientsQueryVariables>;
export const OrganizationInvitationDocument = gql`
    mutation OrganizationInvitation($organizationId: ID!) {
  organizationInvitation(organizationId: $organizationId) {
    code
    id
    organization {
      id
      name
    }
  }
}
    `;
export type OrganizationInvitationMutationFn = Apollo.MutationFunction<OrganizationInvitationMutation, OrganizationInvitationMutationVariables>;

/**
 * __useOrganizationInvitationMutation__
 *
 * To run a mutation, you first call `useOrganizationInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationInvitationMutation, { data, loading, error }] = useOrganizationInvitationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationInvitationMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationInvitationMutation, OrganizationInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationInvitationMutation, OrganizationInvitationMutationVariables>(OrganizationInvitationDocument, options);
      }
export type OrganizationInvitationMutationHookResult = ReturnType<typeof useOrganizationInvitationMutation>;
export type OrganizationInvitationMutationResult = Apollo.MutationResult<OrganizationInvitationMutation>;
export type OrganizationInvitationMutationOptions = Apollo.BaseMutationOptions<OrganizationInvitationMutation, OrganizationInvitationMutationVariables>;
export const ServicePlacesDocument = gql`
    query ServicePlaces {
  servicePlaces {
    id
    code
    description
  }
}
    `;

/**
 * __useServicePlacesQuery__
 *
 * To run a query within a React component, call `useServicePlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePlacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicePlacesQuery(baseOptions?: Apollo.QueryHookOptions<ServicePlacesQuery, ServicePlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicePlacesQuery, ServicePlacesQueryVariables>(ServicePlacesDocument, options);
      }
export function useServicePlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicePlacesQuery, ServicePlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicePlacesQuery, ServicePlacesQueryVariables>(ServicePlacesDocument, options);
        }
export type ServicePlacesQueryHookResult = ReturnType<typeof useServicePlacesQuery>;
export type ServicePlacesLazyQueryHookResult = ReturnType<typeof useServicePlacesLazyQuery>;
export type ServicePlacesQueryResult = Apollo.QueryResult<ServicePlacesQuery, ServicePlacesQueryVariables>;
export const ServiceTypesDocument = gql`
    query ServiceTypes {
  serviceTypes {
    id
    name
    cptCode
    isAddOn
  }
}
    `;

/**
 * __useServiceTypesQuery__
 *
 * To run a query within a React component, call `useServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceTypesQuery(baseOptions?: Apollo.QueryHookOptions<ServiceTypesQuery, ServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceTypesQuery, ServiceTypesQueryVariables>(ServiceTypesDocument, options);
      }
export function useServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceTypesQuery, ServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceTypesQuery, ServiceTypesQueryVariables>(ServiceTypesDocument, options);
        }
export type ServiceTypesQueryHookResult = ReturnType<typeof useServiceTypesQuery>;
export type ServiceTypesLazyQueryHookResult = ReturnType<typeof useServiceTypesLazyQuery>;
export type ServiceTypesQueryResult = Apollo.QueryResult<ServiceTypesQuery, ServiceTypesQueryVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($organizationId: ID!, $title: String!, $startDate: Date!, $sessionType: SessionType!, $patients: [ID], $hosts: [ID], $description: String, $duration: Int, $hasVideo: Boolean, $servicePlace: ID, $services: [SessionServiceInput], $status: SessionStatus, $selectedGroup: ID) {
  createSession(
    organizationId: $organizationId
    title: $title
    startDate: $startDate
    patients: $patients
    hosts: $hosts
    description: $description
    duration: $duration
    sessionType: $sessionType
    hasVideo: $hasVideo
    servicePlace: $servicePlace
    services: $services
    status: $status
    selectedGroup: $selectedGroup
  ) {
    id
    title
  }
}
    `;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      title: // value for 'title'
 *      startDate: // value for 'startDate'
 *      sessionType: // value for 'sessionType'
 *      patients: // value for 'patients'
 *      hosts: // value for 'hosts'
 *      description: // value for 'description'
 *      duration: // value for 'duration'
 *      hasVideo: // value for 'hasVideo'
 *      servicePlace: // value for 'servicePlace'
 *      services: // value for 'services'
 *      status: // value for 'status'
 *      selectedGroup: // value for 'selectedGroup'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($sessionId: ID!, $title: String, $status: SessionStatus, $sessionType: SessionType, $startDate: Date, $patients: [ID], $hosts: [ID], $description: String, $duration: Int, $hasVideo: Boolean, $notes: String, $servicePlace: ID, $services: [SessionServiceInput], $confirmed: Boolean, $selectedGroup: ID) {
  updateSession(
    sessionId: $sessionId
    status: $status
    title: $title
    sessionType: $sessionType
    startDate: $startDate
    patients: $patients
    hosts: $hosts
    description: $description
    duration: $duration
    hasVideo: $hasVideo
    notes: $notes
    servicePlace: $servicePlace
    services: $services
    confirmed: $confirmed
    selectedGroup: $selectedGroup
  ) {
    id
  }
}
    `;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      title: // value for 'title'
 *      status: // value for 'status'
 *      sessionType: // value for 'sessionType'
 *      startDate: // value for 'startDate'
 *      patients: // value for 'patients'
 *      hosts: // value for 'hosts'
 *      description: // value for 'description'
 *      duration: // value for 'duration'
 *      hasVideo: // value for 'hasVideo'
 *      notes: // value for 'notes'
 *      servicePlace: // value for 'servicePlace'
 *      services: // value for 'services'
 *      confirmed: // value for 'confirmed'
 *      selectedGroup: // value for 'selectedGroup'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const DeleteSessionDocument = gql`
    mutation DeleteSession($sessionId: ID!, $reason: String) {
  deleteSession(sessionId: $sessionId, reason: $reason)
}
    `;
export type DeleteSessionMutationFn = Apollo.MutationFunction<DeleteSessionMutation, DeleteSessionMutationVariables>;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionMutation, DeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionMutation, DeleteSessionMutationVariables>(DeleteSessionDocument, options);
      }
export type DeleteSessionMutationHookResult = ReturnType<typeof useDeleteSessionMutation>;
export type DeleteSessionMutationResult = Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const OrganizationSessionsDocument = gql`
    query OrganizationSessions($filter: OrganizationSessionsFilter) {
  organizationSessions(filter: $filter) {
    id
    status
    breakoutRoom
    description
    duration
    sessionType
    hasVideo
    startDate
    status
    title
    notes
    transcripts
    confirmed
    acceptanceStates
    hosts {
      id
      firstName
      lastName
      avatarUrl
      licenceNumber
      npi
    }
    organization {
      id
      name
    }
    patients {
      id
      email
      firstName
      lastName
      avatarUrl
      gender
      pronoun
      dateOfBirth
      phoneNumber
      address1
      address2
      city
      state
      zipCode
      superbillDisabled
      isTestUser
    }
    servicePlace {
      id
      code
      description
    }
    services {
      cptCode
      name
      fee
      modifiers
    }
    deleted
    invoices {
      id
      organization {
        id
      }
      patient {
        id
        firstName
        lastName
        avatarUrl
      }
      amount
      state
      createdAt
      updatedAt
      invoiceNumber
      paymentDate
      paymentMethod
      stripePaymentId
      stripePaymentStatus
      stripeProcessingFee
      refundDate
      refundMethod
      stripeRefundStatus
      stripeRefundId
    }
    selectedGroup {
      id
    }
    cmsForms {
      id
      state
      patient {
        id
      }
    }
  }
}
    `;

/**
 * __useOrganizationSessionsQuery__
 *
 * To run a query within a React component, call `useOrganizationSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSessionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationSessionsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSessionsQuery, OrganizationSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSessionsQuery, OrganizationSessionsQueryVariables>(OrganizationSessionsDocument, options);
      }
export function useOrganizationSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSessionsQuery, OrganizationSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSessionsQuery, OrganizationSessionsQueryVariables>(OrganizationSessionsDocument, options);
        }
export type OrganizationSessionsQueryHookResult = ReturnType<typeof useOrganizationSessionsQuery>;
export type OrganizationSessionsLazyQueryHookResult = ReturnType<typeof useOrganizationSessionsLazyQuery>;
export type OrganizationSessionsQueryResult = Apollo.QueryResult<OrganizationSessionsQuery, OrganizationSessionsQueryVariables>;
export const SessionDocument = gql`
    query Session($sessionId: ID!) {
  session(sessionId: $sessionId) {
    id
    status
    breakoutRoom
    description
    duration
    sessionType
    hasVideo
    startDate
    status
    title
    notes
    transcripts
    confirmed
    acceptanceStates
    hosts {
      id
      firstName
      lastName
      avatarUrl
      licenceNumber
      npi
    }
    organization {
      id
      name
    }
    patients {
      id
      email
      firstName
      lastName
      avatarUrl
      gender
      pronoun
      dateOfBirth
      phoneNumber
      address1
      address2
      city
      state
      zipCode
      superbillDisabled
      isTestUser
    }
    servicePlace {
      id
      code
      description
    }
    services {
      cptCode
      name
      fee
      modifiers
    }
    deleted
    invoices {
      id
      organization {
        id
      }
      patient {
        id
        firstName
        lastName
        avatarUrl
      }
      amount
      state
      createdAt
      updatedAt
      invoiceNumber
      paymentDate
      paymentMethod
      stripePaymentId
      stripePaymentStatus
      stripeProcessingFee
      refundDate
      refundMethod
      stripeRefundStatus
      stripeRefundId
    }
    selectedGroup {
      id
    }
    cmsForms {
      id
      state
      patient {
        id
      }
    }
  }
}
    `;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSessionQuery(baseOptions: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const PatientSessionsDocument = gql`
    query PatientSessions($filter: SessionFilter) {
  sessions(filter: $filter) {
    breakoutRoom
    description
    duration
    sessionType
    organization {
      name
    }
    hosts {
      id
      firstName
      lastName
      avatarUrl
      doctorTitle
    }
    id
    patients {
      id
      firstName
      lastName
      avatarUrl
    }
    startDate
    status
    title
    acceptanceStates
  }
}
    `;

/**
 * __usePatientSessionsQuery__
 *
 * To run a query within a React component, call `usePatientSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientSessionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientSessionsQuery(baseOptions?: Apollo.QueryHookOptions<PatientSessionsQuery, PatientSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientSessionsQuery, PatientSessionsQueryVariables>(PatientSessionsDocument, options);
      }
export function usePatientSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientSessionsQuery, PatientSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientSessionsQuery, PatientSessionsQueryVariables>(PatientSessionsDocument, options);
        }
export type PatientSessionsQueryHookResult = ReturnType<typeof usePatientSessionsQuery>;
export type PatientSessionsLazyQueryHookResult = ReturnType<typeof usePatientSessionsLazyQuery>;
export type PatientSessionsQueryResult = Apollo.QueryResult<PatientSessionsQuery, PatientSessionsQueryVariables>;
export const PatientSessionDocument = gql`
    query PatientSession($sessionId: ID!) {
  session(sessionId: $sessionId) {
    breakoutRoom
    description
    duration
    sessionType
    organization {
      name
    }
    hosts {
      id
      firstName
      lastName
      avatarUrl
      doctorTitle
    }
    id
    patients {
      id
      firstName
      lastName
      avatarUrl
    }
    startDate
    status
    title
    acceptanceStates
  }
}
    `;

/**
 * __usePatientSessionQuery__
 *
 * To run a query within a React component, call `usePatientSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePatientSessionQuery(baseOptions: Apollo.QueryHookOptions<PatientSessionQuery, PatientSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientSessionQuery, PatientSessionQueryVariables>(PatientSessionDocument, options);
      }
export function usePatientSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientSessionQuery, PatientSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientSessionQuery, PatientSessionQueryVariables>(PatientSessionDocument, options);
        }
export type PatientSessionQueryHookResult = ReturnType<typeof usePatientSessionQuery>;
export type PatientSessionLazyQueryHookResult = ReturnType<typeof usePatientSessionLazyQuery>;
export type PatientSessionQueryResult = Apollo.QueryResult<PatientSessionQuery, PatientSessionQueryVariables>;
export const GetAccessTokenForSessionDocument = gql`
    mutation GetAccessTokenForSession($sessionId: ID!) {
  getAccessTokenForSession(sessionId: $sessionId) {
    accessToken
  }
}
    `;
export type GetAccessTokenForSessionMutationFn = Apollo.MutationFunction<GetAccessTokenForSessionMutation, GetAccessTokenForSessionMutationVariables>;

/**
 * __useGetAccessTokenForSessionMutation__
 *
 * To run a mutation, you first call `useGetAccessTokenForSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAccessTokenForSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAccessTokenForSessionMutation, { data, loading, error }] = useGetAccessTokenForSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetAccessTokenForSessionMutation(baseOptions?: Apollo.MutationHookOptions<GetAccessTokenForSessionMutation, GetAccessTokenForSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAccessTokenForSessionMutation, GetAccessTokenForSessionMutationVariables>(GetAccessTokenForSessionDocument, options);
      }
export type GetAccessTokenForSessionMutationHookResult = ReturnType<typeof useGetAccessTokenForSessionMutation>;
export type GetAccessTokenForSessionMutationResult = Apollo.MutationResult<GetAccessTokenForSessionMutation>;
export type GetAccessTokenForSessionMutationOptions = Apollo.BaseMutationOptions<GetAccessTokenForSessionMutation, GetAccessTokenForSessionMutationVariables>;
export const AddPatientsToGroupDocument = gql`
    mutation AddPatientsToGroup($groupId: ID!, $patients: [ID]!) {
  addPatientsToGroup(groupId: $groupId, patients: $patients) {
    id
    color
    description
    name
    objective
    patients {
      id
    }
  }
}
    `;
export type AddPatientsToGroupMutationFn = Apollo.MutationFunction<AddPatientsToGroupMutation, AddPatientsToGroupMutationVariables>;

/**
 * __useAddPatientsToGroupMutation__
 *
 * To run a mutation, you first call `useAddPatientsToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientsToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientsToGroupMutation, { data, loading, error }] = useAddPatientsToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      patients: // value for 'patients'
 *   },
 * });
 */
export function useAddPatientsToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientsToGroupMutation, AddPatientsToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientsToGroupMutation, AddPatientsToGroupMutationVariables>(AddPatientsToGroupDocument, options);
      }
export type AddPatientsToGroupMutationHookResult = ReturnType<typeof useAddPatientsToGroupMutation>;
export type AddPatientsToGroupMutationResult = Apollo.MutationResult<AddPatientsToGroupMutation>;
export type AddPatientsToGroupMutationOptions = Apollo.BaseMutationOptions<AddPatientsToGroupMutation, AddPatientsToGroupMutationVariables>;
export const RemovePatientsFromGroupDocument = gql`
    mutation RemovePatientsFromGroup($groupId: ID!, $patients: [ID]!) {
  removePatientsFromGroup(groupId: $groupId, patients: $patients) {
    color
    description
    id
    name
    mentors {
      firstName
      lastName
    }
  }
}
    `;
export type RemovePatientsFromGroupMutationFn = Apollo.MutationFunction<RemovePatientsFromGroupMutation, RemovePatientsFromGroupMutationVariables>;

/**
 * __useRemovePatientsFromGroupMutation__
 *
 * To run a mutation, you first call `useRemovePatientsFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientsFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePatientsFromGroupMutation, { data, loading, error }] = useRemovePatientsFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      patients: // value for 'patients'
 *   },
 * });
 */
export function useRemovePatientsFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemovePatientsFromGroupMutation, RemovePatientsFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePatientsFromGroupMutation, RemovePatientsFromGroupMutationVariables>(RemovePatientsFromGroupDocument, options);
      }
export type RemovePatientsFromGroupMutationHookResult = ReturnType<typeof useRemovePatientsFromGroupMutation>;
export type RemovePatientsFromGroupMutationResult = Apollo.MutationResult<RemovePatientsFromGroupMutation>;
export type RemovePatientsFromGroupMutationOptions = Apollo.BaseMutationOptions<RemovePatientsFromGroupMutation, RemovePatientsFromGroupMutationVariables>;
export const MoodAndScoreOfPatientDocument = gql`
    query MoodAndScoreOfPatient($filter: UserScoreAndMoodFilter!) {
  moodAndScoreOfPatient(filter: $filter) {
    mood {
      id
      date
      selectedMood
    }
    score {
      anxiety {
        level
        percentage
        score
      }
      depression {
        level
        percentage
        score
      }
      stress {
        level
        percentage
        score
      }
    }
  }
}
    `;

/**
 * __useMoodAndScoreOfPatientQuery__
 *
 * To run a query within a React component, call `useMoodAndScoreOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoodAndScoreOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoodAndScoreOfPatientQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMoodAndScoreOfPatientQuery(baseOptions: Apollo.QueryHookOptions<MoodAndScoreOfPatientQuery, MoodAndScoreOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoodAndScoreOfPatientQuery, MoodAndScoreOfPatientQueryVariables>(MoodAndScoreOfPatientDocument, options);
      }
export function useMoodAndScoreOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoodAndScoreOfPatientQuery, MoodAndScoreOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoodAndScoreOfPatientQuery, MoodAndScoreOfPatientQueryVariables>(MoodAndScoreOfPatientDocument, options);
        }
export type MoodAndScoreOfPatientQueryHookResult = ReturnType<typeof useMoodAndScoreOfPatientQuery>;
export type MoodAndScoreOfPatientLazyQueryHookResult = ReturnType<typeof useMoodAndScoreOfPatientLazyQuery>;
export type MoodAndScoreOfPatientQueryResult = Apollo.QueryResult<MoodAndScoreOfPatientQuery, MoodAndScoreOfPatientQueryVariables>;
export const DiagnosesDocument = gql`
    query Diagnoses {
  diagnoses {
    code
    description
    id
  }
}
    `;

/**
 * __useDiagnosesQuery__
 *
 * To run a query within a React component, call `useDiagnosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiagnosesQuery(baseOptions?: Apollo.QueryHookOptions<DiagnosesQuery, DiagnosesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosesQuery, DiagnosesQueryVariables>(DiagnosesDocument, options);
      }
export function useDiagnosesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosesQuery, DiagnosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosesQuery, DiagnosesQueryVariables>(DiagnosesDocument, options);
        }
export type DiagnosesQueryHookResult = ReturnType<typeof useDiagnosesQuery>;
export type DiagnosesLazyQueryHookResult = ReturnType<typeof useDiagnosesLazyQuery>;
export type DiagnosesQueryResult = Apollo.QueryResult<DiagnosesQuery, DiagnosesQueryVariables>;
export const ApplyDiagnosisToPatientDocument = gql`
    mutation ApplyDiagnosisToPatient($userId: ID!, $diagnosisId: ID!, $assignedAt: Date!) {
  applyDiagnosisToPatient(
    userId: $userId
    diagnosisId: $diagnosisId
    assignedAt: $assignedAt
  ) {
    id
  }
}
    `;
export type ApplyDiagnosisToPatientMutationFn = Apollo.MutationFunction<ApplyDiagnosisToPatientMutation, ApplyDiagnosisToPatientMutationVariables>;

/**
 * __useApplyDiagnosisToPatientMutation__
 *
 * To run a mutation, you first call `useApplyDiagnosisToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiagnosisToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiagnosisToPatientMutation, { data, loading, error }] = useApplyDiagnosisToPatientMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      diagnosisId: // value for 'diagnosisId'
 *      assignedAt: // value for 'assignedAt'
 *   },
 * });
 */
export function useApplyDiagnosisToPatientMutation(baseOptions?: Apollo.MutationHookOptions<ApplyDiagnosisToPatientMutation, ApplyDiagnosisToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyDiagnosisToPatientMutation, ApplyDiagnosisToPatientMutationVariables>(ApplyDiagnosisToPatientDocument, options);
      }
export type ApplyDiagnosisToPatientMutationHookResult = ReturnType<typeof useApplyDiagnosisToPatientMutation>;
export type ApplyDiagnosisToPatientMutationResult = Apollo.MutationResult<ApplyDiagnosisToPatientMutation>;
export type ApplyDiagnosisToPatientMutationOptions = Apollo.BaseMutationOptions<ApplyDiagnosisToPatientMutation, ApplyDiagnosisToPatientMutationVariables>;
export const RemoveDiagnosisFromPatientDocument = gql`
    mutation RemoveDiagnosisFromPatient($userId: ID!, $diagnosisId: ID!) {
  removeDiagnosisFromPatient(userId: $userId, diagnosisId: $diagnosisId) {
    id
  }
}
    `;
export type RemoveDiagnosisFromPatientMutationFn = Apollo.MutationFunction<RemoveDiagnosisFromPatientMutation, RemoveDiagnosisFromPatientMutationVariables>;

/**
 * __useRemoveDiagnosisFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveDiagnosisFromPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDiagnosisFromPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDiagnosisFromPatientMutation, { data, loading, error }] = useRemoveDiagnosisFromPatientMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      diagnosisId: // value for 'diagnosisId'
 *   },
 * });
 */
export function useRemoveDiagnosisFromPatientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDiagnosisFromPatientMutation, RemoveDiagnosisFromPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDiagnosisFromPatientMutation, RemoveDiagnosisFromPatientMutationVariables>(RemoveDiagnosisFromPatientDocument, options);
      }
export type RemoveDiagnosisFromPatientMutationHookResult = ReturnType<typeof useRemoveDiagnosisFromPatientMutation>;
export type RemoveDiagnosisFromPatientMutationResult = Apollo.MutationResult<RemoveDiagnosisFromPatientMutation>;
export type RemoveDiagnosisFromPatientMutationOptions = Apollo.BaseMutationOptions<RemoveDiagnosisFromPatientMutation, RemoveDiagnosisFromPatientMutationVariables>;
export const AggregateSessionsByMonthDocument = gql`
    query AggregateSessionsByMonth($patientId: ID!) {
  aggregateSessionsByMonth(patientId: $patientId) {
    hasUnconfirmedSessions
    month
    year
  }
}
    `;

/**
 * __useAggregateSessionsByMonthQuery__
 *
 * To run a query within a React component, call `useAggregateSessionsByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateSessionsByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateSessionsByMonthQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAggregateSessionsByMonthQuery(baseOptions: Apollo.QueryHookOptions<AggregateSessionsByMonthQuery, AggregateSessionsByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregateSessionsByMonthQuery, AggregateSessionsByMonthQueryVariables>(AggregateSessionsByMonthDocument, options);
      }
export function useAggregateSessionsByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregateSessionsByMonthQuery, AggregateSessionsByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregateSessionsByMonthQuery, AggregateSessionsByMonthQueryVariables>(AggregateSessionsByMonthDocument, options);
        }
export type AggregateSessionsByMonthQueryHookResult = ReturnType<typeof useAggregateSessionsByMonthQuery>;
export type AggregateSessionsByMonthLazyQueryHookResult = ReturnType<typeof useAggregateSessionsByMonthLazyQuery>;
export type AggregateSessionsByMonthQueryResult = Apollo.QueryResult<AggregateSessionsByMonthQuery, AggregateSessionsByMonthQueryVariables>;
export const HasUnconfirmedSessionsDocument = gql`
    query HasUnconfirmedSessions($month: Int!, $year: Int!, $patientId: ID!) {
  hasUnconfirmedSessions(month: $month, year: $year, patientId: $patientId)
}
    `;

/**
 * __useHasUnconfirmedSessionsQuery__
 *
 * To run a query within a React component, call `useHasUnconfirmedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasUnconfirmedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasUnconfirmedSessionsQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useHasUnconfirmedSessionsQuery(baseOptions: Apollo.QueryHookOptions<HasUnconfirmedSessionsQuery, HasUnconfirmedSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasUnconfirmedSessionsQuery, HasUnconfirmedSessionsQueryVariables>(HasUnconfirmedSessionsDocument, options);
      }
export function useHasUnconfirmedSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasUnconfirmedSessionsQuery, HasUnconfirmedSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasUnconfirmedSessionsQuery, HasUnconfirmedSessionsQueryVariables>(HasUnconfirmedSessionsDocument, options);
        }
export type HasUnconfirmedSessionsQueryHookResult = ReturnType<typeof useHasUnconfirmedSessionsQuery>;
export type HasUnconfirmedSessionsLazyQueryHookResult = ReturnType<typeof useHasUnconfirmedSessionsLazyQuery>;
export type HasUnconfirmedSessionsQueryResult = Apollo.QueryResult<HasUnconfirmedSessionsQuery, HasUnconfirmedSessionsQueryVariables>;
export const SuperbillDocument = gql`
    query Superbill($patientId: ID!, $month: Int!, $year: Int!) {
  superbill(patientId: $patientId, month: $month, year: $year) {
    id
    dateFrom
    dateTo
    state
  }
}
    `;

/**
 * __useSuperbillQuery__
 *
 * To run a query within a React component, call `useSuperbillQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperbillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperbillQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSuperbillQuery(baseOptions: Apollo.QueryHookOptions<SuperbillQuery, SuperbillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperbillQuery, SuperbillQueryVariables>(SuperbillDocument, options);
      }
export function useSuperbillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperbillQuery, SuperbillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperbillQuery, SuperbillQueryVariables>(SuperbillDocument, options);
        }
export type SuperbillQueryHookResult = ReturnType<typeof useSuperbillQuery>;
export type SuperbillLazyQueryHookResult = ReturnType<typeof useSuperbillLazyQuery>;
export type SuperbillQueryResult = Apollo.QueryResult<SuperbillQuery, SuperbillQueryVariables>;
export const SuperbillPdfUrlDocument = gql`
    query SuperbillPdfUrl($patientId: ID!, $month: Int!, $year: Int!) {
  superbillPdfUrl(patientId: $patientId, month: $month, year: $year)
}
    `;

/**
 * __useSuperbillPdfUrlQuery__
 *
 * To run a query within a React component, call `useSuperbillPdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperbillPdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperbillPdfUrlQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSuperbillPdfUrlQuery(baseOptions: Apollo.QueryHookOptions<SuperbillPdfUrlQuery, SuperbillPdfUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperbillPdfUrlQuery, SuperbillPdfUrlQueryVariables>(SuperbillPdfUrlDocument, options);
      }
export function useSuperbillPdfUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperbillPdfUrlQuery, SuperbillPdfUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperbillPdfUrlQuery, SuperbillPdfUrlQueryVariables>(SuperbillPdfUrlDocument, options);
        }
export type SuperbillPdfUrlQueryHookResult = ReturnType<typeof useSuperbillPdfUrlQuery>;
export type SuperbillPdfUrlLazyQueryHookResult = ReturnType<typeof useSuperbillPdfUrlLazyQuery>;
export type SuperbillPdfUrlQueryResult = Apollo.QueryResult<SuperbillPdfUrlQuery, SuperbillPdfUrlQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $lastName: String!, $primaryDoctorId: ID!, $email: String, $phoneNumber: String, $secondaryEmails: [String!]) {
  createUser(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber: $phoneNumber
    primaryDoctorId: $primaryDoctorId
    secondaryEmails: $secondaryEmails
  ) {
    id
    firstName
    lastName
    email
    phoneNumber
    avatarUrl
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      primaryDoctorId: // value for 'primaryDoctorId'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      secondaryEmails: // value for 'secondaryEmails'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdatePatientProfileDocument = gql`
    mutation UpdatePatientProfile($patientId: ID!, $firstName: String, $lastName: String, $email: String, $gender: Genders, $dateOfBirth: Date, $preferredName: String, $pronoun: Pronouns, $healthInsurance: HealthInsurance, $healthInsuranceNumber: String, $healthInsuranceProvider: String, $phoneNumber: String, $address1: String, $address2: String, $city: String, $state: String, $zipCode: String, $primaryDoctorId: ID, $superbillDisabled: Boolean, $receiveReminders: Boolean, $receiveAutomaticInvoice: Boolean, $receiveAutomaticSuperbill: Boolean, $billingType: BillingType, $secondaryEmails: [String!]) {
  updatePatientProfile(
    patientId: $patientId
    firstName: $firstName
    lastName: $lastName
    email: $email
    gender: $gender
    dateOfBirth: $dateOfBirth
    preferredName: $preferredName
    pronoun: $pronoun
    healthInsurance: $healthInsurance
    healthInsuranceNumber: $healthInsuranceNumber
    healthInsuranceProvider: $healthInsuranceProvider
    phoneNumber: $phoneNumber
    address1: $address1
    address2: $address2
    city: $city
    state: $state
    zipCode: $zipCode
    primaryDoctorId: $primaryDoctorId
    superbillDisabled: $superbillDisabled
    receiveReminders: $receiveReminders
    receiveAutomaticInvoice: $receiveAutomaticInvoice
    receiveAutomaticSuperbill: $receiveAutomaticSuperbill
    billingType: $billingType
    secondaryEmails: $secondaryEmails
  ) {
    id
  }
}
    `;
export type UpdatePatientProfileMutationFn = Apollo.MutationFunction<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>;

/**
 * __useUpdatePatientProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePatientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientProfileMutation, { data, loading, error }] = useUpdatePatientProfileMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      gender: // value for 'gender'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      preferredName: // value for 'preferredName'
 *      pronoun: // value for 'pronoun'
 *      healthInsurance: // value for 'healthInsurance'
 *      healthInsuranceNumber: // value for 'healthInsuranceNumber'
 *      healthInsuranceProvider: // value for 'healthInsuranceProvider'
 *      phoneNumber: // value for 'phoneNumber'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *      primaryDoctorId: // value for 'primaryDoctorId'
 *      superbillDisabled: // value for 'superbillDisabled'
 *      receiveReminders: // value for 'receiveReminders'
 *      receiveAutomaticInvoice: // value for 'receiveAutomaticInvoice'
 *      receiveAutomaticSuperbill: // value for 'receiveAutomaticSuperbill'
 *      billingType: // value for 'billingType'
 *      secondaryEmails: // value for 'secondaryEmails'
 *   },
 * });
 */
export function useUpdatePatientProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>(UpdatePatientProfileDocument, options);
      }
export type UpdatePatientProfileMutationHookResult = ReturnType<typeof useUpdatePatientProfileMutation>;
export type UpdatePatientProfileMutationResult = Apollo.MutationResult<UpdatePatientProfileMutation>;
export type UpdatePatientProfileMutationOptions = Apollo.BaseMutationOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($patientId: ID!, $customEmailMessage: String, $customSmsMessage: String) {
  sendInvitation(
    patientId: $patientId
    customEmailMessage: $customEmailMessage
    customSMSMessage: $customSmsMessage
  )
}
    `;
export type SendInvitationMutationFn = Apollo.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      customEmailMessage: // value for 'customEmailMessage'
 *      customSmsMessage: // value for 'customSmsMessage'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = Apollo.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = Apollo.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const SendDoctorPatientAppInvitationDocument = gql`
    mutation SendDoctorPatientAppInvitation {
  sendDoctorPatientAppInvitation
}
    `;
export type SendDoctorPatientAppInvitationMutationFn = Apollo.MutationFunction<SendDoctorPatientAppInvitationMutation, SendDoctorPatientAppInvitationMutationVariables>;

/**
 * __useSendDoctorPatientAppInvitationMutation__
 *
 * To run a mutation, you first call `useSendDoctorPatientAppInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDoctorPatientAppInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDoctorPatientAppInvitationMutation, { data, loading, error }] = useSendDoctorPatientAppInvitationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendDoctorPatientAppInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendDoctorPatientAppInvitationMutation, SendDoctorPatientAppInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDoctorPatientAppInvitationMutation, SendDoctorPatientAppInvitationMutationVariables>(SendDoctorPatientAppInvitationDocument, options);
      }
export type SendDoctorPatientAppInvitationMutationHookResult = ReturnType<typeof useSendDoctorPatientAppInvitationMutation>;
export type SendDoctorPatientAppInvitationMutationResult = Apollo.MutationResult<SendDoctorPatientAppInvitationMutation>;
export type SendDoctorPatientAppInvitationMutationOptions = Apollo.BaseMutationOptions<SendDoctorPatientAppInvitationMutation, SendDoctorPatientAppInvitationMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($firstName: String, $lastName: String, $email: String, $phoneNumber: String, $licenceState: String, $licenceNumber: String, $licenceExpiryDate: Date, $npi: String, $doctorRole: String, $doctorTitle: String, $timezone: String, $defaultSignature: DefaultSignatureInput) {
  updateProfile(
    timezone: $timezone
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber: $phoneNumber
    licenceState: $licenceState
    licenceNumber: $licenceNumber
    licenceExpiryDate: $licenceExpiryDate
    npi: $npi
    doctorRole: $doctorRole
    doctorTitle: $doctorTitle
    defaultSignature: $defaultSignature
  ) {
    id
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      licenceState: // value for 'licenceState'
 *      licenceNumber: // value for 'licenceNumber'
 *      licenceExpiryDate: // value for 'licenceExpiryDate'
 *      npi: // value for 'npi'
 *      doctorRole: // value for 'doctorRole'
 *      doctorTitle: // value for 'doctorTitle'
 *      timezone: // value for 'timezone'
 *      defaultSignature: // value for 'defaultSignature'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($name: String!, $timezone: String!, $address1: String, $address2: String, $city: String, $state: String, $email: String, $phoneNumber: String, $zipCode: String, $interests: [String], $isPaidTrial: Boolean) {
  createOrganization(
    name: $name
    timezone: $timezone
    address1: $address1
    address2: $address2
    city: $city
    state: $state
    phoneNumber: $phoneNumber
    email: $email
    zipCode: $zipCode
    interests: $interests
    isPaidTrial: $isPaidTrial
  ) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      timezone: // value for 'timezone'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      zipCode: // value for 'zipCode'
 *      interests: // value for 'interests'
 *      isPaidTrial: // value for 'isPaidTrial'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UploadAvatarDocument = gql`
    mutation UploadAvatar($base64: String!) {
  uploadAvatar(base64: $base64) {
    id
  }
}
    `;
export type UploadAvatarMutationFn = Apollo.MutationFunction<UploadAvatarMutation, UploadAvatarMutationVariables>;

/**
 * __useUploadAvatarMutation__
 *
 * To run a mutation, you first call `useUploadAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAvatarMutation, { data, loading, error }] = useUploadAvatarMutation({
 *   variables: {
 *      base64: // value for 'base64'
 *   },
 * });
 */
export function useUploadAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UploadAvatarMutation, UploadAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAvatarMutation, UploadAvatarMutationVariables>(UploadAvatarDocument, options);
      }
export type UploadAvatarMutationHookResult = ReturnType<typeof useUploadAvatarMutation>;
export type UploadAvatarMutationResult = Apollo.MutationResult<UploadAvatarMutation>;
export type UploadAvatarMutationOptions = Apollo.BaseMutationOptions<UploadAvatarMutation, UploadAvatarMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($email: String, $name: String, $timezone: String, $address1: String, $address2: String, $city: String, $state: String, $zipCode: String, $phoneNumber: String, $taxId: String, $npi: String, $stripeStatementDescriptor: String, $receiveHighSurveyNotification: Boolean, $receiveHighPhq9Notification: Boolean, $receiveHighSurveyEmail: Boolean, $receiveHighPhq9Email: Boolean, $transcriptDefaultSettings: TranscriptDefaultSettingsInput) {
  updateOrganization(
    email: $email
    name: $name
    timezone: $timezone
    address1: $address1
    address2: $address2
    city: $city
    state: $state
    zipCode: $zipCode
    phoneNumber: $phoneNumber
    taxId: $taxId
    npi: $npi
    stripeStatementDescriptor: $stripeStatementDescriptor
    receiveHighSurveyNotification: $receiveHighSurveyNotification
    receiveHighPhq9Notification: $receiveHighPhq9Notification
    receiveHighSurveyEmail: $receiveHighSurveyEmail
    receiveHighPhq9Email: $receiveHighPhq9Email
    transcriptDefaultSettings: $transcriptDefaultSettings
  ) {
    id
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      timezone: // value for 'timezone'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      taxId: // value for 'taxId'
 *      npi: // value for 'npi'
 *      stripeStatementDescriptor: // value for 'stripeStatementDescriptor'
 *      receiveHighSurveyNotification: // value for 'receiveHighSurveyNotification'
 *      receiveHighPhq9Notification: // value for 'receiveHighPhq9Notification'
 *      receiveHighSurveyEmail: // value for 'receiveHighSurveyEmail'
 *      receiveHighPhq9Email: // value for 'receiveHighPhq9Email'
 *      transcriptDefaultSettings: // value for 'transcriptDefaultSettings'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationLogoDocument = gql`
    mutation UpdateOrganizationLogo($base64: String) {
  updateOrganizationLogo(base64: $base64) {
    id
  }
}
    `;
export type UpdateOrganizationLogoMutationFn = Apollo.MutationFunction<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>;

/**
 * __useUpdateOrganizationLogoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationLogoMutation, { data, loading, error }] = useUpdateOrganizationLogoMutation({
 *   variables: {
 *      base64: // value for 'base64'
 *   },
 * });
 */
export function useUpdateOrganizationLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>(UpdateOrganizationLogoDocument, options);
      }
export type UpdateOrganizationLogoMutationHookResult = ReturnType<typeof useUpdateOrganizationLogoMutation>;
export type UpdateOrganizationLogoMutationResult = Apollo.MutationResult<UpdateOrganizationLogoMutation>;
export type UpdateOrganizationLogoMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($newPassword: String!, $oldPassword: String!) {
  changeUserPassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    id
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const ChangeTemporaryPasswordDocument = gql`
    mutation ChangeTemporaryPassword($newPassword: String!) {
  changeTemporaryPassword(newPassword: $newPassword)
}
    `;
export type ChangeTemporaryPasswordMutationFn = Apollo.MutationFunction<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>;

/**
 * __useChangeTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useChangeTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTemporaryPasswordMutation, { data, loading, error }] = useChangeTemporaryPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangeTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>(ChangeTemporaryPasswordDocument, options);
      }
export type ChangeTemporaryPasswordMutationHookResult = ReturnType<typeof useChangeTemporaryPasswordMutation>;
export type ChangeTemporaryPasswordMutationResult = Apollo.MutationResult<ChangeTemporaryPasswordMutation>;
export type ChangeTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>;
export const AdminSetTemporaryPasswordDocument = gql`
    mutation AdminSetTemporaryPassword($email: String!, $temporaryPassword: String!) {
  adminSetTemporaryPassword(email: $email, temporaryPassword: $temporaryPassword) {
    id
  }
}
    `;
export type AdminSetTemporaryPasswordMutationFn = Apollo.MutationFunction<AdminSetTemporaryPasswordMutation, AdminSetTemporaryPasswordMutationVariables>;

/**
 * __useAdminSetTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useAdminSetTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetTemporaryPasswordMutation, { data, loading, error }] = useAdminSetTemporaryPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      temporaryPassword: // value for 'temporaryPassword'
 *   },
 * });
 */
export function useAdminSetTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetTemporaryPasswordMutation, AdminSetTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetTemporaryPasswordMutation, AdminSetTemporaryPasswordMutationVariables>(AdminSetTemporaryPasswordDocument, options);
      }
export type AdminSetTemporaryPasswordMutationHookResult = ReturnType<typeof useAdminSetTemporaryPasswordMutation>;
export type AdminSetTemporaryPasswordMutationResult = Apollo.MutationResult<AdminSetTemporaryPasswordMutation>;
export type AdminSetTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<AdminSetTemporaryPasswordMutation, AdminSetTemporaryPasswordMutationVariables>;
export const MoodResponsesOfPatientDocument = gql`
    query MoodResponsesOfPatient($patientId: ID!, $filter: MoodResponseFilter) {
  moodResponsesOfPatient(patientId: $patientId, filter: $filter) {
    id
    description
    user {
      id
      firstName
      lastName
      email
    }
    userId
    selectedMood
    emotions {
      id
      slug
      text
      moods
      translation {
        en {
          text
          description
        }
      }
      descriptionReplaceText
      type
    }
    date
    moodContextItems {
      translation {
        en {
          name
        }
      }
      id
      name
      iconName
      predefined
      moderated
    }
    moodContextLabels {
      slug
      label
      translation {
        en {
          label
        }
      }
      iconName
    }
  }
}
    `;

/**
 * __useMoodResponsesOfPatientQuery__
 *
 * To run a query within a React component, call `useMoodResponsesOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoodResponsesOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoodResponsesOfPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMoodResponsesOfPatientQuery(baseOptions: Apollo.QueryHookOptions<MoodResponsesOfPatientQuery, MoodResponsesOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoodResponsesOfPatientQuery, MoodResponsesOfPatientQueryVariables>(MoodResponsesOfPatientDocument, options);
      }
export function useMoodResponsesOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoodResponsesOfPatientQuery, MoodResponsesOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoodResponsesOfPatientQuery, MoodResponsesOfPatientQueryVariables>(MoodResponsesOfPatientDocument, options);
        }
export type MoodResponsesOfPatientQueryHookResult = ReturnType<typeof useMoodResponsesOfPatientQuery>;
export type MoodResponsesOfPatientLazyQueryHookResult = ReturnType<typeof useMoodResponsesOfPatientLazyQuery>;
export type MoodResponsesOfPatientQueryResult = Apollo.QueryResult<MoodResponsesOfPatientQuery, MoodResponsesOfPatientQueryVariables>;
export const LatestScoreDocument = gql`
    query LatestScore($userId: ID) {
  latestScore(userId: $userId) {
    stress {
      score
      percentage
      level
    }
    anxiety {
      score
      percentage
      level
    }
    depression {
      score
      percentage
      level
    }
    highlightedText {
      anxiety {
        en {
          highlightedText
        }
      }
      depression {
        en {
          highlightedText
        }
      }
      stress {
        en {
          highlightedText
        }
      }
    }
    surveyResponse {
      survey {
        type
        questions {
          question {
            slug
            subTitle
            text
            optionGroup {
              options {
                option {
                  slug
                  text
                }
              }
            }
          }
        }
      }
      answers {
        question {
          slug
        }
        option {
          slug
        }
      }
      createdAt
    }
    wellbeingIndex
    wellbeingIndexDelta
    lastSurveyTime
    lastCheckInTime
    createdAt
  }
}
    `;

/**
 * __useLatestScoreQuery__
 *
 * To run a query within a React component, call `useLatestScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestScoreQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLatestScoreQuery(baseOptions?: Apollo.QueryHookOptions<LatestScoreQuery, LatestScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestScoreQuery, LatestScoreQueryVariables>(LatestScoreDocument, options);
      }
export function useLatestScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestScoreQuery, LatestScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestScoreQuery, LatestScoreQueryVariables>(LatestScoreDocument, options);
        }
export type LatestScoreQueryHookResult = ReturnType<typeof useLatestScoreQuery>;
export type LatestScoreLazyQueryHookResult = ReturnType<typeof useLatestScoreLazyQuery>;
export type LatestScoreQueryResult = Apollo.QueryResult<LatestScoreQuery, LatestScoreQueryVariables>;
export const ScoresOfPatientDocument = gql`
    query scoresOfPatient($patientId: ID!, $filter: ScoreFilter) {
  scoresOfPatient(patientId: $patientId, filter: $filter) {
    stress {
      score
      percentage
      level
    }
    anxiety {
      score
      percentage
      level
    }
    depression {
      score
      percentage
      level
    }
    wellbeingIndex
    wellbeingIndexDelta
    triggeredBy
    createdAt
  }
}
    `;

/**
 * __useScoresOfPatientQuery__
 *
 * To run a query within a React component, call `useScoresOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoresOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoresOfPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScoresOfPatientQuery(baseOptions: Apollo.QueryHookOptions<ScoresOfPatientQuery, ScoresOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoresOfPatientQuery, ScoresOfPatientQueryVariables>(ScoresOfPatientDocument, options);
      }
export function useScoresOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoresOfPatientQuery, ScoresOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoresOfPatientQuery, ScoresOfPatientQueryVariables>(ScoresOfPatientDocument, options);
        }
export type ScoresOfPatientQueryHookResult = ReturnType<typeof useScoresOfPatientQuery>;
export type ScoresOfPatientLazyQueryHookResult = ReturnType<typeof useScoresOfPatientLazyQuery>;
export type ScoresOfPatientQueryResult = Apollo.QueryResult<ScoresOfPatientQuery, ScoresOfPatientQueryVariables>;
export const MutationDocument = gql`
    mutation Mutation($email: String!, $temporaryPassword: String!) {
  adminSetTemporaryPassword(email: $email, temporaryPassword: $temporaryPassword) {
    id
    firstName
    lastName
  }
}
    `;
export type MutationMutationFn = Apollo.MutationFunction<MutationMutation, MutationMutationVariables>;

/**
 * __useMutationMutation__
 *
 * To run a mutation, you first call `useMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutationMutation, { data, loading, error }] = useMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      temporaryPassword: // value for 'temporaryPassword'
 *   },
 * });
 */
export function useMutationMutation(baseOptions?: Apollo.MutationHookOptions<MutationMutation, MutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutationMutation, MutationMutationVariables>(MutationDocument, options);
      }
export type MutationMutationHookResult = ReturnType<typeof useMutationMutation>;
export type MutationMutationResult = Apollo.MutationResult<MutationMutation>;
export type MutationMutationOptions = Apollo.BaseMutationOptions<MutationMutation, MutationMutationVariables>;
export const AggregateMoodByDayOfPatientDocument = gql`
    query AggregateMoodByDayOfPatient($patientId: ID!, $filter: AggregateMoodByDayFilter) {
  aggregateMoodByDayOfPatient(patientId: $patientId, filter: $filter) {
    year
    month
    day
    averageSelectedMood
    checkinCount
  }
}
    `;

/**
 * __useAggregateMoodByDayOfPatientQuery__
 *
 * To run a query within a React component, call `useAggregateMoodByDayOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateMoodByDayOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateMoodByDayOfPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAggregateMoodByDayOfPatientQuery(baseOptions: Apollo.QueryHookOptions<AggregateMoodByDayOfPatientQuery, AggregateMoodByDayOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregateMoodByDayOfPatientQuery, AggregateMoodByDayOfPatientQueryVariables>(AggregateMoodByDayOfPatientDocument, options);
      }
export function useAggregateMoodByDayOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregateMoodByDayOfPatientQuery, AggregateMoodByDayOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregateMoodByDayOfPatientQuery, AggregateMoodByDayOfPatientQueryVariables>(AggregateMoodByDayOfPatientDocument, options);
        }
export type AggregateMoodByDayOfPatientQueryHookResult = ReturnType<typeof useAggregateMoodByDayOfPatientQuery>;
export type AggregateMoodByDayOfPatientLazyQueryHookResult = ReturnType<typeof useAggregateMoodByDayOfPatientLazyQuery>;
export type AggregateMoodByDayOfPatientQueryResult = Apollo.QueryResult<AggregateMoodByDayOfPatientQuery, AggregateMoodByDayOfPatientQueryVariables>;
export const MoodStatisticsOfPatientDocument = gql`
    query MoodStatisticsOfPatient($patientId: ID!, $filter: MoodResponseFilter) {
  moodStatisticsOfPatient(patientId: $patientId, filter: $filter) {
    averageSelectedMood
    mostSelectedEmotions {
      count
      emotions {
        id
        text
      }
    }
  }
}
    `;

/**
 * __useMoodStatisticsOfPatientQuery__
 *
 * To run a query within a React component, call `useMoodStatisticsOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoodStatisticsOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoodStatisticsOfPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMoodStatisticsOfPatientQuery(baseOptions: Apollo.QueryHookOptions<MoodStatisticsOfPatientQuery, MoodStatisticsOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoodStatisticsOfPatientQuery, MoodStatisticsOfPatientQueryVariables>(MoodStatisticsOfPatientDocument, options);
      }
export function useMoodStatisticsOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoodStatisticsOfPatientQuery, MoodStatisticsOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoodStatisticsOfPatientQuery, MoodStatisticsOfPatientQueryVariables>(MoodStatisticsOfPatientDocument, options);
        }
export type MoodStatisticsOfPatientQueryHookResult = ReturnType<typeof useMoodStatisticsOfPatientQuery>;
export type MoodStatisticsOfPatientLazyQueryHookResult = ReturnType<typeof useMoodStatisticsOfPatientLazyQuery>;
export type MoodStatisticsOfPatientQueryResult = Apollo.QueryResult<MoodStatisticsOfPatientQuery, MoodStatisticsOfPatientQueryVariables>;
export const OrganizationInvoicesDocument = gql`
    query OrganizationInvoices($filter: OrganizationInvoicesFilter) {
  organizationInvoices(filter: $filter) {
    id
    paymentDate
    paymentMethod
    stripePaymentId
    stripePaymentStatus
    stripeProcessingFee
    refundDate
    refundMethod
    stripeRefundStatus
    stripeRefundId
    invoiceNumber
    updatedAt
    createdAt
    state
    organization {
      id
    }
    patient {
      id
      firstName
      lastName
      avatarUrl
      receiveAutomaticInvoice
    }
    amount
  }
}
    `;

/**
 * __useOrganizationInvoicesQuery__
 *
 * To run a query within a React component, call `useOrganizationInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>(OrganizationInvoicesDocument, options);
      }
export function useOrganizationInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>(OrganizationInvoicesDocument, options);
        }
export type OrganizationInvoicesQueryHookResult = ReturnType<typeof useOrganizationInvoicesQuery>;
export type OrganizationInvoicesLazyQueryHookResult = ReturnType<typeof useOrganizationInvoicesLazyQuery>;
export type OrganizationInvoicesQueryResult = Apollo.QueryResult<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>;
export const InvoicePdfUrlDocument = gql`
    query InvoicePdfUrl($invoiceId: ID!) {
  invoicePdfUrl(invoiceId: $invoiceId)
}
    `;

/**
 * __useInvoicePdfUrlQuery__
 *
 * To run a query within a React component, call `useInvoicePdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePdfUrlQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicePdfUrlQuery(baseOptions: Apollo.QueryHookOptions<InvoicePdfUrlQuery, InvoicePdfUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePdfUrlQuery, InvoicePdfUrlQueryVariables>(InvoicePdfUrlDocument, options);
      }
export function useInvoicePdfUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePdfUrlQuery, InvoicePdfUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePdfUrlQuery, InvoicePdfUrlQueryVariables>(InvoicePdfUrlDocument, options);
        }
export type InvoicePdfUrlQueryHookResult = ReturnType<typeof useInvoicePdfUrlQuery>;
export type InvoicePdfUrlLazyQueryHookResult = ReturnType<typeof useInvoicePdfUrlLazyQuery>;
export type InvoicePdfUrlQueryResult = Apollo.QueryResult<InvoicePdfUrlQuery, InvoicePdfUrlQueryVariables>;
export const PayInvoiceDocument = gql`
    mutation PayInvoice($invoiceId: ID!, $paymentMethod: PaymentMethod!, $paymentDate: Date) {
  payInvoice(
    invoiceId: $invoiceId
    paymentMethod: $paymentMethod
    paymentDate: $paymentDate
  ) {
    id
  }
}
    `;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentMethod: // value for 'paymentMethod'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<PayInvoiceMutation, PayInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($invoiceId: ID!) {
  deleteInvoice(invoiceId: $invoiceId)
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const RefundInvoiceDocument = gql`
    mutation RefundInvoice($invoiceId: ID!, $refundDate: Date, $refundMethod: PaymentMethod!) {
  refundInvoice(
    invoiceId: $invoiceId
    refundDate: $refundDate
    refundMethod: $refundMethod
  ) {
    id
  }
}
    `;
export type RefundInvoiceMutationFn = Apollo.MutationFunction<RefundInvoiceMutation, RefundInvoiceMutationVariables>;

/**
 * __useRefundInvoiceMutation__
 *
 * To run a mutation, you first call `useRefundInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundInvoiceMutation, { data, loading, error }] = useRefundInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      refundDate: // value for 'refundDate'
 *      refundMethod: // value for 'refundMethod'
 *   },
 * });
 */
export function useRefundInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RefundInvoiceMutation, RefundInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundInvoiceMutation, RefundInvoiceMutationVariables>(RefundInvoiceDocument, options);
      }
export type RefundInvoiceMutationHookResult = ReturnType<typeof useRefundInvoiceMutation>;
export type RefundInvoiceMutationResult = Apollo.MutationResult<RefundInvoiceMutation>;
export type RefundInvoiceMutationOptions = Apollo.BaseMutationOptions<RefundInvoiceMutation, RefundInvoiceMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($sessionId: ID!, $patientId: ID!) {
  createInvoice(sessionId: $sessionId, patientId: $patientId) {
    id
  }
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const AdminCreateDoctorDocument = gql`
    mutation AdminCreateDoctor($firstName: String!, $lastName: String!, $email: String!, $temporaryPassword: String!) {
  adminCreateDoctor(
    firstName: $firstName
    lastName: $lastName
    email: $email
    temporaryPassword: $temporaryPassword
  ) {
    id
  }
}
    `;
export type AdminCreateDoctorMutationFn = Apollo.MutationFunction<AdminCreateDoctorMutation, AdminCreateDoctorMutationVariables>;

/**
 * __useAdminCreateDoctorMutation__
 *
 * To run a mutation, you first call `useAdminCreateDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDoctorMutation, { data, loading, error }] = useAdminCreateDoctorMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      temporaryPassword: // value for 'temporaryPassword'
 *   },
 * });
 */
export function useAdminCreateDoctorMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDoctorMutation, AdminCreateDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDoctorMutation, AdminCreateDoctorMutationVariables>(AdminCreateDoctorDocument, options);
      }
export type AdminCreateDoctorMutationHookResult = ReturnType<typeof useAdminCreateDoctorMutation>;
export type AdminCreateDoctorMutationResult = Apollo.MutationResult<AdminCreateDoctorMutation>;
export type AdminCreateDoctorMutationOptions = Apollo.BaseMutationOptions<AdminCreateDoctorMutation, AdminCreateDoctorMutationVariables>;
export const SetupOrganizationStripeAccountDocument = gql`
    mutation SetupOrganizationStripeAccount($urlPath: String) {
  setupOrganizationStripeAccount(urlPath: $urlPath)
}
    `;
export type SetupOrganizationStripeAccountMutationFn = Apollo.MutationFunction<SetupOrganizationStripeAccountMutation, SetupOrganizationStripeAccountMutationVariables>;

/**
 * __useSetupOrganizationStripeAccountMutation__
 *
 * To run a mutation, you first call `useSetupOrganizationStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupOrganizationStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupOrganizationStripeAccountMutation, { data, loading, error }] = useSetupOrganizationStripeAccountMutation({
 *   variables: {
 *      urlPath: // value for 'urlPath'
 *   },
 * });
 */
export function useSetupOrganizationStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<SetupOrganizationStripeAccountMutation, SetupOrganizationStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupOrganizationStripeAccountMutation, SetupOrganizationStripeAccountMutationVariables>(SetupOrganizationStripeAccountDocument, options);
      }
export type SetupOrganizationStripeAccountMutationHookResult = ReturnType<typeof useSetupOrganizationStripeAccountMutation>;
export type SetupOrganizationStripeAccountMutationResult = Apollo.MutationResult<SetupOrganizationStripeAccountMutation>;
export type SetupOrganizationStripeAccountMutationOptions = Apollo.BaseMutationOptions<SetupOrganizationStripeAccountMutation, SetupOrganizationStripeAccountMutationVariables>;
export const OrganizationStripeAccountDocument = gql`
    query OrganizationStripeAccount {
  organizationStripeAccount {
    pastDue
    currentlyDue
    currentDeadLine
    accountHolderName
    bankName
    routingNumber
    last4
  }
}
    `;

/**
 * __useOrganizationStripeAccountQuery__
 *
 * To run a query within a React component, call `useOrganizationStripeAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStripeAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStripeAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationStripeAccountQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationStripeAccountQuery, OrganizationStripeAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationStripeAccountQuery, OrganizationStripeAccountQueryVariables>(OrganizationStripeAccountDocument, options);
      }
export function useOrganizationStripeAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStripeAccountQuery, OrganizationStripeAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationStripeAccountQuery, OrganizationStripeAccountQueryVariables>(OrganizationStripeAccountDocument, options);
        }
export type OrganizationStripeAccountQueryHookResult = ReturnType<typeof useOrganizationStripeAccountQuery>;
export type OrganizationStripeAccountLazyQueryHookResult = ReturnType<typeof useOrganizationStripeAccountLazyQuery>;
export type OrganizationStripeAccountQueryResult = Apollo.QueryResult<OrganizationStripeAccountQuery, OrganizationStripeAccountQueryVariables>;
export const AddPatientStripeCreditCardDocument = gql`
    mutation AddPatientStripeCreditCard($stripeTokenId: String!, $patientId: String!) {
  addPatientStripeCreditCard(stripeTokenId: $stripeTokenId, patientId: $patientId)
}
    `;
export type AddPatientStripeCreditCardMutationFn = Apollo.MutationFunction<AddPatientStripeCreditCardMutation, AddPatientStripeCreditCardMutationVariables>;

/**
 * __useAddPatientStripeCreditCardMutation__
 *
 * To run a mutation, you first call `useAddPatientStripeCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientStripeCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientStripeCreditCardMutation, { data, loading, error }] = useAddPatientStripeCreditCardMutation({
 *   variables: {
 *      stripeTokenId: // value for 'stripeTokenId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAddPatientStripeCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientStripeCreditCardMutation, AddPatientStripeCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientStripeCreditCardMutation, AddPatientStripeCreditCardMutationVariables>(AddPatientStripeCreditCardDocument, options);
      }
export type AddPatientStripeCreditCardMutationHookResult = ReturnType<typeof useAddPatientStripeCreditCardMutation>;
export type AddPatientStripeCreditCardMutationResult = Apollo.MutationResult<AddPatientStripeCreditCardMutation>;
export type AddPatientStripeCreditCardMutationOptions = Apollo.BaseMutationOptions<AddPatientStripeCreditCardMutation, AddPatientStripeCreditCardMutationVariables>;
export const PatientStripeCreditCardsDocument = gql`
    query PatientStripeCreditCards($patientId: String!) {
  patientStripeCreditCards(patientId: $patientId) {
    id
    brand
    expMonth
    expYear
    last4
  }
}
    `;

/**
 * __usePatientStripeCreditCardsQuery__
 *
 * To run a query within a React component, call `usePatientStripeCreditCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientStripeCreditCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientStripeCreditCardsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientStripeCreditCardsQuery(baseOptions: Apollo.QueryHookOptions<PatientStripeCreditCardsQuery, PatientStripeCreditCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientStripeCreditCardsQuery, PatientStripeCreditCardsQueryVariables>(PatientStripeCreditCardsDocument, options);
      }
export function usePatientStripeCreditCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientStripeCreditCardsQuery, PatientStripeCreditCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientStripeCreditCardsQuery, PatientStripeCreditCardsQueryVariables>(PatientStripeCreditCardsDocument, options);
        }
export type PatientStripeCreditCardsQueryHookResult = ReturnType<typeof usePatientStripeCreditCardsQuery>;
export type PatientStripeCreditCardsLazyQueryHookResult = ReturnType<typeof usePatientStripeCreditCardsLazyQuery>;
export type PatientStripeCreditCardsQueryResult = Apollo.QueryResult<PatientStripeCreditCardsQuery, PatientStripeCreditCardsQueryVariables>;
export const UpdatePatientStripeCreditCardDocument = gql`
    mutation UpdatePatientStripeCreditCard($patientId: String!, $cardId: String!, $expYear: String, $expMonth: String) {
  updatePatientStripeCreditCard(
    patientId: $patientId
    cardId: $cardId
    expYear: $expYear
    expMonth: $expMonth
  )
}
    `;
export type UpdatePatientStripeCreditCardMutationFn = Apollo.MutationFunction<UpdatePatientStripeCreditCardMutation, UpdatePatientStripeCreditCardMutationVariables>;

/**
 * __useUpdatePatientStripeCreditCardMutation__
 *
 * To run a mutation, you first call `useUpdatePatientStripeCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientStripeCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientStripeCreditCardMutation, { data, loading, error }] = useUpdatePatientStripeCreditCardMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      cardId: // value for 'cardId'
 *      expYear: // value for 'expYear'
 *      expMonth: // value for 'expMonth'
 *   },
 * });
 */
export function useUpdatePatientStripeCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientStripeCreditCardMutation, UpdatePatientStripeCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientStripeCreditCardMutation, UpdatePatientStripeCreditCardMutationVariables>(UpdatePatientStripeCreditCardDocument, options);
      }
export type UpdatePatientStripeCreditCardMutationHookResult = ReturnType<typeof useUpdatePatientStripeCreditCardMutation>;
export type UpdatePatientStripeCreditCardMutationResult = Apollo.MutationResult<UpdatePatientStripeCreditCardMutation>;
export type UpdatePatientStripeCreditCardMutationOptions = Apollo.BaseMutationOptions<UpdatePatientStripeCreditCardMutation, UpdatePatientStripeCreditCardMutationVariables>;
export const DeletePatientStripeCreditCardDocument = gql`
    mutation DeletePatientStripeCreditCard($patientId: String!, $cardId: String!) {
  deletePatientStripeCreditCard(patientId: $patientId, cardId: $cardId)
}
    `;
export type DeletePatientStripeCreditCardMutationFn = Apollo.MutationFunction<DeletePatientStripeCreditCardMutation, DeletePatientStripeCreditCardMutationVariables>;

/**
 * __useDeletePatientStripeCreditCardMutation__
 *
 * To run a mutation, you first call `useDeletePatientStripeCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientStripeCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientStripeCreditCardMutation, { data, loading, error }] = useDeletePatientStripeCreditCardMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useDeletePatientStripeCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientStripeCreditCardMutation, DeletePatientStripeCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientStripeCreditCardMutation, DeletePatientStripeCreditCardMutationVariables>(DeletePatientStripeCreditCardDocument, options);
      }
export type DeletePatientStripeCreditCardMutationHookResult = ReturnType<typeof useDeletePatientStripeCreditCardMutation>;
export type DeletePatientStripeCreditCardMutationResult = Apollo.MutationResult<DeletePatientStripeCreditCardMutation>;
export type DeletePatientStripeCreditCardMutationOptions = Apollo.BaseMutationOptions<DeletePatientStripeCreditCardMutation, DeletePatientStripeCreditCardMutationVariables>;
export const PayInvoiceOnlineDocument = gql`
    mutation PayInvoiceOnline($invoiceId: ID!, $cardId: String!) {
  payInvoiceOnline(invoiceId: $invoiceId, cardId: $cardId) {
    id
  }
}
    `;
export type PayInvoiceOnlineMutationFn = Apollo.MutationFunction<PayInvoiceOnlineMutation, PayInvoiceOnlineMutationVariables>;

/**
 * __usePayInvoiceOnlineMutation__
 *
 * To run a mutation, you first call `usePayInvoiceOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceOnlineMutation, { data, loading, error }] = usePayInvoiceOnlineMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function usePayInvoiceOnlineMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceOnlineMutation, PayInvoiceOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceOnlineMutation, PayInvoiceOnlineMutationVariables>(PayInvoiceOnlineDocument, options);
      }
export type PayInvoiceOnlineMutationHookResult = ReturnType<typeof usePayInvoiceOnlineMutation>;
export type PayInvoiceOnlineMutationResult = Apollo.MutationResult<PayInvoiceOnlineMutation>;
export type PayInvoiceOnlineMutationOptions = Apollo.BaseMutationOptions<PayInvoiceOnlineMutation, PayInvoiceOnlineMutationVariables>;
export const RefundInvoiceOnlineDocument = gql`
    mutation RefundInvoiceOnline($invoiceId: ID!, $refundReason: StripeRefundReason) {
  refundInvoiceOnline(invoiceId: $invoiceId, refundReason: $refundReason) {
    id
  }
}
    `;
export type RefundInvoiceOnlineMutationFn = Apollo.MutationFunction<RefundInvoiceOnlineMutation, RefundInvoiceOnlineMutationVariables>;

/**
 * __useRefundInvoiceOnlineMutation__
 *
 * To run a mutation, you first call `useRefundInvoiceOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundInvoiceOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundInvoiceOnlineMutation, { data, loading, error }] = useRefundInvoiceOnlineMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      refundReason: // value for 'refundReason'
 *   },
 * });
 */
export function useRefundInvoiceOnlineMutation(baseOptions?: Apollo.MutationHookOptions<RefundInvoiceOnlineMutation, RefundInvoiceOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundInvoiceOnlineMutation, RefundInvoiceOnlineMutationVariables>(RefundInvoiceOnlineDocument, options);
      }
export type RefundInvoiceOnlineMutationHookResult = ReturnType<typeof useRefundInvoiceOnlineMutation>;
export type RefundInvoiceOnlineMutationResult = Apollo.MutationResult<RefundInvoiceOnlineMutation>;
export type RefundInvoiceOnlineMutationOptions = Apollo.BaseMutationOptions<RefundInvoiceOnlineMutation, RefundInvoiceOnlineMutationVariables>;
export const CreateCmsFormDocument = gql`
    mutation CreateCMSForm($sessionIds: [ID]!, $patientId: ID!, $data: CMSFormDataInput!) {
  createCMSForm(sessionIds: $sessionIds, patientId: $patientId, data: $data) {
    id
  }
}
    `;
export type CreateCmsFormMutationFn = Apollo.MutationFunction<CreateCmsFormMutation, CreateCmsFormMutationVariables>;

/**
 * __useCreateCmsFormMutation__
 *
 * To run a mutation, you first call `useCreateCmsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCmsFormMutation, { data, loading, error }] = useCreateCmsFormMutation({
 *   variables: {
 *      sessionIds: // value for 'sessionIds'
 *      patientId: // value for 'patientId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCmsFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateCmsFormMutation, CreateCmsFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCmsFormMutation, CreateCmsFormMutationVariables>(CreateCmsFormDocument, options);
      }
export type CreateCmsFormMutationHookResult = ReturnType<typeof useCreateCmsFormMutation>;
export type CreateCmsFormMutationResult = Apollo.MutationResult<CreateCmsFormMutation>;
export type CreateCmsFormMutationOptions = Apollo.BaseMutationOptions<CreateCmsFormMutation, CreateCmsFormMutationVariables>;
export const UpdateCmsFormDocument = gql`
    mutation UpdateCMSForm($cmsFormId: ID!, $data: CMSFormDataInput!, $sessionIds: [ID]) {
  updateCMSForm(cmsFormId: $cmsFormId, data: $data, sessionIds: $sessionIds) {
    id
  }
}
    `;
export type UpdateCmsFormMutationFn = Apollo.MutationFunction<UpdateCmsFormMutation, UpdateCmsFormMutationVariables>;

/**
 * __useUpdateCmsFormMutation__
 *
 * To run a mutation, you first call `useUpdateCmsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsFormMutation, { data, loading, error }] = useUpdateCmsFormMutation({
 *   variables: {
 *      cmsFormId: // value for 'cmsFormId'
 *      data: // value for 'data'
 *      sessionIds: // value for 'sessionIds'
 *   },
 * });
 */
export function useUpdateCmsFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsFormMutation, UpdateCmsFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsFormMutation, UpdateCmsFormMutationVariables>(UpdateCmsFormDocument, options);
      }
export type UpdateCmsFormMutationHookResult = ReturnType<typeof useUpdateCmsFormMutation>;
export type UpdateCmsFormMutationResult = Apollo.MutationResult<UpdateCmsFormMutation>;
export type UpdateCmsFormMutationOptions = Apollo.BaseMutationOptions<UpdateCmsFormMutation, UpdateCmsFormMutationVariables>;
export const UpdateCmsFormStateDocument = gql`
    mutation UpdateCMSFormState($cmsFormId: ID!, $state: CMSFormState!) {
  updateCMSFormState(cmsFormId: $cmsFormId, state: $state) {
    id
  }
}
    `;
export type UpdateCmsFormStateMutationFn = Apollo.MutationFunction<UpdateCmsFormStateMutation, UpdateCmsFormStateMutationVariables>;

/**
 * __useUpdateCmsFormStateMutation__
 *
 * To run a mutation, you first call `useUpdateCmsFormStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmsFormStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCmsFormStateMutation, { data, loading, error }] = useUpdateCmsFormStateMutation({
 *   variables: {
 *      cmsFormId: // value for 'cmsFormId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateCmsFormStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCmsFormStateMutation, UpdateCmsFormStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCmsFormStateMutation, UpdateCmsFormStateMutationVariables>(UpdateCmsFormStateDocument, options);
      }
export type UpdateCmsFormStateMutationHookResult = ReturnType<typeof useUpdateCmsFormStateMutation>;
export type UpdateCmsFormStateMutationResult = Apollo.MutationResult<UpdateCmsFormStateMutation>;
export type UpdateCmsFormStateMutationOptions = Apollo.BaseMutationOptions<UpdateCmsFormStateMutation, UpdateCmsFormStateMutationVariables>;
export const DeleteCmsFormDocument = gql`
    mutation DeleteCMSForm($cmsFormId: ID!) {
  deleteCMSForm(cmsFormId: $cmsFormId)
}
    `;
export type DeleteCmsFormMutationFn = Apollo.MutationFunction<DeleteCmsFormMutation, DeleteCmsFormMutationVariables>;

/**
 * __useDeleteCmsFormMutation__
 *
 * To run a mutation, you first call `useDeleteCmsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCmsFormMutation, { data, loading, error }] = useDeleteCmsFormMutation({
 *   variables: {
 *      cmsFormId: // value for 'cmsFormId'
 *   },
 * });
 */
export function useDeleteCmsFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCmsFormMutation, DeleteCmsFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCmsFormMutation, DeleteCmsFormMutationVariables>(DeleteCmsFormDocument, options);
      }
export type DeleteCmsFormMutationHookResult = ReturnType<typeof useDeleteCmsFormMutation>;
export type DeleteCmsFormMutationResult = Apollo.MutationResult<DeleteCmsFormMutation>;
export type DeleteCmsFormMutationOptions = Apollo.BaseMutationOptions<DeleteCmsFormMutation, DeleteCmsFormMutationVariables>;
export const OrganizationCmsFormsDocument = gql`
    query OrganizationCMSForms($filter: OrganizationCMSFormsFilter) {
  organizationCMSForms(filter: $filter) {
    id
    patient {
      lastName
      firstName
    }
    sessions {
      startDate
    }
    state
    data {
      insuranceName
      insuranceAddress1
      insuranceAddress2
      insuranceCity
      insuranceState
      insuranceZipCode
      insuranceMemberId
      insuranceType
      patientName
      patientDateOfBirth
      patientGender
      patientAddress
      patientCity
      patientState
      patientZipCode
      patientPhoneNumber
      patientRelationToInsured
      patientAccountNumber
      insuredName
      insuredAddress
      insuredCity
      insuredState
      insuredZipCode
      insuredPhoneNumber
      insuredPolicyGroup
      insuredDateOfBirth
      insuredGender
      insuredInsuranceName
      isOtherInsuranceAvailable
      otherInsuredName
      otherInsuredMemberId
      otherInsuredInsuranceName
      isEmploymentRelated
      isAutoAccident
      autoAccidentState
      isOtherAccident
      claimCodes
      isWithInsuredSignatureOnFile
      dateOfCurrentIllness
      currentIllnessId
      otherDate
      unableToWorkDateFrom
      unableToWorkDateTo
      referringProviderId
      referringProviderName
      referringProviderSecondaryIdType
      referringProviderSecondaryId
      referringProviderNpi
      hospitalizationDateFrom
      hospitalizationDateTo
      additionalClaimInformation
      isOutsideLab
      outsideLabCharges
      icdInd
      diagnoses
      resubmissionCode
      originalRefNum
      authorizationNumber
      services {
        dateFrom
        dateTo
        placeOfService
        isEmergency
        cptCode
        modifier1
        modifier2
        modifier3
        modifier4
        diagnosis
        charges
        units
        epsdt
        provider
      }
      taxFederationId
      taxFederationIdType
      assignmentAccepted
      amountPaid
      signatureDate
      facilityName
      facilityAddress1
      facilityAddress2
      facilityCity
      facilityState
      facilityZipCode
      facilityNpi
      providerName
      providerAddress1
      providerAddress2
      providerCity
      providerState
      providerZipCode
      providerPhoneNumber
      providerNpi
      providerTaxonomyCode
      createdAt
    }
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useOrganizationCmsFormsQuery__
 *
 * To run a query within a React component, call `useOrganizationCmsFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCmsFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCmsFormsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationCmsFormsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationCmsFormsQuery, OrganizationCmsFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCmsFormsQuery, OrganizationCmsFormsQueryVariables>(OrganizationCmsFormsDocument, options);
      }
export function useOrganizationCmsFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCmsFormsQuery, OrganizationCmsFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCmsFormsQuery, OrganizationCmsFormsQueryVariables>(OrganizationCmsFormsDocument, options);
        }
export type OrganizationCmsFormsQueryHookResult = ReturnType<typeof useOrganizationCmsFormsQuery>;
export type OrganizationCmsFormsLazyQueryHookResult = ReturnType<typeof useOrganizationCmsFormsLazyQuery>;
export type OrganizationCmsFormsQueryResult = Apollo.QueryResult<OrganizationCmsFormsQuery, OrganizationCmsFormsQueryVariables>;
export const CmsFormHistoryDocument = gql`
    query CmsFormHistory($cmsFormId: ID!, $filter: CMSFormHistoryFilter) {
  cmsFormHistory(cmsFormId: $cmsFormId, filter: $filter) {
    id
    cmsFormId
    state
    data {
      insuranceName
      insuranceAddress1
      insuranceAddress2
      insuranceCity
      insuranceState
      insuranceZipCode
      insuranceMemberId
      insuranceType
      patientName
      patientDateOfBirth
      patientGender
      patientAddress
      patientCity
      patientState
      patientZipCode
      patientPhoneNumber
      patientRelationToInsured
      patientAccountNumber
      insuredName
      insuredAddress
      insuredCity
      insuredState
      insuredZipCode
      insuredPhoneNumber
      insuredPolicyGroup
      insuredDateOfBirth
      insuredGender
      insuredInsuranceName
      isOtherInsuranceAvailable
      otherInsuredName
      otherInsuredMemberId
      otherInsuredInsuranceName
      isEmploymentRelated
      isAutoAccident
      autoAccidentState
      isOtherAccident
      claimCodes
      isWithInsuredSignatureOnFile
      dateOfCurrentIllness
      currentIllnessId
      otherDate
      unableToWorkDateFrom
      unableToWorkDateTo
      referringProviderId
      referringProviderName
      referringProviderSecondaryIdType
      referringProviderSecondaryId
      referringProviderNpi
      hospitalizationDateFrom
      hospitalizationDateTo
      additionalClaimInformation
      isOutsideLab
      outsideLabCharges
      icdInd
      diagnoses
      resubmissionCode
      originalRefNum
      authorizationNumber
      services {
        dateFrom
        dateTo
        placeOfService
        isEmergency
        cptCode
        modifier1
        modifier2
        modifier3
        modifier4
        diagnosis
        charges
        units
        epsdt
        provider
      }
      taxFederationId
      taxFederationIdType
      assignmentAccepted
      amountPaid
      signatureDate
      facilityName
      facilityAddress1
      facilityAddress2
      facilityCity
      facilityState
      facilityZipCode
      facilityNpi
      providerName
      providerAddress1
      providerAddress2
      providerCity
      providerState
      providerZipCode
      providerPhoneNumber
      providerNpi
      providerTaxonomyCode
      createdAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCmsFormHistoryQuery__
 *
 * To run a query within a React component, call `useCmsFormHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsFormHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsFormHistoryQuery({
 *   variables: {
 *      cmsFormId: // value for 'cmsFormId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCmsFormHistoryQuery(baseOptions: Apollo.QueryHookOptions<CmsFormHistoryQuery, CmsFormHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsFormHistoryQuery, CmsFormHistoryQueryVariables>(CmsFormHistoryDocument, options);
      }
export function useCmsFormHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsFormHistoryQuery, CmsFormHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsFormHistoryQuery, CmsFormHistoryQueryVariables>(CmsFormHistoryDocument, options);
        }
export type CmsFormHistoryQueryHookResult = ReturnType<typeof useCmsFormHistoryQuery>;
export type CmsFormHistoryLazyQueryHookResult = ReturnType<typeof useCmsFormHistoryLazyQuery>;
export type CmsFormHistoryQueryResult = Apollo.QueryResult<CmsFormHistoryQuery, CmsFormHistoryQueryVariables>;
export const CreateOrUpdatePatientInsuranceDocument = gql`
    mutation CreateOrUpdatePatientInsurance($insuranceId: ID, $patientId: ID, $data: InsuranceDataInput!) {
  createOrUpdatePatientInsurance(
    insuranceId: $insuranceId
    patientId: $patientId
    data: $data
  ) {
    id
  }
}
    `;
export type CreateOrUpdatePatientInsuranceMutationFn = Apollo.MutationFunction<CreateOrUpdatePatientInsuranceMutation, CreateOrUpdatePatientInsuranceMutationVariables>;

/**
 * __useCreateOrUpdatePatientInsuranceMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePatientInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePatientInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePatientInsuranceMutation, { data, loading, error }] = useCreateOrUpdatePatientInsuranceMutation({
 *   variables: {
 *      insuranceId: // value for 'insuranceId'
 *      patientId: // value for 'patientId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdatePatientInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePatientInsuranceMutation, CreateOrUpdatePatientInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePatientInsuranceMutation, CreateOrUpdatePatientInsuranceMutationVariables>(CreateOrUpdatePatientInsuranceDocument, options);
      }
export type CreateOrUpdatePatientInsuranceMutationHookResult = ReturnType<typeof useCreateOrUpdatePatientInsuranceMutation>;
export type CreateOrUpdatePatientInsuranceMutationResult = Apollo.MutationResult<CreateOrUpdatePatientInsuranceMutation>;
export type CreateOrUpdatePatientInsuranceMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePatientInsuranceMutation, CreateOrUpdatePatientInsuranceMutationVariables>;
export const UpdatePatientInsuranceImageDocument = gql`
    mutation UpdatePatientInsuranceImage($insuranceId: ID!, $base64: String!, $side: ImageSide!) {
  updatePatientInsuranceImage(
    insuranceId: $insuranceId
    base64: $base64
    side: $side
  ) {
    id
    insuranceFrontImage
    insuranceBackImage
  }
}
    `;
export type UpdatePatientInsuranceImageMutationFn = Apollo.MutationFunction<UpdatePatientInsuranceImageMutation, UpdatePatientInsuranceImageMutationVariables>;

/**
 * __useUpdatePatientInsuranceImageMutation__
 *
 * To run a mutation, you first call `useUpdatePatientInsuranceImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientInsuranceImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientInsuranceImageMutation, { data, loading, error }] = useUpdatePatientInsuranceImageMutation({
 *   variables: {
 *      insuranceId: // value for 'insuranceId'
 *      base64: // value for 'base64'
 *      side: // value for 'side'
 *   },
 * });
 */
export function useUpdatePatientInsuranceImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientInsuranceImageMutation, UpdatePatientInsuranceImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientInsuranceImageMutation, UpdatePatientInsuranceImageMutationVariables>(UpdatePatientInsuranceImageDocument, options);
      }
export type UpdatePatientInsuranceImageMutationHookResult = ReturnType<typeof useUpdatePatientInsuranceImageMutation>;
export type UpdatePatientInsuranceImageMutationResult = Apollo.MutationResult<UpdatePatientInsuranceImageMutation>;
export type UpdatePatientInsuranceImageMutationOptions = Apollo.BaseMutationOptions<UpdatePatientInsuranceImageMutation, UpdatePatientInsuranceImageMutationVariables>;
export const DeletePatientInsuranceDocument = gql`
    mutation DeletePatientInsurance($insuranceId: ID!) {
  deletePatientInsurance(insuranceId: $insuranceId)
}
    `;
export type DeletePatientInsuranceMutationFn = Apollo.MutationFunction<DeletePatientInsuranceMutation, DeletePatientInsuranceMutationVariables>;

/**
 * __useDeletePatientInsuranceMutation__
 *
 * To run a mutation, you first call `useDeletePatientInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientInsuranceMutation, { data, loading, error }] = useDeletePatientInsuranceMutation({
 *   variables: {
 *      insuranceId: // value for 'insuranceId'
 *   },
 * });
 */
export function useDeletePatientInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientInsuranceMutation, DeletePatientInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientInsuranceMutation, DeletePatientInsuranceMutationVariables>(DeletePatientInsuranceDocument, options);
      }
export type DeletePatientInsuranceMutationHookResult = ReturnType<typeof useDeletePatientInsuranceMutation>;
export type DeletePatientInsuranceMutationResult = Apollo.MutationResult<DeletePatientInsuranceMutation>;
export type DeletePatientInsuranceMutationOptions = Apollo.BaseMutationOptions<DeletePatientInsuranceMutation, DeletePatientInsuranceMutationVariables>;
export const PatientInsurancesDocument = gql`
    query PatientInsurances($patientId: ID!, $filter: PatientInsuranceFilter) {
  patientInsurances(patientId: $patientId, filter: $filter) {
    id
    patient {
      id
    }
    patientRelationToInsured
    insuranceType
    insurancePayerId
    insuranceName
    insuranceAddress1
    insuranceAddress2
    insuranceCity
    insuranceState
    insuranceZipCode
    insuredFirstName
    insuredLastName
    insuredMiddleName
    insuredAddress1
    insuredAddress2
    insuredCity
    insuredState
    insuredZipCode
    insuredPhoneNumber
    insuredDateOfBirth
    insuredGender
    policyMemberId
    policyGroupId
    policyPlanId
    policyCopay
    policyDeductible
    policyMaximumAmount
    signatureOnFile
    acceptAssignment
    inactive
    createdAt
    updatedAt
    insuranceFrontImage
    insuranceBackImage
  }
}
    `;

/**
 * __usePatientInsurancesQuery__
 *
 * To run a query within a React component, call `usePatientInsurancesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientInsurancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientInsurancesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientInsurancesQuery(baseOptions: Apollo.QueryHookOptions<PatientInsurancesQuery, PatientInsurancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientInsurancesQuery, PatientInsurancesQueryVariables>(PatientInsurancesDocument, options);
      }
export function usePatientInsurancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientInsurancesQuery, PatientInsurancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientInsurancesQuery, PatientInsurancesQueryVariables>(PatientInsurancesDocument, options);
        }
export type PatientInsurancesQueryHookResult = ReturnType<typeof usePatientInsurancesQuery>;
export type PatientInsurancesLazyQueryHookResult = ReturnType<typeof usePatientInsurancesLazyQuery>;
export type PatientInsurancesQueryResult = Apollo.QueryResult<PatientInsurancesQuery, PatientInsurancesQueryVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($notificationIds: [ID!]!) {
  markNotificationsAsRead(notificationIds: $notificationIds)
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const OrganizationNotificationsDocument = gql`
    query OrganizationNotifications($filter: OrganizationNotificationsFilter) {
  organizationNotifications(filter: $filter) {
    id
    isRead
    senderUser {
      id
      firstName
      lastName
      avatarUrl
    }
    data {
      stressLevel
      anxietyLevel
      depressionLevel
      surveyType
      optionSlug
      form {
        id
        type
        title
      }
    }
    type
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useOrganizationNotificationsQuery__
 *
 * To run a query within a React component, call `useOrganizationNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNotificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationNotificationsQuery, OrganizationNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNotificationsQuery, OrganizationNotificationsQueryVariables>(OrganizationNotificationsDocument, options);
      }
export function useOrganizationNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNotificationsQuery, OrganizationNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNotificationsQuery, OrganizationNotificationsQueryVariables>(OrganizationNotificationsDocument, options);
        }
export type OrganizationNotificationsQueryHookResult = ReturnType<typeof useOrganizationNotificationsQuery>;
export type OrganizationNotificationsLazyQueryHookResult = ReturnType<typeof useOrganizationNotificationsLazyQuery>;
export type OrganizationNotificationsQueryResult = Apollo.QueryResult<OrganizationNotificationsQuery, OrganizationNotificationsQueryVariables>;
export const RequestToContactUmoreTeamDocument = gql`
    mutation RequestToContactUmoreTeam {
  requestToContactUmoreTeam
}
    `;
export type RequestToContactUmoreTeamMutationFn = Apollo.MutationFunction<RequestToContactUmoreTeamMutation, RequestToContactUmoreTeamMutationVariables>;

/**
 * __useRequestToContactUmoreTeamMutation__
 *
 * To run a mutation, you first call `useRequestToContactUmoreTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestToContactUmoreTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestToContactUmoreTeamMutation, { data, loading, error }] = useRequestToContactUmoreTeamMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestToContactUmoreTeamMutation(baseOptions?: Apollo.MutationHookOptions<RequestToContactUmoreTeamMutation, RequestToContactUmoreTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestToContactUmoreTeamMutation, RequestToContactUmoreTeamMutationVariables>(RequestToContactUmoreTeamDocument, options);
      }
export type RequestToContactUmoreTeamMutationHookResult = ReturnType<typeof useRequestToContactUmoreTeamMutation>;
export type RequestToContactUmoreTeamMutationResult = Apollo.MutationResult<RequestToContactUmoreTeamMutation>;
export type RequestToContactUmoreTeamMutationOptions = Apollo.BaseMutationOptions<RequestToContactUmoreTeamMutation, RequestToContactUmoreTeamMutationVariables>;
export const DeleteTestUserDocument = gql`
    mutation DeleteTestUser($userId: ID!) {
  deleteTestUser(userId: $userId) {
    id
  }
}
    `;
export type DeleteTestUserMutationFn = Apollo.MutationFunction<DeleteTestUserMutation, DeleteTestUserMutationVariables>;

/**
 * __useDeleteTestUserMutation__
 *
 * To run a mutation, you first call `useDeleteTestUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestUserMutation, { data, loading, error }] = useDeleteTestUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteTestUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestUserMutation, DeleteTestUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTestUserMutation, DeleteTestUserMutationVariables>(DeleteTestUserDocument, options);
      }
export type DeleteTestUserMutationHookResult = ReturnType<typeof useDeleteTestUserMutation>;
export type DeleteTestUserMutationResult = Apollo.MutationResult<DeleteTestUserMutation>;
export type DeleteTestUserMutationOptions = Apollo.BaseMutationOptions<DeleteTestUserMutation, DeleteTestUserMutationVariables>;
export const Generate2FaQrCodeUrlDocument = gql`
    mutation Generate2FAQrCodeUrl {
  generate2FAQrCodeUrl {
    otpAuthUrl
    twoFactorSecret
  }
}
    `;
export type Generate2FaQrCodeUrlMutationFn = Apollo.MutationFunction<Generate2FaQrCodeUrlMutation, Generate2FaQrCodeUrlMutationVariables>;

/**
 * __useGenerate2FaQrCodeUrlMutation__
 *
 * To run a mutation, you first call `useGenerate2FaQrCodeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerate2FaQrCodeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generate2FaQrCodeUrlMutation, { data, loading, error }] = useGenerate2FaQrCodeUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerate2FaQrCodeUrlMutation(baseOptions?: Apollo.MutationHookOptions<Generate2FaQrCodeUrlMutation, Generate2FaQrCodeUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Generate2FaQrCodeUrlMutation, Generate2FaQrCodeUrlMutationVariables>(Generate2FaQrCodeUrlDocument, options);
      }
export type Generate2FaQrCodeUrlMutationHookResult = ReturnType<typeof useGenerate2FaQrCodeUrlMutation>;
export type Generate2FaQrCodeUrlMutationResult = Apollo.MutationResult<Generate2FaQrCodeUrlMutation>;
export type Generate2FaQrCodeUrlMutationOptions = Apollo.BaseMutationOptions<Generate2FaQrCodeUrlMutation, Generate2FaQrCodeUrlMutationVariables>;
export const Enable2FaDocument = gql`
    mutation Enable2FA($code: String!) {
  enable2FA(code: $code)
}
    `;
export type Enable2FaMutationFn = Apollo.MutationFunction<Enable2FaMutation, Enable2FaMutationVariables>;

/**
 * __useEnable2FaMutation__
 *
 * To run a mutation, you first call `useEnable2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnable2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enable2FaMutation, { data, loading, error }] = useEnable2FaMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEnable2FaMutation(baseOptions?: Apollo.MutationHookOptions<Enable2FaMutation, Enable2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Enable2FaMutation, Enable2FaMutationVariables>(Enable2FaDocument, options);
      }
export type Enable2FaMutationHookResult = ReturnType<typeof useEnable2FaMutation>;
export type Enable2FaMutationResult = Apollo.MutationResult<Enable2FaMutation>;
export type Enable2FaMutationOptions = Apollo.BaseMutationOptions<Enable2FaMutation, Enable2FaMutationVariables>;
export const Verify2FaCodeAndLoginDocument = gql`
    mutation Verify2FACodeAndLogin($token: String!, $code: String!, $rememberMe: Boolean) {
  verify2FACodeAndLogin(token: $token, code: $code, rememberMe: $rememberMe) {
    token
  }
}
    `;
export type Verify2FaCodeAndLoginMutationFn = Apollo.MutationFunction<Verify2FaCodeAndLoginMutation, Verify2FaCodeAndLoginMutationVariables>;

/**
 * __useVerify2FaCodeAndLoginMutation__
 *
 * To run a mutation, you first call `useVerify2FaCodeAndLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerify2FaCodeAndLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verify2FaCodeAndLoginMutation, { data, loading, error }] = useVerify2FaCodeAndLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *      code: // value for 'code'
 *      rememberMe: // value for 'rememberMe'
 *   },
 * });
 */
export function useVerify2FaCodeAndLoginMutation(baseOptions?: Apollo.MutationHookOptions<Verify2FaCodeAndLoginMutation, Verify2FaCodeAndLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Verify2FaCodeAndLoginMutation, Verify2FaCodeAndLoginMutationVariables>(Verify2FaCodeAndLoginDocument, options);
      }
export type Verify2FaCodeAndLoginMutationHookResult = ReturnType<typeof useVerify2FaCodeAndLoginMutation>;
export type Verify2FaCodeAndLoginMutationResult = Apollo.MutationResult<Verify2FaCodeAndLoginMutation>;
export type Verify2FaCodeAndLoginMutationOptions = Apollo.BaseMutationOptions<Verify2FaCodeAndLoginMutation, Verify2FaCodeAndLoginMutationVariables>;
export const CreateOrganizationServiceDocument = gql`
    mutation CreateOrganizationService($cptCode: String!, $name: String, $fee: Float, $duration: Int, $isAddOn: Boolean, $isDefault: Boolean) {
  createOrganizationService(
    cptCode: $cptCode
    name: $name
    fee: $fee
    duration: $duration
    isAddOn: $isAddOn
    isDefault: $isDefault
  ) {
    id
    cptCode
    name
    fee
    duration
    isAddOn
    isDefault
    createdAt
    updatedAt
  }
}
    `;
export type CreateOrganizationServiceMutationFn = Apollo.MutationFunction<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>;

/**
 * __useCreateOrganizationServiceMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationServiceMutation, { data, loading, error }] = useCreateOrganizationServiceMutation({
 *   variables: {
 *      cptCode: // value for 'cptCode'
 *      name: // value for 'name'
 *      fee: // value for 'fee'
 *      duration: // value for 'duration'
 *      isAddOn: // value for 'isAddOn'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useCreateOrganizationServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>(CreateOrganizationServiceDocument, options);
      }
export type CreateOrganizationServiceMutationHookResult = ReturnType<typeof useCreateOrganizationServiceMutation>;
export type CreateOrganizationServiceMutationResult = Apollo.MutationResult<CreateOrganizationServiceMutation>;
export type CreateOrganizationServiceMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>;
export const UpdateOrganizationServiceDocument = gql`
    mutation UpdateOrganizationService($organizationServiceId: ID!, $name: String, $fee: Float, $duration: Int, $isAddOn: Boolean, $isDefault: Boolean) {
  updateOrganizationService(
    organizationServiceId: $organizationServiceId
    name: $name
    fee: $fee
    duration: $duration
    isAddOn: $isAddOn
    isDefault: $isDefault
  ) {
    id
    organization {
      id
    }
    cptCode
    name
    fee
    duration
    isAddOn
    isDefault
    createdAt
    updatedAt
  }
}
    `;
export type UpdateOrganizationServiceMutationFn = Apollo.MutationFunction<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>;

/**
 * __useUpdateOrganizationServiceMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationServiceMutation, { data, loading, error }] = useUpdateOrganizationServiceMutation({
 *   variables: {
 *      organizationServiceId: // value for 'organizationServiceId'
 *      name: // value for 'name'
 *      fee: // value for 'fee'
 *      duration: // value for 'duration'
 *      isAddOn: // value for 'isAddOn'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useUpdateOrganizationServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>(UpdateOrganizationServiceDocument, options);
      }
export type UpdateOrganizationServiceMutationHookResult = ReturnType<typeof useUpdateOrganizationServiceMutation>;
export type UpdateOrganizationServiceMutationResult = Apollo.MutationResult<UpdateOrganizationServiceMutation>;
export type UpdateOrganizationServiceMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>;
export const DeleteOrganizationServiceDocument = gql`
    mutation DeleteOrganizationService($organizationServiceId: ID!) {
  deleteOrganizationService(organizationServiceId: $organizationServiceId)
}
    `;
export type DeleteOrganizationServiceMutationFn = Apollo.MutationFunction<DeleteOrganizationServiceMutation, DeleteOrganizationServiceMutationVariables>;

/**
 * __useDeleteOrganizationServiceMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationServiceMutation, { data, loading, error }] = useDeleteOrganizationServiceMutation({
 *   variables: {
 *      organizationServiceId: // value for 'organizationServiceId'
 *   },
 * });
 */
export function useDeleteOrganizationServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationServiceMutation, DeleteOrganizationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationServiceMutation, DeleteOrganizationServiceMutationVariables>(DeleteOrganizationServiceDocument, options);
      }
export type DeleteOrganizationServiceMutationHookResult = ReturnType<typeof useDeleteOrganizationServiceMutation>;
export type DeleteOrganizationServiceMutationResult = Apollo.MutationResult<DeleteOrganizationServiceMutation>;
export type DeleteOrganizationServiceMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationServiceMutation, DeleteOrganizationServiceMutationVariables>;
export const OrganizationServicesDocument = gql`
    query OrganizationServices {
  organizationServices {
    id
    cptCode
    name
    fee
    duration
    isAddOn
    isDefault
  }
}
    `;

/**
 * __useOrganizationServicesQuery__
 *
 * To run a query within a React component, call `useOrganizationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationServicesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationServicesQuery, OrganizationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationServicesQuery, OrganizationServicesQueryVariables>(OrganizationServicesDocument, options);
      }
export function useOrganizationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationServicesQuery, OrganizationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationServicesQuery, OrganizationServicesQueryVariables>(OrganizationServicesDocument, options);
        }
export type OrganizationServicesQueryHookResult = ReturnType<typeof useOrganizationServicesQuery>;
export type OrganizationServicesLazyQueryHookResult = ReturnType<typeof useOrganizationServicesLazyQuery>;
export type OrganizationServicesQueryResult = Apollo.QueryResult<OrganizationServicesQuery, OrganizationServicesQueryVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($type: NoteType!, $text: String!, $sessionId: String, $patientId: String, $date: Date) {
  createNote(
    type: $type
    text: $text
    sessionId: $sessionId
    patientId: $patientId
    date: $date
  ) {
    id
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      type: // value for 'type'
 *      text: // value for 'text'
 *      sessionId: // value for 'sessionId'
 *      patientId: // value for 'patientId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($noteId: ID!, $type: NoteType, $text: String, $date: Date) {
  updateNote(noteId: $noteId, type: $type, text: $text, date: $date) {
    id
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      type: // value for 'type'
 *      text: // value for 'text'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($noteId: ID!) {
  deleteNote(noteId: $noteId) {
    id
    deleted
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const SignNoteDocument = gql`
    mutation SignNote($noteId: ID!) {
  signNote(noteId: $noteId) {
    id
  }
}
    `;
export type SignNoteMutationFn = Apollo.MutationFunction<SignNoteMutation, SignNoteMutationVariables>;

/**
 * __useSignNoteMutation__
 *
 * To run a mutation, you first call `useSignNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signNoteMutation, { data, loading, error }] = useSignNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useSignNoteMutation(baseOptions?: Apollo.MutationHookOptions<SignNoteMutation, SignNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignNoteMutation, SignNoteMutationVariables>(SignNoteDocument, options);
      }
export type SignNoteMutationHookResult = ReturnType<typeof useSignNoteMutation>;
export type SignNoteMutationResult = Apollo.MutationResult<SignNoteMutation>;
export type SignNoteMutationOptions = Apollo.BaseMutationOptions<SignNoteMutation, SignNoteMutationVariables>;
export const AddAddendumAndSignDocument = gql`
    mutation AddAddendumAndSign($noteId: ID!, $addendumText: String!, $deleted: Boolean) {
  addAddendumAndSign(
    noteId: $noteId
    addendumText: $addendumText
    deleted: $deleted
  ) {
    id
  }
}
    `;
export type AddAddendumAndSignMutationFn = Apollo.MutationFunction<AddAddendumAndSignMutation, AddAddendumAndSignMutationVariables>;

/**
 * __useAddAddendumAndSignMutation__
 *
 * To run a mutation, you first call `useAddAddendumAndSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddendumAndSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddendumAndSignMutation, { data, loading, error }] = useAddAddendumAndSignMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      addendumText: // value for 'addendumText'
 *      deleted: // value for 'deleted'
 *   },
 * });
 */
export function useAddAddendumAndSignMutation(baseOptions?: Apollo.MutationHookOptions<AddAddendumAndSignMutation, AddAddendumAndSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAddendumAndSignMutation, AddAddendumAndSignMutationVariables>(AddAddendumAndSignDocument, options);
      }
export type AddAddendumAndSignMutationHookResult = ReturnType<typeof useAddAddendumAndSignMutation>;
export type AddAddendumAndSignMutationResult = Apollo.MutationResult<AddAddendumAndSignMutation>;
export type AddAddendumAndSignMutationOptions = Apollo.BaseMutationOptions<AddAddendumAndSignMutation, AddAddendumAndSignMutationVariables>;
export const OrganizationNotesDocument = gql`
    query OrganizationNotes($filter: OrganizationNotesFilter) {
  organizationNotes(filter: $filter) {
    id
    type
    date
    session {
      id
      startDate
      duration
    }
    patient {
      id
    }
    text
    signature {
      name
      credentials
      licenceNumber
      date
      ipAddress
    }
    addendums {
      text
      signature {
        name
        credentials
        licenceNumber
        date
        ipAddress
      }
    }
    deleted
  }
}
    `;

/**
 * __useOrganizationNotesQuery__
 *
 * To run a query within a React component, call `useOrganizationNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNotesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationNotesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationNotesQuery, OrganizationNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNotesQuery, OrganizationNotesQueryVariables>(OrganizationNotesDocument, options);
      }
export function useOrganizationNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNotesQuery, OrganizationNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNotesQuery, OrganizationNotesQueryVariables>(OrganizationNotesDocument, options);
        }
export type OrganizationNotesQueryHookResult = ReturnType<typeof useOrganizationNotesQuery>;
export type OrganizationNotesLazyQueryHookResult = ReturnType<typeof useOrganizationNotesLazyQuery>;
export type OrganizationNotesQueryResult = Apollo.QueryResult<OrganizationNotesQuery, OrganizationNotesQueryVariables>;
export const NotePdfUrlDocument = gql`
    query NotePdfUrl($noteId: ID!) {
  notePdfUrl(noteId: $noteId)
}
    `;

/**
 * __useNotePdfUrlQuery__
 *
 * To run a query within a React component, call `useNotePdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotePdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotePdfUrlQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useNotePdfUrlQuery(baseOptions: Apollo.QueryHookOptions<NotePdfUrlQuery, NotePdfUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotePdfUrlQuery, NotePdfUrlQueryVariables>(NotePdfUrlDocument, options);
      }
export function useNotePdfUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotePdfUrlQuery, NotePdfUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotePdfUrlQuery, NotePdfUrlQueryVariables>(NotePdfUrlDocument, options);
        }
export type NotePdfUrlQueryHookResult = ReturnType<typeof useNotePdfUrlQuery>;
export type NotePdfUrlLazyQueryHookResult = ReturnType<typeof useNotePdfUrlLazyQuery>;
export type NotePdfUrlQueryResult = Apollo.QueryResult<NotePdfUrlQuery, NotePdfUrlQueryVariables>;
export const CreateDeferredDeepLinkDocument = gql`
    mutation CreateDeferredDeepLink($key: String!, $value: String!) {
  createDeferredDeepLink(key: $key, value: $value) {
    id
  }
}
    `;
export type CreateDeferredDeepLinkMutationFn = Apollo.MutationFunction<CreateDeferredDeepLinkMutation, CreateDeferredDeepLinkMutationVariables>;

/**
 * __useCreateDeferredDeepLinkMutation__
 *
 * To run a mutation, you first call `useCreateDeferredDeepLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeferredDeepLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeferredDeepLinkMutation, { data, loading, error }] = useCreateDeferredDeepLinkMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateDeferredDeepLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeferredDeepLinkMutation, CreateDeferredDeepLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeferredDeepLinkMutation, CreateDeferredDeepLinkMutationVariables>(CreateDeferredDeepLinkDocument, options);
      }
export type CreateDeferredDeepLinkMutationHookResult = ReturnType<typeof useCreateDeferredDeepLinkMutation>;
export type CreateDeferredDeepLinkMutationResult = Apollo.MutationResult<CreateDeferredDeepLinkMutation>;
export type CreateDeferredDeepLinkMutationOptions = Apollo.BaseMutationOptions<CreateDeferredDeepLinkMutation, CreateDeferredDeepLinkMutationVariables>;
export const OrganizationBillableCptCodesDocument = gql`
    query OrganizationBillableCptCodes($filter: OrganizationBillableCptCodesFilter) {
  organizationBillableCptCodes(filter: $filter) {
    id
    patient {
      id
      firstName
      lastName
      avatarUrl
    }
    cptCode
    description
    estimatedAmount
    isBilled
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useOrganizationBillableCptCodesQuery__
 *
 * To run a query within a React component, call `useOrganizationBillableCptCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBillableCptCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBillableCptCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationBillableCptCodesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationBillableCptCodesQuery, OrganizationBillableCptCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBillableCptCodesQuery, OrganizationBillableCptCodesQueryVariables>(OrganizationBillableCptCodesDocument, options);
      }
export function useOrganizationBillableCptCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBillableCptCodesQuery, OrganizationBillableCptCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBillableCptCodesQuery, OrganizationBillableCptCodesQueryVariables>(OrganizationBillableCptCodesDocument, options);
        }
export type OrganizationBillableCptCodesQueryHookResult = ReturnType<typeof useOrganizationBillableCptCodesQuery>;
export type OrganizationBillableCptCodesLazyQueryHookResult = ReturnType<typeof useOrganizationBillableCptCodesLazyQuery>;
export type OrganizationBillableCptCodesQueryResult = Apollo.QueryResult<OrganizationBillableCptCodesQuery, OrganizationBillableCptCodesQueryVariables>;
export const UpdateBillableCptCodeStateDocument = gql`
    mutation UpdateBillableCptCodeState($billableCptCodeId: ID!, $isBilled: Boolean!) {
  updateBillableCptCodeState(
    billableCptCodeId: $billableCptCodeId
    isBilled: $isBilled
  ) {
    id
  }
}
    `;
export type UpdateBillableCptCodeStateMutationFn = Apollo.MutationFunction<UpdateBillableCptCodeStateMutation, UpdateBillableCptCodeStateMutationVariables>;

/**
 * __useUpdateBillableCptCodeStateMutation__
 *
 * To run a mutation, you first call `useUpdateBillableCptCodeStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillableCptCodeStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillableCptCodeStateMutation, { data, loading, error }] = useUpdateBillableCptCodeStateMutation({
 *   variables: {
 *      billableCptCodeId: // value for 'billableCptCodeId'
 *      isBilled: // value for 'isBilled'
 *   },
 * });
 */
export function useUpdateBillableCptCodeStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillableCptCodeStateMutation, UpdateBillableCptCodeStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillableCptCodeStateMutation, UpdateBillableCptCodeStateMutationVariables>(UpdateBillableCptCodeStateDocument, options);
      }
export type UpdateBillableCptCodeStateMutationHookResult = ReturnType<typeof useUpdateBillableCptCodeStateMutation>;
export type UpdateBillableCptCodeStateMutationResult = Apollo.MutationResult<UpdateBillableCptCodeStateMutation>;
export type UpdateBillableCptCodeStateMutationOptions = Apollo.BaseMutationOptions<UpdateBillableCptCodeStateMutation, UpdateBillableCptCodeStateMutationVariables>;
export const PatientAppUsageDocument = gql`
    query PatientAppUsage($patientId: ID!, $filter: AppUsageFilter) {
  patientAppUsage(patientId: $patientId, filter: $filter) {
    date
    action
    activitySlug
    journalType
  }
}
    `;

/**
 * __usePatientAppUsageQuery__
 *
 * To run a query within a React component, call `usePatientAppUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientAppUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientAppUsageQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientAppUsageQuery(baseOptions: Apollo.QueryHookOptions<PatientAppUsageQuery, PatientAppUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientAppUsageQuery, PatientAppUsageQueryVariables>(PatientAppUsageDocument, options);
      }
export function usePatientAppUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientAppUsageQuery, PatientAppUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientAppUsageQuery, PatientAppUsageQueryVariables>(PatientAppUsageDocument, options);
        }
export type PatientAppUsageQueryHookResult = ReturnType<typeof usePatientAppUsageQuery>;
export type PatientAppUsageLazyQueryHookResult = ReturnType<typeof usePatientAppUsageLazyQuery>;
export type PatientAppUsageQueryResult = Apollo.QueryResult<PatientAppUsageQuery, PatientAppUsageQueryVariables>;
export const OrganizationMessagesDocument = gql`
    query OrganizationMessages($filter: OrganizationMessageFilter) {
  organizationMessages(filter: $filter) {
    id
    subject
    content
    files
    readBy {
      user {
        id
      }
    }
    recipients {
      id
      firstName
      lastName
      avatarUrl
    }
    owner {
      id
      firstName
      lastName
      avatarUrl
    }
    replies {
      id
      content
      files
      createdAt
      updatedAt
      readBy {
        user {
          id
        }
      }
      sender {
        id
        firstName
        lastName
        avatarUrl
      }
    }
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useOrganizationMessagesQuery__
 *
 * To run a query within a React component, call `useOrganizationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationMessagesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
      }
export function useOrganizationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
        }
export type OrganizationMessagesQueryHookResult = ReturnType<typeof useOrganizationMessagesQuery>;
export type OrganizationMessagesLazyQueryHookResult = ReturnType<typeof useOrganizationMessagesLazyQuery>;
export type OrganizationMessagesQueryResult = Apollo.QueryResult<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>;
export const CreateOrganizationMessageDocument = gql`
    mutation CreateOrganizationMessage($content: String!, $recipients: [ID!], $subject: String) {
  createOrganizationMessage(
    content: $content
    recipients: $recipients
    subject: $subject
  ) {
    id
  }
}
    `;
export type CreateOrganizationMessageMutationFn = Apollo.MutationFunction<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>;

/**
 * __useCreateOrganizationMessageMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMessageMutation, { data, loading, error }] = useCreateOrganizationMessageMutation({
 *   variables: {
 *      content: // value for 'content'
 *      recipients: // value for 'recipients'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useCreateOrganizationMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>(CreateOrganizationMessageDocument, options);
      }
export type CreateOrganizationMessageMutationHookResult = ReturnType<typeof useCreateOrganizationMessageMutation>;
export type CreateOrganizationMessageMutationResult = Apollo.MutationResult<CreateOrganizationMessageMutation>;
export type CreateOrganizationMessageMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMessageMutation, CreateOrganizationMessageMutationVariables>;
export const OrganizationMessageDocument = gql`
    query OrganizationMessage($organizationMessageId: ID!) {
  organizationMessage(organizationMessageId: $organizationMessageId) {
    id
    subject
    content
    files
    readBy {
      user {
        id
      }
    }
    recipients {
      id
      firstName
      lastName
      avatarUrl
    }
    owner {
      id
      firstName
      lastName
      avatarUrl
    }
    replies {
      id
      content
      files
      createdAt
      updatedAt
      readBy {
        user {
          id
        }
      }
      sender {
        id
        firstName
        lastName
        avatarUrl
      }
    }
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useOrganizationMessageQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageQuery({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *   },
 * });
 */
export function useOrganizationMessageQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMessageQuery, OrganizationMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageQuery, OrganizationMessageQueryVariables>(OrganizationMessageDocument, options);
      }
export function useOrganizationMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageQuery, OrganizationMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageQuery, OrganizationMessageQueryVariables>(OrganizationMessageDocument, options);
        }
export type OrganizationMessageQueryHookResult = ReturnType<typeof useOrganizationMessageQuery>;
export type OrganizationMessageLazyQueryHookResult = ReturnType<typeof useOrganizationMessageLazyQuery>;
export type OrganizationMessageQueryResult = Apollo.QueryResult<OrganizationMessageQuery, OrganizationMessageQueryVariables>;
export const CreateOrganizationMessageReplyDocument = gql`
    mutation CreateOrganizationMessageReply($organizationMessageId: ID!, $content: String!) {
  createOrganizationMessageReply(
    organizationMessageId: $organizationMessageId
    content: $content
  ) {
    id
    replies {
      id
    }
  }
}
    `;
export type CreateOrganizationMessageReplyMutationFn = Apollo.MutationFunction<CreateOrganizationMessageReplyMutation, CreateOrganizationMessageReplyMutationVariables>;

/**
 * __useCreateOrganizationMessageReplyMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMessageReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMessageReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMessageReplyMutation, { data, loading, error }] = useCreateOrganizationMessageReplyMutation({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateOrganizationMessageReplyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMessageReplyMutation, CreateOrganizationMessageReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMessageReplyMutation, CreateOrganizationMessageReplyMutationVariables>(CreateOrganizationMessageReplyDocument, options);
      }
export type CreateOrganizationMessageReplyMutationHookResult = ReturnType<typeof useCreateOrganizationMessageReplyMutation>;
export type CreateOrganizationMessageReplyMutationResult = Apollo.MutationResult<CreateOrganizationMessageReplyMutation>;
export type CreateOrganizationMessageReplyMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMessageReplyMutation, CreateOrganizationMessageReplyMutationVariables>;
export const MarkOrganizationMessageAsReadDocument = gql`
    mutation MarkOrganizationMessageAsRead($organizationMessageId: ID!) {
  markOrganizationMessageAsRead(organizationMessageId: $organizationMessageId) {
    id
  }
}
    `;
export type MarkOrganizationMessageAsReadMutationFn = Apollo.MutationFunction<MarkOrganizationMessageAsReadMutation, MarkOrganizationMessageAsReadMutationVariables>;

/**
 * __useMarkOrganizationMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkOrganizationMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrganizationMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrganizationMessageAsReadMutation, { data, loading, error }] = useMarkOrganizationMessageAsReadMutation({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *   },
 * });
 */
export function useMarkOrganizationMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkOrganizationMessageAsReadMutation, MarkOrganizationMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOrganizationMessageAsReadMutation, MarkOrganizationMessageAsReadMutationVariables>(MarkOrganizationMessageAsReadDocument, options);
      }
export type MarkOrganizationMessageAsReadMutationHookResult = ReturnType<typeof useMarkOrganizationMessageAsReadMutation>;
export type MarkOrganizationMessageAsReadMutationResult = Apollo.MutationResult<MarkOrganizationMessageAsReadMutation>;
export type MarkOrganizationMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkOrganizationMessageAsReadMutation, MarkOrganizationMessageAsReadMutationVariables>;
export const GenerateOrganizationMessageFileUploadUrlDocument = gql`
    mutation GenerateOrganizationMessageFileUploadUrl($organizationMessageId: ID!, $fileName: String!, $contentType: String!, $replyId: String) {
  generateOrganizationMessageFileUploadUrl(
    organizationMessageId: $organizationMessageId
    fileName: $fileName
    contentType: $contentType
    replyId: $replyId
  )
}
    `;
export type GenerateOrganizationMessageFileUploadUrlMutationFn = Apollo.MutationFunction<GenerateOrganizationMessageFileUploadUrlMutation, GenerateOrganizationMessageFileUploadUrlMutationVariables>;

/**
 * __useGenerateOrganizationMessageFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationMessageFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationMessageFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationMessageFileUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationMessageFileUploadUrlMutation({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useGenerateOrganizationMessageFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrganizationMessageFileUploadUrlMutation, GenerateOrganizationMessageFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrganizationMessageFileUploadUrlMutation, GenerateOrganizationMessageFileUploadUrlMutationVariables>(GenerateOrganizationMessageFileUploadUrlDocument, options);
      }
export type GenerateOrganizationMessageFileUploadUrlMutationHookResult = ReturnType<typeof useGenerateOrganizationMessageFileUploadUrlMutation>;
export type GenerateOrganizationMessageFileUploadUrlMutationResult = Apollo.MutationResult<GenerateOrganizationMessageFileUploadUrlMutation>;
export type GenerateOrganizationMessageFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateOrganizationMessageFileUploadUrlMutation, GenerateOrganizationMessageFileUploadUrlMutationVariables>;
export const UpdateOrganizationMessageFilesDocument = gql`
    mutation UpdateOrganizationMessageFiles($organizationMessageId: ID!, $fileName: String!, $replyId: String) {
  updateOrganizationMessageFiles(
    organizationMessageId: $organizationMessageId
    fileName: $fileName
    replyId: $replyId
  ) {
    id
  }
}
    `;
export type UpdateOrganizationMessageFilesMutationFn = Apollo.MutationFunction<UpdateOrganizationMessageFilesMutation, UpdateOrganizationMessageFilesMutationVariables>;

/**
 * __useUpdateOrganizationMessageFilesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMessageFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMessageFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMessageFilesMutation, { data, loading, error }] = useUpdateOrganizationMessageFilesMutation({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *      fileName: // value for 'fileName'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useUpdateOrganizationMessageFilesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMessageFilesMutation, UpdateOrganizationMessageFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMessageFilesMutation, UpdateOrganizationMessageFilesMutationVariables>(UpdateOrganizationMessageFilesDocument, options);
      }
export type UpdateOrganizationMessageFilesMutationHookResult = ReturnType<typeof useUpdateOrganizationMessageFilesMutation>;
export type UpdateOrganizationMessageFilesMutationResult = Apollo.MutationResult<UpdateOrganizationMessageFilesMutation>;
export type UpdateOrganizationMessageFilesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMessageFilesMutation, UpdateOrganizationMessageFilesMutationVariables>;
export const OrganizationMessageFileUrlDocument = gql`
    query OrganizationMessageFileUrl($organizationMessageId: ID!, $fileName: String!, $replyId: String) {
  organizationMessageFileUrl(
    organizationMessageId: $organizationMessageId
    fileName: $fileName
    replyId: $replyId
  )
}
    `;

/**
 * __useOrganizationMessageFileUrlQuery__
 *
 * To run a query within a React component, call `useOrganizationMessageFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessageFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessageFileUrlQuery({
 *   variables: {
 *      organizationMessageId: // value for 'organizationMessageId'
 *      fileName: // value for 'fileName'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useOrganizationMessageFileUrlQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMessageFileUrlQuery, OrganizationMessageFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessageFileUrlQuery, OrganizationMessageFileUrlQueryVariables>(OrganizationMessageFileUrlDocument, options);
      }
export function useOrganizationMessageFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessageFileUrlQuery, OrganizationMessageFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessageFileUrlQuery, OrganizationMessageFileUrlQueryVariables>(OrganizationMessageFileUrlDocument, options);
        }
export type OrganizationMessageFileUrlQueryHookResult = ReturnType<typeof useOrganizationMessageFileUrlQuery>;
export type OrganizationMessageFileUrlLazyQueryHookResult = ReturnType<typeof useOrganizationMessageFileUrlLazyQuery>;
export type OrganizationMessageFileUrlQueryResult = Apollo.QueryResult<OrganizationMessageFileUrlQuery, OrganizationMessageFileUrlQueryVariables>;
export const CreateSelfCarePlanDocument = gql`
    mutation CreateSelfCarePlan($patientId: ID!, $steps: [SelfCarePlanStepInput!]!, $diagnosis: String, $goals: [SelfCarePlanGoalInput!]) {
  createSelfCarePlan(
    patientId: $patientId
    steps: $steps
    diagnosis: $diagnosis
    goals: $goals
  ) {
    id
    createdAt
    updatedAt
    patient {
      id
    }
    diagnosis
    goals {
      id
      title
      description
    }
    steps {
      id
      title
      description
      actionPlanTitle
      actionPlanDescription
      appTools {
        id
        slug
        completed
        isActive
      }
    }
  }
}
    `;
export type CreateSelfCarePlanMutationFn = Apollo.MutationFunction<CreateSelfCarePlanMutation, CreateSelfCarePlanMutationVariables>;

/**
 * __useCreateSelfCarePlanMutation__
 *
 * To run a mutation, you first call `useCreateSelfCarePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfCarePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfCarePlanMutation, { data, loading, error }] = useCreateSelfCarePlanMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      steps: // value for 'steps'
 *      diagnosis: // value for 'diagnosis'
 *      goals: // value for 'goals'
 *   },
 * });
 */
export function useCreateSelfCarePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateSelfCarePlanMutation, CreateSelfCarePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSelfCarePlanMutation, CreateSelfCarePlanMutationVariables>(CreateSelfCarePlanDocument, options);
      }
export type CreateSelfCarePlanMutationHookResult = ReturnType<typeof useCreateSelfCarePlanMutation>;
export type CreateSelfCarePlanMutationResult = Apollo.MutationResult<CreateSelfCarePlanMutation>;
export type CreateSelfCarePlanMutationOptions = Apollo.BaseMutationOptions<CreateSelfCarePlanMutation, CreateSelfCarePlanMutationVariables>;
export const SelfCarePlanOfPatientDocument = gql`
    query SelfCarePlanOfPatient($patientId: ID!) {
  selfCarePlanOfPatient(patientId: $patientId) {
    id
    createdAt
    updatedAt
    patient {
      id
    }
    diagnosis
    goals {
      id
      title
      description
    }
    steps {
      id
      title
      description
      actionPlanTitle
      actionPlanDescription
      appTools {
        id
        slug
        completed
        isActive
      }
    }
  }
}
    `;

/**
 * __useSelfCarePlanOfPatientQuery__
 *
 * To run a query within a React component, call `useSelfCarePlanOfPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfCarePlanOfPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfCarePlanOfPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useSelfCarePlanOfPatientQuery(baseOptions: Apollo.QueryHookOptions<SelfCarePlanOfPatientQuery, SelfCarePlanOfPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfCarePlanOfPatientQuery, SelfCarePlanOfPatientQueryVariables>(SelfCarePlanOfPatientDocument, options);
      }
export function useSelfCarePlanOfPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfCarePlanOfPatientQuery, SelfCarePlanOfPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfCarePlanOfPatientQuery, SelfCarePlanOfPatientQueryVariables>(SelfCarePlanOfPatientDocument, options);
        }
export type SelfCarePlanOfPatientQueryHookResult = ReturnType<typeof useSelfCarePlanOfPatientQuery>;
export type SelfCarePlanOfPatientLazyQueryHookResult = ReturnType<typeof useSelfCarePlanOfPatientLazyQuery>;
export type SelfCarePlanOfPatientQueryResult = Apollo.QueryResult<SelfCarePlanOfPatientQuery, SelfCarePlanOfPatientQueryVariables>;
export const UpdateSelfCarePlanDocument = gql`
    mutation UpdateSelfCarePlan($selfCarePlanId: ID!, $steps: [SelfCarePlanStepInput!], $diagnosis: String, $goals: [SelfCarePlanGoalInput!]) {
  updateSelfCarePlan(
    selfCarePlanId: $selfCarePlanId
    steps: $steps
    diagnosis: $diagnosis
    goals: $goals
  ) {
    id
    createdAt
    updatedAt
    patient {
      id
    }
    diagnosis
    goals {
      id
      title
      description
    }
    steps {
      id
      title
      description
      actionPlanTitle
      actionPlanDescription
      appTools {
        id
        slug
        completed
        isActive
      }
    }
  }
}
    `;
export type UpdateSelfCarePlanMutationFn = Apollo.MutationFunction<UpdateSelfCarePlanMutation, UpdateSelfCarePlanMutationVariables>;

/**
 * __useUpdateSelfCarePlanMutation__
 *
 * To run a mutation, you first call `useUpdateSelfCarePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfCarePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfCarePlanMutation, { data, loading, error }] = useUpdateSelfCarePlanMutation({
 *   variables: {
 *      selfCarePlanId: // value for 'selfCarePlanId'
 *      steps: // value for 'steps'
 *      diagnosis: // value for 'diagnosis'
 *      goals: // value for 'goals'
 *   },
 * });
 */
export function useUpdateSelfCarePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelfCarePlanMutation, UpdateSelfCarePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelfCarePlanMutation, UpdateSelfCarePlanMutationVariables>(UpdateSelfCarePlanDocument, options);
      }
export type UpdateSelfCarePlanMutationHookResult = ReturnType<typeof useUpdateSelfCarePlanMutation>;
export type UpdateSelfCarePlanMutationResult = Apollo.MutationResult<UpdateSelfCarePlanMutation>;
export type UpdateSelfCarePlanMutationOptions = Apollo.BaseMutationOptions<UpdateSelfCarePlanMutation, UpdateSelfCarePlanMutationVariables>;
export const GenerateFormDataDocument = gql`
    mutation GenerateFormData($input: String!, $attachments: [String!], $type: TemplateType) {
  generateFormData(input: $input, attachments: $attachments, type: $type)
}
    `;
export type GenerateFormDataMutationFn = Apollo.MutationFunction<GenerateFormDataMutation, GenerateFormDataMutationVariables>;

/**
 * __useGenerateFormDataMutation__
 *
 * To run a mutation, you first call `useGenerateFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFormDataMutation, { data, loading, error }] = useGenerateFormDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *      attachments: // value for 'attachments'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenerateFormDataMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFormDataMutation, GenerateFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFormDataMutation, GenerateFormDataMutationVariables>(GenerateFormDataDocument, options);
      }
export type GenerateFormDataMutationHookResult = ReturnType<typeof useGenerateFormDataMutation>;
export type GenerateFormDataMutationResult = Apollo.MutationResult<GenerateFormDataMutation>;
export type GenerateFormDataMutationOptions = Apollo.BaseMutationOptions<GenerateFormDataMutation, GenerateFormDataMutationVariables>;
export const UpdateTemplateChatLogDocument = gql`
    mutation updateTemplateChatLog($input: String!, $content: String!, $templateId: ID!) {
  updateTemplateChatLog(input: $input, content: $content, templateId: $templateId) {
    id
    messages {
      role
      content
    }
  }
}
    `;
export type UpdateTemplateChatLogMutationFn = Apollo.MutationFunction<UpdateTemplateChatLogMutation, UpdateTemplateChatLogMutationVariables>;

/**
 * __useUpdateTemplateChatLogMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateChatLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateChatLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateChatLogMutation, { data, loading, error }] = useUpdateTemplateChatLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *      content: // value for 'content'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useUpdateTemplateChatLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateChatLogMutation, UpdateTemplateChatLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateChatLogMutation, UpdateTemplateChatLogMutationVariables>(UpdateTemplateChatLogDocument, options);
      }
export type UpdateTemplateChatLogMutationHookResult = ReturnType<typeof useUpdateTemplateChatLogMutation>;
export type UpdateTemplateChatLogMutationResult = Apollo.MutationResult<UpdateTemplateChatLogMutation>;
export type UpdateTemplateChatLogMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateChatLogMutation, UpdateTemplateChatLogMutationVariables>;
export const GuestUpdateTemplateChatLogDocument = gql`
    mutation guestUpdateTemplateChatLog($input: String!, $content: String!, $chatLogId: ID) {
  guestUpdateTemplateChatLog(
    input: $input
    content: $content
    chatLogId: $chatLogId
  ) {
    id
    messages {
      role
      content
    }
  }
}
    `;
export type GuestUpdateTemplateChatLogMutationFn = Apollo.MutationFunction<GuestUpdateTemplateChatLogMutation, GuestUpdateTemplateChatLogMutationVariables>;

/**
 * __useGuestUpdateTemplateChatLogMutation__
 *
 * To run a mutation, you first call `useGuestUpdateTemplateChatLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestUpdateTemplateChatLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestUpdateTemplateChatLogMutation, { data, loading, error }] = useGuestUpdateTemplateChatLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *      content: // value for 'content'
 *      chatLogId: // value for 'chatLogId'
 *   },
 * });
 */
export function useGuestUpdateTemplateChatLogMutation(baseOptions?: Apollo.MutationHookOptions<GuestUpdateTemplateChatLogMutation, GuestUpdateTemplateChatLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestUpdateTemplateChatLogMutation, GuestUpdateTemplateChatLogMutationVariables>(GuestUpdateTemplateChatLogDocument, options);
      }
export type GuestUpdateTemplateChatLogMutationHookResult = ReturnType<typeof useGuestUpdateTemplateChatLogMutation>;
export type GuestUpdateTemplateChatLogMutationResult = Apollo.MutationResult<GuestUpdateTemplateChatLogMutation>;
export type GuestUpdateTemplateChatLogMutationOptions = Apollo.BaseMutationOptions<GuestUpdateTemplateChatLogMutation, GuestUpdateTemplateChatLogMutationVariables>;
export const TemplateChatLogDocument = gql`
    query templateChatLog($templateId: ID!) {
  templateChatLog(templateId: $templateId) {
    id
    messages {
      role
      content
    }
  }
}
    `;

/**
 * __useTemplateChatLogQuery__
 *
 * To run a query within a React component, call `useTemplateChatLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateChatLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateChatLogQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateChatLogQuery(baseOptions: Apollo.QueryHookOptions<TemplateChatLogQuery, TemplateChatLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateChatLogQuery, TemplateChatLogQueryVariables>(TemplateChatLogDocument, options);
      }
export function useTemplateChatLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateChatLogQuery, TemplateChatLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateChatLogQuery, TemplateChatLogQueryVariables>(TemplateChatLogDocument, options);
        }
export type TemplateChatLogQueryHookResult = ReturnType<typeof useTemplateChatLogQuery>;
export type TemplateChatLogLazyQueryHookResult = ReturnType<typeof useTemplateChatLogLazyQuery>;
export type TemplateChatLogQueryResult = Apollo.QueryResult<TemplateChatLogQuery, TemplateChatLogQueryVariables>;
export const GeneratePromptsDocument = gql`
    mutation GeneratePrompts($input: String!) {
  generatePrompts(input: $input)
}
    `;
export type GeneratePromptsMutationFn = Apollo.MutationFunction<GeneratePromptsMutation, GeneratePromptsMutationVariables>;

/**
 * __useGeneratePromptsMutation__
 *
 * To run a mutation, you first call `useGeneratePromptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePromptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePromptsMutation, { data, loading, error }] = useGeneratePromptsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePromptsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePromptsMutation, GeneratePromptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePromptsMutation, GeneratePromptsMutationVariables>(GeneratePromptsDocument, options);
      }
export type GeneratePromptsMutationHookResult = ReturnType<typeof useGeneratePromptsMutation>;
export type GeneratePromptsMutationResult = Apollo.MutationResult<GeneratePromptsMutation>;
export type GeneratePromptsMutationOptions = Apollo.BaseMutationOptions<GeneratePromptsMutation, GeneratePromptsMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($content: String!) {
  createForm(content: $content) {
    id
    content
    createdAt
    updatedAt
  }
}
    `;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const FormDocument = gql`
    query Form($formId: ID!) {
  form(formId: $formId) {
    id
    content
    title
    type
    createdAt
    updatedAt
    responses
    responseDates
    repeatable
    completed
  }
}
    `;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const SendFormToDoctorDocument = gql`
    mutation SendFormToDoctor($formId: ID!, $email: String!, $phoneNumber: String!) {
  sendFormToDoctor(formId: $formId, email: $email, phoneNumber: $phoneNumber)
}
    `;
export type SendFormToDoctorMutationFn = Apollo.MutationFunction<SendFormToDoctorMutation, SendFormToDoctorMutationVariables>;

/**
 * __useSendFormToDoctorMutation__
 *
 * To run a mutation, you first call `useSendFormToDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFormToDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFormToDoctorMutation, { data, loading, error }] = useSendFormToDoctorMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSendFormToDoctorMutation(baseOptions?: Apollo.MutationHookOptions<SendFormToDoctorMutation, SendFormToDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFormToDoctorMutation, SendFormToDoctorMutationVariables>(SendFormToDoctorDocument, options);
      }
export type SendFormToDoctorMutationHookResult = ReturnType<typeof useSendFormToDoctorMutation>;
export type SendFormToDoctorMutationResult = Apollo.MutationResult<SendFormToDoctorMutation>;
export type SendFormToDoctorMutationOptions = Apollo.BaseMutationOptions<SendFormToDoctorMutation, SendFormToDoctorMutationVariables>;
export const JoinWaitingListDocument = gql`
    mutation JoinWaitingList($email: String!, $phoneNumber: String!) {
  joinWaitingList(email: $email, phoneNumber: $phoneNumber)
}
    `;
export type JoinWaitingListMutationFn = Apollo.MutationFunction<JoinWaitingListMutation, JoinWaitingListMutationVariables>;

/**
 * __useJoinWaitingListMutation__
 *
 * To run a mutation, you first call `useJoinWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWaitingListMutation, { data, loading, error }] = useJoinWaitingListMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useJoinWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<JoinWaitingListMutation, JoinWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinWaitingListMutation, JoinWaitingListMutationVariables>(JoinWaitingListDocument, options);
      }
export type JoinWaitingListMutationHookResult = ReturnType<typeof useJoinWaitingListMutation>;
export type JoinWaitingListMutationResult = Apollo.MutationResult<JoinWaitingListMutation>;
export type JoinWaitingListMutationOptions = Apollo.BaseMutationOptions<JoinWaitingListMutation, JoinWaitingListMutationVariables>;
export const SendSegmentEventDocument = gql`
    mutation SendSegmentEvent($eventName: String!, $properties: Object) {
  sendSegmentEvent(eventName: $eventName, properties: $properties)
}
    `;
export type SendSegmentEventMutationFn = Apollo.MutationFunction<SendSegmentEventMutation, SendSegmentEventMutationVariables>;

/**
 * __useSendSegmentEventMutation__
 *
 * To run a mutation, you first call `useSendSegmentEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSegmentEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSegmentEventMutation, { data, loading, error }] = useSendSegmentEventMutation({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useSendSegmentEventMutation(baseOptions?: Apollo.MutationHookOptions<SendSegmentEventMutation, SendSegmentEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSegmentEventMutation, SendSegmentEventMutationVariables>(SendSegmentEventDocument, options);
      }
export type SendSegmentEventMutationHookResult = ReturnType<typeof useSendSegmentEventMutation>;
export type SendSegmentEventMutationResult = Apollo.MutationResult<SendSegmentEventMutation>;
export type SendSegmentEventMutationOptions = Apollo.BaseMutationOptions<SendSegmentEventMutation, SendSegmentEventMutationVariables>;
export const CreateAndSendFormToPatientDocument = gql`
    mutation CreateAndSendFormToPatient($content: String!, $message: String, $patientId: ID!, $templateId: ID, $title: String, $type: TemplateType) {
  createAndSendFormToPatient(
    content: $content
    message: $message
    patientId: $patientId
    templateId: $templateId
    title: $title
    type: $type
  ) {
    id
  }
}
    `;
export type CreateAndSendFormToPatientMutationFn = Apollo.MutationFunction<CreateAndSendFormToPatientMutation, CreateAndSendFormToPatientMutationVariables>;

/**
 * __useCreateAndSendFormToPatientMutation__
 *
 * To run a mutation, you first call `useCreateAndSendFormToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndSendFormToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndSendFormToPatientMutation, { data, loading, error }] = useCreateAndSendFormToPatientMutation({
 *   variables: {
 *      content: // value for 'content'
 *      message: // value for 'message'
 *      patientId: // value for 'patientId'
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAndSendFormToPatientMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndSendFormToPatientMutation, CreateAndSendFormToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndSendFormToPatientMutation, CreateAndSendFormToPatientMutationVariables>(CreateAndSendFormToPatientDocument, options);
      }
export type CreateAndSendFormToPatientMutationHookResult = ReturnType<typeof useCreateAndSendFormToPatientMutation>;
export type CreateAndSendFormToPatientMutationResult = Apollo.MutationResult<CreateAndSendFormToPatientMutation>;
export type CreateAndSendFormToPatientMutationOptions = Apollo.BaseMutationOptions<CreateAndSendFormToPatientMutation, CreateAndSendFormToPatientMutationVariables>;
export const CreateAndAssignFormToPatientDocument = gql`
    mutation CreateAndAssignFormToPatient($content: String!, $message: String, $patientId: ID!, $templateId: ID, $title: String, $type: TemplateType) {
  createAndAssignFormToPatient(
    content: $content
    message: $message
    patientId: $patientId
    templateId: $templateId
    title: $title
    type: $type
  ) {
    id
  }
}
    `;
export type CreateAndAssignFormToPatientMutationFn = Apollo.MutationFunction<CreateAndAssignFormToPatientMutation, CreateAndAssignFormToPatientMutationVariables>;

/**
 * __useCreateAndAssignFormToPatientMutation__
 *
 * To run a mutation, you first call `useCreateAndAssignFormToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndAssignFormToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndAssignFormToPatientMutation, { data, loading, error }] = useCreateAndAssignFormToPatientMutation({
 *   variables: {
 *      content: // value for 'content'
 *      message: // value for 'message'
 *      patientId: // value for 'patientId'
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAndAssignFormToPatientMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndAssignFormToPatientMutation, CreateAndAssignFormToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndAssignFormToPatientMutation, CreateAndAssignFormToPatientMutationVariables>(CreateAndAssignFormToPatientDocument, options);
      }
export type CreateAndAssignFormToPatientMutationHookResult = ReturnType<typeof useCreateAndAssignFormToPatientMutation>;
export type CreateAndAssignFormToPatientMutationResult = Apollo.MutationResult<CreateAndAssignFormToPatientMutation>;
export type CreateAndAssignFormToPatientMutationOptions = Apollo.BaseMutationOptions<CreateAndAssignFormToPatientMutation, CreateAndAssignFormToPatientMutationVariables>;
export const SaveFormResponseDocument = gql`
    mutation SaveFormResponse($formId: ID!, $response: String!, $completed: Boolean) {
  saveFormResponse(formId: $formId, response: $response, completed: $completed) {
    id
  }
}
    `;
export type SaveFormResponseMutationFn = Apollo.MutationFunction<SaveFormResponseMutation, SaveFormResponseMutationVariables>;

/**
 * __useSaveFormResponseMutation__
 *
 * To run a mutation, you first call `useSaveFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormResponseMutation, { data, loading, error }] = useSaveFormResponseMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      response: // value for 'response'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useSaveFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveFormResponseMutation, SaveFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFormResponseMutation, SaveFormResponseMutationVariables>(SaveFormResponseDocument, options);
      }
export type SaveFormResponseMutationHookResult = ReturnType<typeof useSaveFormResponseMutation>;
export type SaveFormResponseMutationResult = Apollo.MutationResult<SaveFormResponseMutation>;
export type SaveFormResponseMutationOptions = Apollo.BaseMutationOptions<SaveFormResponseMutation, SaveFormResponseMutationVariables>;
export const OrganizationFormsDocument = gql`
    query OrganizationForms($filter: OrganizationFormsFilter) {
  organizationForms(filter: $filter) {
    id
    content
    template {
      id
      title
      logo
      description
      scoresDescription
    }
    title
    type
    scorable
    completed
    responses
    responseDates
    scores
    sent
    doctor {
      id
      firstName
      lastName
    }
    moduleSchedule {
      id
      title
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useOrganizationFormsQuery__
 *
 * To run a query within a React component, call `useOrganizationFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFormsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationFormsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationFormsQuery, OrganizationFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationFormsQuery, OrganizationFormsQueryVariables>(OrganizationFormsDocument, options);
      }
export function useOrganizationFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFormsQuery, OrganizationFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationFormsQuery, OrganizationFormsQueryVariables>(OrganizationFormsDocument, options);
        }
export type OrganizationFormsQueryHookResult = ReturnType<typeof useOrganizationFormsQuery>;
export type OrganizationFormsLazyQueryHookResult = ReturnType<typeof useOrganizationFormsLazyQuery>;
export type OrganizationFormsQueryResult = Apollo.QueryResult<OrganizationFormsQuery, OrganizationFormsQueryVariables>;
export const PatientFormsDocument = gql`
    query PatientForms($filter: PatientFormsFilter) {
  patientForms(filter: $filter) {
    id
    content
    template {
      id
      title
      logo
      description
      scoresDescription
    }
    title
    type
    scorable
    completed
    responses
    responseDates
    scores
    sent
    doctor {
      id
      firstName
      lastName
    }
    moduleSchedule {
      id
      title
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __usePatientFormsQuery__
 *
 * To run a query within a React component, call `usePatientFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientFormsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientFormsQuery(baseOptions?: Apollo.QueryHookOptions<PatientFormsQuery, PatientFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientFormsQuery, PatientFormsQueryVariables>(PatientFormsDocument, options);
      }
export function usePatientFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientFormsQuery, PatientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientFormsQuery, PatientFormsQueryVariables>(PatientFormsDocument, options);
        }
export type PatientFormsQueryHookResult = ReturnType<typeof usePatientFormsQuery>;
export type PatientFormsLazyQueryHookResult = ReturnType<typeof usePatientFormsLazyQuery>;
export type PatientFormsQueryResult = Apollo.QueryResult<PatientFormsQuery, PatientFormsQueryVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($formId: ID!, $message: String, $patientId: ID, $title: String, $type: TemplateType, $content: String) {
  updateForm(
    formId: $formId
    message: $message
    patientId: $patientId
    title: $title
    type: $type
    content: $content
  ) {
    id
  }
}
    `;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      message: // value for 'message'
 *      patientId: // value for 'patientId'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($formId: ID!) {
  deleteForm(formId: $formId)
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const GenerateTemplateFileUploadUrlDocument = gql`
    mutation GenerateTemplateFileUploadUrl($contentType: String!, $fileExtension: String) {
  generateTemplateFileUploadUrl(
    contentType: $contentType
    fileExtension: $fileExtension
  )
}
    `;
export type GenerateTemplateFileUploadUrlMutationFn = Apollo.MutationFunction<GenerateTemplateFileUploadUrlMutation, GenerateTemplateFileUploadUrlMutationVariables>;

/**
 * __useGenerateTemplateFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateTemplateFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTemplateFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTemplateFileUploadUrlMutation, { data, loading, error }] = useGenerateTemplateFileUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      fileExtension: // value for 'fileExtension'
 *   },
 * });
 */
export function useGenerateTemplateFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTemplateFileUploadUrlMutation, GenerateTemplateFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTemplateFileUploadUrlMutation, GenerateTemplateFileUploadUrlMutationVariables>(GenerateTemplateFileUploadUrlDocument, options);
      }
export type GenerateTemplateFileUploadUrlMutationHookResult = ReturnType<typeof useGenerateTemplateFileUploadUrlMutation>;
export type GenerateTemplateFileUploadUrlMutationResult = Apollo.MutationResult<GenerateTemplateFileUploadUrlMutation>;
export type GenerateTemplateFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateTemplateFileUploadUrlMutation, GenerateTemplateFileUploadUrlMutationVariables>;
export const AdminFetchOrganizationByEmailDocument = gql`
    query adminFetchOrganizationByEmail($email: String!) {
  adminFetchOrganizationByEmail(email: $email) {
    id
    email
    name
  }
}
    `;

/**
 * __useAdminFetchOrganizationByEmailQuery__
 *
 * To run a query within a React component, call `useAdminFetchOrganizationByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchOrganizationByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchOrganizationByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAdminFetchOrganizationByEmailQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchOrganizationByEmailQuery, AdminFetchOrganizationByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchOrganizationByEmailQuery, AdminFetchOrganizationByEmailQueryVariables>(AdminFetchOrganizationByEmailDocument, options);
      }
export function useAdminFetchOrganizationByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchOrganizationByEmailQuery, AdminFetchOrganizationByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchOrganizationByEmailQuery, AdminFetchOrganizationByEmailQueryVariables>(AdminFetchOrganizationByEmailDocument, options);
        }
export type AdminFetchOrganizationByEmailQueryHookResult = ReturnType<typeof useAdminFetchOrganizationByEmailQuery>;
export type AdminFetchOrganizationByEmailLazyQueryHookResult = ReturnType<typeof useAdminFetchOrganizationByEmailLazyQuery>;
export type AdminFetchOrganizationByEmailQueryResult = Apollo.QueryResult<AdminFetchOrganizationByEmailQuery, AdminFetchOrganizationByEmailQueryVariables>;
export const AdminCreateTemplateDocument = gql`
    mutation AdminCreateTemplate($title: String!, $type: TemplateType!, $content: String!, $scorable: Boolean!, $scoresDescription: String, $logo: String, $description: String, $tags: [String], $organizationId: ID) {
  adminCreateTemplate(
    title: $title
    type: $type
    content: $content
    scorable: $scorable
    scoresDescription: $scoresDescription
    logo: $logo
    description: $description
    tags: $tags
    organizationId: $organizationId
  ) {
    id
  }
}
    `;
export type AdminCreateTemplateMutationFn = Apollo.MutationFunction<AdminCreateTemplateMutation, AdminCreateTemplateMutationVariables>;

/**
 * __useAdminCreateTemplateMutation__
 *
 * To run a mutation, you first call `useAdminCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTemplateMutation, { data, loading, error }] = useAdminCreateTemplateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      content: // value for 'content'
 *      scorable: // value for 'scorable'
 *      scoresDescription: // value for 'scoresDescription'
 *      logo: // value for 'logo'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTemplateMutation, AdminCreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTemplateMutation, AdminCreateTemplateMutationVariables>(AdminCreateTemplateDocument, options);
      }
export type AdminCreateTemplateMutationHookResult = ReturnType<typeof useAdminCreateTemplateMutation>;
export type AdminCreateTemplateMutationResult = Apollo.MutationResult<AdminCreateTemplateMutation>;
export type AdminCreateTemplateMutationOptions = Apollo.BaseMutationOptions<AdminCreateTemplateMutation, AdminCreateTemplateMutationVariables>;
export const AdminUpdateTemplateDocument = gql`
    mutation AdminUpdateTemplate($templateId: ID!, $title: String, $type: TemplateType, $content: String, $logo: String, $description: String, $tags: [String], $scorable: Boolean, $scoresDescription: String) {
  adminUpdateTemplate(
    templateId: $templateId
    title: $title
    type: $type
    content: $content
    logo: $logo
    description: $description
    tags: $tags
    scorable: $scorable
    scoresDescription: $scoresDescription
  ) {
    id
  }
}
    `;
export type AdminUpdateTemplateMutationFn = Apollo.MutationFunction<AdminUpdateTemplateMutation, AdminUpdateTemplateMutationVariables>;

/**
 * __useAdminUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTemplateMutation, { data, loading, error }] = useAdminUpdateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      content: // value for 'content'
 *      logo: // value for 'logo'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      scorable: // value for 'scorable'
 *      scoresDescription: // value for 'scoresDescription'
 *   },
 * });
 */
export function useAdminUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTemplateMutation, AdminUpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTemplateMutation, AdminUpdateTemplateMutationVariables>(AdminUpdateTemplateDocument, options);
      }
export type AdminUpdateTemplateMutationHookResult = ReturnType<typeof useAdminUpdateTemplateMutation>;
export type AdminUpdateTemplateMutationResult = Apollo.MutationResult<AdminUpdateTemplateMutation>;
export type AdminUpdateTemplateMutationOptions = Apollo.BaseMutationOptions<AdminUpdateTemplateMutation, AdminUpdateTemplateMutationVariables>;
export const TemplateDocument = gql`
    query Template($templateId: ID, $slug: String) {
  template(templateId: $templateId, slug: $slug) {
    content
    default
    description
    doctor {
      id
      firstName
      lastName
    }
    id
    logo
    scorable
    scoresDescription
    slug
    tags
    title
    type
  }
}
    `;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions?: Apollo.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<TemplateQuery, TemplateQueryVariables>;
export const TemplatesDocument = gql`
    query Templates($organizationId: ID, $isDefault: Boolean, $filter: TemplatesFilter) {
  templates(
    organizationId: $organizationId
    isDefault: $isDefault
    filter: $filter
  ) {
    total
    data {
      content
      default
      description
      doctor {
        id
        firstName
        lastName
      }
      id
      logo
      scorable
      scoresDescription
      slug
      tags
      title
      type
    }
  }
}
    `;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      isDefault: // value for 'isDefault'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const SearchDefaultTemplatesDocument = gql`
    query SearchDefaultTemplates($term: String!, $filter: TemplatesFilter) {
  searchDefaultTemplates(term: $term, filter: $filter) {
    content
    default
    description
    doctor {
      id
      firstName
      lastName
    }
    id
    logo
    scorable
    scoresDescription
    slug
    tags
    title
    type
  }
}
    `;

/**
 * __useSearchDefaultTemplatesQuery__
 *
 * To run a query within a React component, call `useSearchDefaultTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDefaultTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDefaultTemplatesQuery({
 *   variables: {
 *      term: // value for 'term'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchDefaultTemplatesQuery(baseOptions: Apollo.QueryHookOptions<SearchDefaultTemplatesQuery, SearchDefaultTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDefaultTemplatesQuery, SearchDefaultTemplatesQueryVariables>(SearchDefaultTemplatesDocument, options);
      }
export function useSearchDefaultTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDefaultTemplatesQuery, SearchDefaultTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDefaultTemplatesQuery, SearchDefaultTemplatesQueryVariables>(SearchDefaultTemplatesDocument, options);
        }
export type SearchDefaultTemplatesQueryHookResult = ReturnType<typeof useSearchDefaultTemplatesQuery>;
export type SearchDefaultTemplatesLazyQueryHookResult = ReturnType<typeof useSearchDefaultTemplatesLazyQuery>;
export type SearchDefaultTemplatesQueryResult = Apollo.QueryResult<SearchDefaultTemplatesQuery, SearchDefaultTemplatesQueryVariables>;
export const SearchOrganizationTemplatesDocument = gql`
    query SearchOrganizationTemplates($term: String!, $filter: TemplatesFilter) {
  searchOrganizationTemplates(term: $term, filter: $filter) {
    content
    default
    description
    doctor {
      id
      firstName
      lastName
    }
    id
    logo
    scorable
    scoresDescription
    slug
    tags
    title
    type
  }
}
    `;

/**
 * __useSearchOrganizationTemplatesQuery__
 *
 * To run a query within a React component, call `useSearchOrganizationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrganizationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrganizationTemplatesQuery({
 *   variables: {
 *      term: // value for 'term'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchOrganizationTemplatesQuery(baseOptions: Apollo.QueryHookOptions<SearchOrganizationTemplatesQuery, SearchOrganizationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrganizationTemplatesQuery, SearchOrganizationTemplatesQueryVariables>(SearchOrganizationTemplatesDocument, options);
      }
export function useSearchOrganizationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrganizationTemplatesQuery, SearchOrganizationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrganizationTemplatesQuery, SearchOrganizationTemplatesQueryVariables>(SearchOrganizationTemplatesDocument, options);
        }
export type SearchOrganizationTemplatesQueryHookResult = ReturnType<typeof useSearchOrganizationTemplatesQuery>;
export type SearchOrganizationTemplatesLazyQueryHookResult = ReturnType<typeof useSearchOrganizationTemplatesLazyQuery>;
export type SearchOrganizationTemplatesQueryResult = Apollo.QueryResult<SearchOrganizationTemplatesQuery, SearchOrganizationTemplatesQueryVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($title: String!, $content: String!, $description: String, $type: TemplateType, $tags: [String], $logo: String, $scorable: Boolean, $scoresDescription: String) {
  createTemplate(
    title: $title
    content: $content
    description: $description
    type: $type
    tags: $tags
    logo: $logo
    scorable: $scorable
    scoresDescription: $scoresDescription
  ) {
    id
    content
    default
    logo
    title
    type
    description
    tags
    scorable
    scoresDescription
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      description: // value for 'description'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *      logo: // value for 'logo'
 *      scorable: // value for 'scorable'
 *      scoresDescription: // value for 'scoresDescription'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const GenerateTemplateDocument = gql`
    mutation GenerateTemplate($input: String!, $type: TemplateType!, $attachments: [String]) {
  generateTemplate(input: $input, type: $type, attachments: $attachments) {
    id
    content
    default
    logo
    title
    type
    description
    tags
    scorable
    scoresDescription
  }
}
    `;
export type GenerateTemplateMutationFn = Apollo.MutationFunction<GenerateTemplateMutation, GenerateTemplateMutationVariables>;

/**
 * __useGenerateTemplateMutation__
 *
 * To run a mutation, you first call `useGenerateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTemplateMutation, { data, loading, error }] = useGenerateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      type: // value for 'type'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useGenerateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTemplateMutation, GenerateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTemplateMutation, GenerateTemplateMutationVariables>(GenerateTemplateDocument, options);
      }
export type GenerateTemplateMutationHookResult = ReturnType<typeof useGenerateTemplateMutation>;
export type GenerateTemplateMutationResult = Apollo.MutationResult<GenerateTemplateMutation>;
export type GenerateTemplateMutationOptions = Apollo.BaseMutationOptions<GenerateTemplateMutation, GenerateTemplateMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($templateId: ID!, $title: String, $description: String, $tags: [String], $logo: String, $type: TemplateType, $content: String) {
  updateTemplate(
    templateId: $templateId
    title: $title
    description: $description
    tags: $tags
    logo: $logo
    type: $type
    content: $content
  ) {
    id
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      logo: // value for 'logo'
 *      type: // value for 'type'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation DeleteTemplate($templateId: ID!) {
  deleteTemplate(templateId: $templateId) {
    id
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const SendResetEmailVerificationCodeDocument = gql`
    mutation SendResetEmailVerificationCode($email: String!) {
  sendResetEmailVerificationCode(email: $email) {
    email
  }
}
    `;
export type SendResetEmailVerificationCodeMutationFn = Apollo.MutationFunction<SendResetEmailVerificationCodeMutation, SendResetEmailVerificationCodeMutationVariables>;

/**
 * __useSendResetEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendResetEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetEmailVerificationCodeMutation, { data, loading, error }] = useSendResetEmailVerificationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetEmailVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendResetEmailVerificationCodeMutation, SendResetEmailVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetEmailVerificationCodeMutation, SendResetEmailVerificationCodeMutationVariables>(SendResetEmailVerificationCodeDocument, options);
      }
export type SendResetEmailVerificationCodeMutationHookResult = ReturnType<typeof useSendResetEmailVerificationCodeMutation>;
export type SendResetEmailVerificationCodeMutationResult = Apollo.MutationResult<SendResetEmailVerificationCodeMutation>;
export type SendResetEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendResetEmailVerificationCodeMutation, SendResetEmailVerificationCodeMutationVariables>;
export const ValidateVerificationCodeDocument = gql`
    mutation ValidateVerificationCode($email: String!, $code: Int!) {
  validateVerificationCode(email: $email, code: $code) {
    email
  }
}
    `;
export type ValidateVerificationCodeMutationFn = Apollo.MutationFunction<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>;

/**
 * __useValidateVerificationCodeMutation__
 *
 * To run a mutation, you first call `useValidateVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateVerificationCodeMutation, { data, loading, error }] = useValidateVerificationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>(ValidateVerificationCodeDocument, options);
      }
export type ValidateVerificationCodeMutationHookResult = ReturnType<typeof useValidateVerificationCodeMutation>;
export type ValidateVerificationCodeMutationResult = Apollo.MutationResult<ValidateVerificationCodeMutation>;
export type ValidateVerificationCodeMutationOptions = Apollo.BaseMutationOptions<ValidateVerificationCodeMutation, ValidateVerificationCodeMutationVariables>;
export const ResetPasswordAndLoginDocument = gql`
    mutation ResetPasswordAndLogin($email: String!, $code: Int!, $newPassword: String!) {
  resetPasswordAndLogin(
    email: $email
    code: $code
    newPassword: $newPassword
    loginSource: DASHBOARD
  ) {
    token
  }
}
    `;
export type ResetPasswordAndLoginMutationFn = Apollo.MutationFunction<ResetPasswordAndLoginMutation, ResetPasswordAndLoginMutationVariables>;

/**
 * __useResetPasswordAndLoginMutation__
 *
 * To run a mutation, you first call `useResetPasswordAndLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordAndLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordAndLoginMutation, { data, loading, error }] = useResetPasswordAndLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordAndLoginMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordAndLoginMutation, ResetPasswordAndLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordAndLoginMutation, ResetPasswordAndLoginMutationVariables>(ResetPasswordAndLoginDocument, options);
      }
export type ResetPasswordAndLoginMutationHookResult = ReturnType<typeof useResetPasswordAndLoginMutation>;
export type ResetPasswordAndLoginMutationResult = Apollo.MutationResult<ResetPasswordAndLoginMutation>;
export type ResetPasswordAndLoginMutationOptions = Apollo.BaseMutationOptions<ResetPasswordAndLoginMutation, ResetPasswordAndLoginMutationVariables>;
export const CreateFormScheduleDocument = gql`
    mutation CreateFormSchedule($content: String, $patientId: ID!, $repeat: Repeat!, $templateId: ID, $startDate: Date) {
  createFormSchedule(
    content: $content
    patientId: $patientId
    repeat: $repeat
    templateId: $templateId
    startDate: $startDate
  ) {
    id
  }
}
    `;
export type CreateFormScheduleMutationFn = Apollo.MutationFunction<CreateFormScheduleMutation, CreateFormScheduleMutationVariables>;

/**
 * __useCreateFormScheduleMutation__
 *
 * To run a mutation, you first call `useCreateFormScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormScheduleMutation, { data, loading, error }] = useCreateFormScheduleMutation({
 *   variables: {
 *      content: // value for 'content'
 *      patientId: // value for 'patientId'
 *      repeat: // value for 'repeat'
 *      templateId: // value for 'templateId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCreateFormScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormScheduleMutation, CreateFormScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormScheduleMutation, CreateFormScheduleMutationVariables>(CreateFormScheduleDocument, options);
      }
export type CreateFormScheduleMutationHookResult = ReturnType<typeof useCreateFormScheduleMutation>;
export type CreateFormScheduleMutationResult = Apollo.MutationResult<CreateFormScheduleMutation>;
export type CreateFormScheduleMutationOptions = Apollo.BaseMutationOptions<CreateFormScheduleMutation, CreateFormScheduleMutationVariables>;
export const DeleteFormScheduleDocument = gql`
    mutation DeleteFormSchedule($formScheduleId: ID!) {
  deleteFormSchedule(formScheduleId: $formScheduleId) {
    id
  }
}
    `;
export type DeleteFormScheduleMutationFn = Apollo.MutationFunction<DeleteFormScheduleMutation, DeleteFormScheduleMutationVariables>;

/**
 * __useDeleteFormScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteFormScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormScheduleMutation, { data, loading, error }] = useDeleteFormScheduleMutation({
 *   variables: {
 *      formScheduleId: // value for 'formScheduleId'
 *   },
 * });
 */
export function useDeleteFormScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormScheduleMutation, DeleteFormScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormScheduleMutation, DeleteFormScheduleMutationVariables>(DeleteFormScheduleDocument, options);
      }
export type DeleteFormScheduleMutationHookResult = ReturnType<typeof useDeleteFormScheduleMutation>;
export type DeleteFormScheduleMutationResult = Apollo.MutationResult<DeleteFormScheduleMutation>;
export type DeleteFormScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteFormScheduleMutation, DeleteFormScheduleMutationVariables>;
export const UpdateFormSchedulePauseStatusDocument = gql`
    mutation updateFormSchedulePauseStatus($formScheduleId: ID!) {
  updateFormSchedulePauseStatus(formScheduleId: $formScheduleId) {
    id
  }
}
    `;
export type UpdateFormSchedulePauseStatusMutationFn = Apollo.MutationFunction<UpdateFormSchedulePauseStatusMutation, UpdateFormSchedulePauseStatusMutationVariables>;

/**
 * __useUpdateFormSchedulePauseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFormSchedulePauseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSchedulePauseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSchedulePauseStatusMutation, { data, loading, error }] = useUpdateFormSchedulePauseStatusMutation({
 *   variables: {
 *      formScheduleId: // value for 'formScheduleId'
 *   },
 * });
 */
export function useUpdateFormSchedulePauseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormSchedulePauseStatusMutation, UpdateFormSchedulePauseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormSchedulePauseStatusMutation, UpdateFormSchedulePauseStatusMutationVariables>(UpdateFormSchedulePauseStatusDocument, options);
      }
export type UpdateFormSchedulePauseStatusMutationHookResult = ReturnType<typeof useUpdateFormSchedulePauseStatusMutation>;
export type UpdateFormSchedulePauseStatusMutationResult = Apollo.MutationResult<UpdateFormSchedulePauseStatusMutation>;
export type UpdateFormSchedulePauseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFormSchedulePauseStatusMutation, UpdateFormSchedulePauseStatusMutationVariables>;
export const UpdateFormScheduleTimeDocument = gql`
    mutation UpdateFormScheduleTime($formScheduleId: ID!, $startDate: Date, $repeat: Repeat) {
  updateFormScheduleTime(
    formScheduleId: $formScheduleId
    startDate: $startDate
    repeat: $repeat
  ) {
    id
    repeat
    startDate
  }
}
    `;
export type UpdateFormScheduleTimeMutationFn = Apollo.MutationFunction<UpdateFormScheduleTimeMutation, UpdateFormScheduleTimeMutationVariables>;

/**
 * __useUpdateFormScheduleTimeMutation__
 *
 * To run a mutation, you first call `useUpdateFormScheduleTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormScheduleTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormScheduleTimeMutation, { data, loading, error }] = useUpdateFormScheduleTimeMutation({
 *   variables: {
 *      formScheduleId: // value for 'formScheduleId'
 *      startDate: // value for 'startDate'
 *      repeat: // value for 'repeat'
 *   },
 * });
 */
export function useUpdateFormScheduleTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormScheduleTimeMutation, UpdateFormScheduleTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormScheduleTimeMutation, UpdateFormScheduleTimeMutationVariables>(UpdateFormScheduleTimeDocument, options);
      }
export type UpdateFormScheduleTimeMutationHookResult = ReturnType<typeof useUpdateFormScheduleTimeMutation>;
export type UpdateFormScheduleTimeMutationResult = Apollo.MutationResult<UpdateFormScheduleTimeMutation>;
export type UpdateFormScheduleTimeMutationOptions = Apollo.BaseMutationOptions<UpdateFormScheduleTimeMutation, UpdateFormScheduleTimeMutationVariables>;
export const OrganizationFormSchedulesDocument = gql`
    query OrganizationFormSchedules($filter: OrganizationFormSchedulesFilter) {
  organizationFormSchedules(filter: $filter) {
    id
    template {
      title
      type
    }
    patient {
      firstName
      lastName
    }
    doctor {
      firstName
      lastName
    }
    startDate
    repeat
    nextOccurrence
    isPaused
  }
}
    `;

/**
 * __useOrganizationFormSchedulesQuery__
 *
 * To run a query within a React component, call `useOrganizationFormSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFormSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFormSchedulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationFormSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationFormSchedulesQuery, OrganizationFormSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationFormSchedulesQuery, OrganizationFormSchedulesQueryVariables>(OrganizationFormSchedulesDocument, options);
      }
export function useOrganizationFormSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFormSchedulesQuery, OrganizationFormSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationFormSchedulesQuery, OrganizationFormSchedulesQueryVariables>(OrganizationFormSchedulesDocument, options);
        }
export type OrganizationFormSchedulesQueryHookResult = ReturnType<typeof useOrganizationFormSchedulesQuery>;
export type OrganizationFormSchedulesLazyQueryHookResult = ReturnType<typeof useOrganizationFormSchedulesLazyQuery>;
export type OrganizationFormSchedulesQueryResult = Apollo.QueryResult<OrganizationFormSchedulesQuery, OrganizationFormSchedulesQueryVariables>;
export const UpdatePatientArchivedStatusDocument = gql`
    mutation UpdatePatientArchivedStatus($patientId: ID!, $archived: Boolean!) {
  updatePatientArchivedStatus(patientId: $patientId, archived: $archived) {
    id
    archived
  }
}
    `;
export type UpdatePatientArchivedStatusMutationFn = Apollo.MutationFunction<UpdatePatientArchivedStatusMutation, UpdatePatientArchivedStatusMutationVariables>;

/**
 * __useUpdatePatientArchivedStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePatientArchivedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientArchivedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientArchivedStatusMutation, { data, loading, error }] = useUpdatePatientArchivedStatusMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useUpdatePatientArchivedStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientArchivedStatusMutation, UpdatePatientArchivedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientArchivedStatusMutation, UpdatePatientArchivedStatusMutationVariables>(UpdatePatientArchivedStatusDocument, options);
      }
export type UpdatePatientArchivedStatusMutationHookResult = ReturnType<typeof useUpdatePatientArchivedStatusMutation>;
export type UpdatePatientArchivedStatusMutationResult = Apollo.MutationResult<UpdatePatientArchivedStatusMutation>;
export type UpdatePatientArchivedStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePatientArchivedStatusMutation, UpdatePatientArchivedStatusMutationVariables>;
export const ResendFormToPatientDocument = gql`
    mutation resendFormToPatient($formId: ID!) {
  resendFormToPatient(formId: $formId) {
    id
  }
}
    `;
export type ResendFormToPatientMutationFn = Apollo.MutationFunction<ResendFormToPatientMutation, ResendFormToPatientMutationVariables>;

/**
 * __useResendFormToPatientMutation__
 *
 * To run a mutation, you first call `useResendFormToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendFormToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendFormToPatientMutation, { data, loading, error }] = useResendFormToPatientMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useResendFormToPatientMutation(baseOptions?: Apollo.MutationHookOptions<ResendFormToPatientMutation, ResendFormToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendFormToPatientMutation, ResendFormToPatientMutationVariables>(ResendFormToPatientDocument, options);
      }
export type ResendFormToPatientMutationHookResult = ReturnType<typeof useResendFormToPatientMutation>;
export type ResendFormToPatientMutationResult = Apollo.MutationResult<ResendFormToPatientMutation>;
export type ResendFormToPatientMutationOptions = Apollo.BaseMutationOptions<ResendFormToPatientMutation, ResendFormToPatientMutationVariables>;
export const SendFormDocument = gql`
    mutation SendForm($formId: ID!) {
  sendForm(formId: $formId) {
    id
  }
}
    `;
export type SendFormMutationFn = Apollo.MutationFunction<SendFormMutation, SendFormMutationVariables>;

/**
 * __useSendFormMutation__
 *
 * To run a mutation, you first call `useSendFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFormMutation, { data, loading, error }] = useSendFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useSendFormMutation(baseOptions?: Apollo.MutationHookOptions<SendFormMutation, SendFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFormMutation, SendFormMutationVariables>(SendFormDocument, options);
      }
export type SendFormMutationHookResult = ReturnType<typeof useSendFormMutation>;
export type SendFormMutationResult = Apollo.MutationResult<SendFormMutation>;
export type SendFormMutationOptions = Apollo.BaseMutationOptions<SendFormMutation, SendFormMutationVariables>;
export const OrganizationHubSpotSubscriptionDocument = gql`
    query OrganizationHubSpotSubscription {
  organizationHubSpotSubscription {
    nextPaymentDueDate
    lastPaymentDate
    subscriptionStatus
    updatePaymentMethodLink
  }
}
    `;

/**
 * __useOrganizationHubSpotSubscriptionQuery__
 *
 * To run a query within a React component, call `useOrganizationHubSpotSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationHubSpotSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationHubSpotSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationHubSpotSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationHubSpotSubscriptionQuery, OrganizationHubSpotSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationHubSpotSubscriptionQuery, OrganizationHubSpotSubscriptionQueryVariables>(OrganizationHubSpotSubscriptionDocument, options);
      }
export function useOrganizationHubSpotSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationHubSpotSubscriptionQuery, OrganizationHubSpotSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationHubSpotSubscriptionQuery, OrganizationHubSpotSubscriptionQueryVariables>(OrganizationHubSpotSubscriptionDocument, options);
        }
export type OrganizationHubSpotSubscriptionQueryHookResult = ReturnType<typeof useOrganizationHubSpotSubscriptionQuery>;
export type OrganizationHubSpotSubscriptionLazyQueryHookResult = ReturnType<typeof useOrganizationHubSpotSubscriptionLazyQuery>;
export type OrganizationHubSpotSubscriptionQueryResult = Apollo.QueryResult<OrganizationHubSpotSubscriptionQuery, OrganizationHubSpotSubscriptionQueryVariables>;
export const GenerateModuleDocument = gql`
    mutation GenerateModule($input: String!) {
  generateModule(input: $input) {
    id
    title
    description
    tags
    default
    items {
      template {
        id
        title
        description
        tags
        content
      }
    }
  }
}
    `;
export type GenerateModuleMutationFn = Apollo.MutationFunction<GenerateModuleMutation, GenerateModuleMutationVariables>;

/**
 * __useGenerateModuleMutation__
 *
 * To run a mutation, you first call `useGenerateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateModuleMutation, { data, loading, error }] = useGenerateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateModuleMutation(baseOptions?: Apollo.MutationHookOptions<GenerateModuleMutation, GenerateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateModuleMutation, GenerateModuleMutationVariables>(GenerateModuleDocument, options);
      }
export type GenerateModuleMutationHookResult = ReturnType<typeof useGenerateModuleMutation>;
export type GenerateModuleMutationResult = Apollo.MutationResult<GenerateModuleMutation>;
export type GenerateModuleMutationOptions = Apollo.BaseMutationOptions<GenerateModuleMutation, GenerateModuleMutationVariables>;
export const CreateModuleDocument = gql`
    mutation CreateModule($title: String!, $items: [ModuleItemInput!]!, $description: String, $tags: [String!]) {
  createModule(
    title: $title
    items: $items
    description: $description
    tags: $tags
  ) {
    id
    title
    description
    tags
    default
    items {
      id
      template {
        content
        default
        description
        doctor {
          id
          firstName
          lastName
        }
        id
        logo
        scorable
        scoresDescription
        slug
        tags
        title
        type
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type CreateModuleMutationFn = Apollo.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      items: // value for 'items'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, options);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = Apollo.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const DeleteModuleDocument = gql`
    mutation DeleteModule($moduleId: ID!) {
  deleteModule(moduleId: $moduleId)
}
    `;
export type DeleteModuleMutationFn = Apollo.MutationFunction<DeleteModuleMutation, DeleteModuleMutationVariables>;

/**
 * __useDeleteModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleMutation, { data, loading, error }] = useDeleteModuleMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useDeleteModuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleMutation, DeleteModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleMutation, DeleteModuleMutationVariables>(DeleteModuleDocument, options);
      }
export type DeleteModuleMutationHookResult = ReturnType<typeof useDeleteModuleMutation>;
export type DeleteModuleMutationResult = Apollo.MutationResult<DeleteModuleMutation>;
export type DeleteModuleMutationOptions = Apollo.BaseMutationOptions<DeleteModuleMutation, DeleteModuleMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation UpdateModule($moduleId: ID!, $title: String, $description: String, $tags: [String!], $items: [ModuleItemInput!]) {
  updateModule(
    moduleId: $moduleId
    title: $title
    description: $description
    tags: $tags
    items: $items
  ) {
    id
  }
}
    `;
export type UpdateModuleMutationFn = Apollo.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, options);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = Apollo.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = Apollo.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const AssignModuleDocument = gql`
    mutation AssignModule($moduleId: ID!, $patientId: ID!, $startDate: Date) {
  assignModule(moduleId: $moduleId, patientId: $patientId, startDate: $startDate) {
    id
  }
}
    `;
export type AssignModuleMutationFn = Apollo.MutationFunction<AssignModuleMutation, AssignModuleMutationVariables>;

/**
 * __useAssignModuleMutation__
 *
 * To run a mutation, you first call `useAssignModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignModuleMutation, { data, loading, error }] = useAssignModuleMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *      patientId: // value for 'patientId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAssignModuleMutation(baseOptions?: Apollo.MutationHookOptions<AssignModuleMutation, AssignModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignModuleMutation, AssignModuleMutationVariables>(AssignModuleDocument, options);
      }
export type AssignModuleMutationHookResult = ReturnType<typeof useAssignModuleMutation>;
export type AssignModuleMutationResult = Apollo.MutationResult<AssignModuleMutation>;
export type AssignModuleMutationOptions = Apollo.BaseMutationOptions<AssignModuleMutation, AssignModuleMutationVariables>;
export const ModuleDocument = gql`
    query Module($moduleId: ID!) {
  module(moduleId: $moduleId) {
    id
    title
    description
    tags
    default
    items {
      id
      template {
        content
        default
        description
        doctor {
          id
          firstName
          lastName
        }
        id
        logo
        scorable
        scoresDescription
        slug
        tags
        title
        type
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useModuleQuery__
 *
 * To run a query within a React component, call `useModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useModuleQuery(baseOptions: Apollo.QueryHookOptions<ModuleQuery, ModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleQuery, ModuleQueryVariables>(ModuleDocument, options);
      }
export function useModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleQuery, ModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleQuery, ModuleQueryVariables>(ModuleDocument, options);
        }
export type ModuleQueryHookResult = ReturnType<typeof useModuleQuery>;
export type ModuleLazyQueryHookResult = ReturnType<typeof useModuleLazyQuery>;
export type ModuleQueryResult = Apollo.QueryResult<ModuleQuery, ModuleQueryVariables>;
export const ModulesDocument = gql`
    query Modules($filter: ModulesFilter, $isDefault: Boolean) {
  modules(filter: $filter, isDefault: $isDefault) {
    id
    title
    description
    tags
    default
    doctor {
      id
      firstName
      lastName
    }
    items {
      id
    }
  }
}
    `;

/**
 * __useModulesQuery__
 *
 * To run a query within a React component, call `useModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useModulesQuery(baseOptions?: Apollo.QueryHookOptions<ModulesQuery, ModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModulesQuery, ModulesQueryVariables>(ModulesDocument, options);
      }
export function useModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModulesQuery, ModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModulesQuery, ModulesQueryVariables>(ModulesDocument, options);
        }
export type ModulesQueryHookResult = ReturnType<typeof useModulesQuery>;
export type ModulesLazyQueryHookResult = ReturnType<typeof useModulesLazyQuery>;
export type ModulesQueryResult = Apollo.QueryResult<ModulesQuery, ModulesQueryVariables>;
export const ModuleScheduleDocument = gql`
    query ModuleSchedule($moduleScheduleId: ID!) {
  moduleSchedule(moduleScheduleId: $moduleScheduleId) {
    id
    title
    description
    tags
    startDate
    items {
      form {
        id
        title
        completed
        responses
        responseDates
        content
        createdAt
        updatedAt
      }
      template {
        id
        title
        content
        createdAt
        updatedAt
        default
      }
      delayTime
      sendStatus
      status
    }
    module {
      title
      description
    }
  }
}
    `;

/**
 * __useModuleScheduleQuery__
 *
 * To run a query within a React component, call `useModuleScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleScheduleQuery({
 *   variables: {
 *      moduleScheduleId: // value for 'moduleScheduleId'
 *   },
 * });
 */
export function useModuleScheduleQuery(baseOptions: Apollo.QueryHookOptions<ModuleScheduleQuery, ModuleScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleScheduleQuery, ModuleScheduleQueryVariables>(ModuleScheduleDocument, options);
      }
export function useModuleScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleScheduleQuery, ModuleScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleScheduleQuery, ModuleScheduleQueryVariables>(ModuleScheduleDocument, options);
        }
export type ModuleScheduleQueryHookResult = ReturnType<typeof useModuleScheduleQuery>;
export type ModuleScheduleLazyQueryHookResult = ReturnType<typeof useModuleScheduleLazyQuery>;
export type ModuleScheduleQueryResult = Apollo.QueryResult<ModuleScheduleQuery, ModuleScheduleQueryVariables>;
export const UpdateTranscriptDocument = gql`
    mutation UpdateTranscript($transcriptId: ID!, $note: String, $patients: [ID!], $summary: String, $text: String, $title: String, $sessionDate: Date, $sessionType: TranscriptSessionType, $noteType: TranscriptNoteType, $source: TranscriptSource, $customPrompt: String) {
  updateTranscript(
    transcriptId: $transcriptId
    note: $note
    patients: $patients
    summary: $summary
    text: $text
    title: $title
    sessionDate: $sessionDate
    sessionType: $sessionType
    noteType: $noteType
    source: $source
    customPrompt: $customPrompt
  ) {
    id
  }
}
    `;
export type UpdateTranscriptMutationFn = Apollo.MutationFunction<UpdateTranscriptMutation, UpdateTranscriptMutationVariables>;

/**
 * __useUpdateTranscriptMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptMutation, { data, loading, error }] = useUpdateTranscriptMutation({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *      note: // value for 'note'
 *      patients: // value for 'patients'
 *      summary: // value for 'summary'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      sessionDate: // value for 'sessionDate'
 *      sessionType: // value for 'sessionType'
 *      noteType: // value for 'noteType'
 *      source: // value for 'source'
 *      customPrompt: // value for 'customPrompt'
 *   },
 * });
 */
export function useUpdateTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranscriptMutation, UpdateTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranscriptMutation, UpdateTranscriptMutationVariables>(UpdateTranscriptDocument, options);
      }
export type UpdateTranscriptMutationHookResult = ReturnType<typeof useUpdateTranscriptMutation>;
export type UpdateTranscriptMutationResult = Apollo.MutationResult<UpdateTranscriptMutation>;
export type UpdateTranscriptMutationOptions = Apollo.BaseMutationOptions<UpdateTranscriptMutation, UpdateTranscriptMutationVariables>;
export const TranscriptDocument = gql`
    query Transcript($transcriptId: ID!) {
  transcript(transcriptId: $transcriptId) {
    id
    createdAt
    note
    noteType
    transcriptionDuration
    sessionType
    status
    source
    sessionDate
    customPrompt
    organization {
      id
    }
    doctor {
      firstName
      lastName
    }
    patients {
      id
      firstName
      lastName
      avatarUrl
    }
    summary
    text
    title
    updatedAt
  }
}
    `;

/**
 * __useTranscriptQuery__
 *
 * To run a query within a React component, call `useTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptQuery({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *   },
 * });
 */
export function useTranscriptQuery(baseOptions: Apollo.QueryHookOptions<TranscriptQuery, TranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptQuery, TranscriptQueryVariables>(TranscriptDocument, options);
      }
export function useTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptQuery, TranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptQuery, TranscriptQueryVariables>(TranscriptDocument, options);
        }
export type TranscriptQueryHookResult = ReturnType<typeof useTranscriptQuery>;
export type TranscriptLazyQueryHookResult = ReturnType<typeof useTranscriptLazyQuery>;
export type TranscriptQueryResult = Apollo.QueryResult<TranscriptQuery, TranscriptQueryVariables>;
export const TranscriptsDocument = gql`
    query Transcripts($filter: TranscriptFilter!) {
  transcripts(filter: $filter) {
    id
    createdAt
    note
    noteType
    transcriptionDuration
    sessionType
    source
    sessionDate
    organization {
      id
    }
    doctor {
      firstName
      lastName
    }
    patients {
      id
      firstName
      lastName
      avatarUrl
    }
    status
    summary
    text
    title
    updatedAt
  }
}
    `;

/**
 * __useTranscriptsQuery__
 *
 * To run a query within a React component, call `useTranscriptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTranscriptsQuery(baseOptions: Apollo.QueryHookOptions<TranscriptsQuery, TranscriptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptsQuery, TranscriptsQueryVariables>(TranscriptsDocument, options);
      }
export function useTranscriptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptsQuery, TranscriptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptsQuery, TranscriptsQueryVariables>(TranscriptsDocument, options);
        }
export type TranscriptsQueryHookResult = ReturnType<typeof useTranscriptsQuery>;
export type TranscriptsLazyQueryHookResult = ReturnType<typeof useTranscriptsLazyQuery>;
export type TranscriptsQueryResult = Apollo.QueryResult<TranscriptsQuery, TranscriptsQueryVariables>;
export const DeleteTranscriptDocument = gql`
    mutation DeleteTranscript($transcriptId: ID!) {
  deleteTranscript(transcriptId: $transcriptId)
}
    `;
export type DeleteTranscriptMutationFn = Apollo.MutationFunction<DeleteTranscriptMutation, DeleteTranscriptMutationVariables>;

/**
 * __useDeleteTranscriptMutation__
 *
 * To run a mutation, you first call `useDeleteTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTranscriptMutation, { data, loading, error }] = useDeleteTranscriptMutation({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *   },
 * });
 */
export function useDeleteTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTranscriptMutation, DeleteTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTranscriptMutation, DeleteTranscriptMutationVariables>(DeleteTranscriptDocument, options);
      }
export type DeleteTranscriptMutationHookResult = ReturnType<typeof useDeleteTranscriptMutation>;
export type DeleteTranscriptMutationResult = Apollo.MutationResult<DeleteTranscriptMutation>;
export type DeleteTranscriptMutationOptions = Apollo.BaseMutationOptions<DeleteTranscriptMutation, DeleteTranscriptMutationVariables>;
export const CompleteTranscriptDocument = gql`
    mutation CompleteTranscript($transcriptId: ID!) {
  completeTranscript(transcriptId: $transcriptId) {
    id
  }
}
    `;
export type CompleteTranscriptMutationFn = Apollo.MutationFunction<CompleteTranscriptMutation, CompleteTranscriptMutationVariables>;

/**
 * __useCompleteTranscriptMutation__
 *
 * To run a mutation, you first call `useCompleteTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTranscriptMutation, { data, loading, error }] = useCompleteTranscriptMutation({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *   },
 * });
 */
export function useCompleteTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTranscriptMutation, CompleteTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTranscriptMutation, CompleteTranscriptMutationVariables>(CompleteTranscriptDocument, options);
      }
export type CompleteTranscriptMutationHookResult = ReturnType<typeof useCompleteTranscriptMutation>;
export type CompleteTranscriptMutationResult = Apollo.MutationResult<CompleteTranscriptMutation>;
export type CompleteTranscriptMutationOptions = Apollo.BaseMutationOptions<CompleteTranscriptMutation, CompleteTranscriptMutationVariables>;
export const GenerateRecommendedHomeworkDocument = gql`
    mutation GenerateRecommendedHomework($transcriptId: ID!) {
  generateRecommendedHomework(transcriptId: $transcriptId) {
    module {
      id
      description
      title
      tags
      items {
        template {
          id
        }
      }
    }
    template {
      id
      title
      description
      tags
      content
    }
  }
}
    `;
export type GenerateRecommendedHomeworkMutationFn = Apollo.MutationFunction<GenerateRecommendedHomeworkMutation, GenerateRecommendedHomeworkMutationVariables>;

/**
 * __useGenerateRecommendedHomeworkMutation__
 *
 * To run a mutation, you first call `useGenerateRecommendedHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRecommendedHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRecommendedHomeworkMutation, { data, loading, error }] = useGenerateRecommendedHomeworkMutation({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *   },
 * });
 */
export function useGenerateRecommendedHomeworkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRecommendedHomeworkMutation, GenerateRecommendedHomeworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRecommendedHomeworkMutation, GenerateRecommendedHomeworkMutationVariables>(GenerateRecommendedHomeworkDocument, options);
      }
export type GenerateRecommendedHomeworkMutationHookResult = ReturnType<typeof useGenerateRecommendedHomeworkMutation>;
export type GenerateRecommendedHomeworkMutationResult = Apollo.MutationResult<GenerateRecommendedHomeworkMutation>;
export type GenerateRecommendedHomeworkMutationOptions = Apollo.BaseMutationOptions<GenerateRecommendedHomeworkMutation, GenerateRecommendedHomeworkMutationVariables>;
export const RecommendedHomeworkDocument = gql`
    query RecommendedHomework($transcriptId: ID!) {
  recommendedHomework(transcriptId: $transcriptId) {
    module {
      id
      description
      title
      tags
      items {
        template {
          id
          title
        }
      }
    }
    template {
      id
      title
      description
      type
      tags
      logo
      content
      default
    }
  }
}
    `;

/**
 * __useRecommendedHomeworkQuery__
 *
 * To run a query within a React component, call `useRecommendedHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedHomeworkQuery({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *   },
 * });
 */
export function useRecommendedHomeworkQuery(baseOptions: Apollo.QueryHookOptions<RecommendedHomeworkQuery, RecommendedHomeworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedHomeworkQuery, RecommendedHomeworkQueryVariables>(RecommendedHomeworkDocument, options);
      }
export function useRecommendedHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedHomeworkQuery, RecommendedHomeworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedHomeworkQuery, RecommendedHomeworkQueryVariables>(RecommendedHomeworkDocument, options);
        }
export type RecommendedHomeworkQueryHookResult = ReturnType<typeof useRecommendedHomeworkQuery>;
export type RecommendedHomeworkLazyQueryHookResult = ReturnType<typeof useRecommendedHomeworkLazyQuery>;
export type RecommendedHomeworkQueryResult = Apollo.QueryResult<RecommendedHomeworkQuery, RecommendedHomeworkQueryVariables>;
export const UpdateTranscriptNoteDocument = gql`
    mutation UpdateTranscriptNote($transcriptId: ID!, $input: String!) {
  updateTranscriptNote(transcriptId: $transcriptId, input: $input) {
    id
  }
}
    `;
export type UpdateTranscriptNoteMutationFn = Apollo.MutationFunction<UpdateTranscriptNoteMutation, UpdateTranscriptNoteMutationVariables>;

/**
 * __useUpdateTranscriptNoteMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptNoteMutation, { data, loading, error }] = useUpdateTranscriptNoteMutation({
 *   variables: {
 *      transcriptId: // value for 'transcriptId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranscriptNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranscriptNoteMutation, UpdateTranscriptNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranscriptNoteMutation, UpdateTranscriptNoteMutationVariables>(UpdateTranscriptNoteDocument, options);
      }
export type UpdateTranscriptNoteMutationHookResult = ReturnType<typeof useUpdateTranscriptNoteMutation>;
export type UpdateTranscriptNoteMutationResult = Apollo.MutationResult<UpdateTranscriptNoteMutation>;
export type UpdateTranscriptNoteMutationOptions = Apollo.BaseMutationOptions<UpdateTranscriptNoteMutation, UpdateTranscriptNoteMutationVariables>;
export const GenerateTranscriptAudioFileUploadUrlDocument = gql`
    mutation GenerateTranscriptAudioFileUploadUrl($contentType: String!, $fileExtension: String) {
  generateTranscriptAudioFileUploadUrl(
    contentType: $contentType
    fileExtension: $fileExtension
  )
}
    `;
export type GenerateTranscriptAudioFileUploadUrlMutationFn = Apollo.MutationFunction<GenerateTranscriptAudioFileUploadUrlMutation, GenerateTranscriptAudioFileUploadUrlMutationVariables>;

/**
 * __useGenerateTranscriptAudioFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateTranscriptAudioFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTranscriptAudioFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTranscriptAudioFileUploadUrlMutation, { data, loading, error }] = useGenerateTranscriptAudioFileUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      fileExtension: // value for 'fileExtension'
 *   },
 * });
 */
export function useGenerateTranscriptAudioFileUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTranscriptAudioFileUploadUrlMutation, GenerateTranscriptAudioFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTranscriptAudioFileUploadUrlMutation, GenerateTranscriptAudioFileUploadUrlMutationVariables>(GenerateTranscriptAudioFileUploadUrlDocument, options);
      }
export type GenerateTranscriptAudioFileUploadUrlMutationHookResult = ReturnType<typeof useGenerateTranscriptAudioFileUploadUrlMutation>;
export type GenerateTranscriptAudioFileUploadUrlMutationResult = Apollo.MutationResult<GenerateTranscriptAudioFileUploadUrlMutation>;
export type GenerateTranscriptAudioFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateTranscriptAudioFileUploadUrlMutation, GenerateTranscriptAudioFileUploadUrlMutationVariables>;
export const CreateTranscriptFromAudioFileDocument = gql`
    mutation CreateTranscriptFromAudioFile($fileUrl: String!, $patients: [ID!], $title: String, $sessionType: TranscriptSessionType) {
  createTranscriptFromAudioFile(
    fileUrl: $fileUrl
    patients: $patients
    title: $title
    sessionType: $sessionType
  ) {
    id
  }
}
    `;
export type CreateTranscriptFromAudioFileMutationFn = Apollo.MutationFunction<CreateTranscriptFromAudioFileMutation, CreateTranscriptFromAudioFileMutationVariables>;

/**
 * __useCreateTranscriptFromAudioFileMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptFromAudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptFromAudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscriptFromAudioFileMutation, { data, loading, error }] = useCreateTranscriptFromAudioFileMutation({
 *   variables: {
 *      fileUrl: // value for 'fileUrl'
 *      patients: // value for 'patients'
 *      title: // value for 'title'
 *      sessionType: // value for 'sessionType'
 *   },
 * });
 */
export function useCreateTranscriptFromAudioFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranscriptFromAudioFileMutation, CreateTranscriptFromAudioFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranscriptFromAudioFileMutation, CreateTranscriptFromAudioFileMutationVariables>(CreateTranscriptFromAudioFileDocument, options);
      }
export type CreateTranscriptFromAudioFileMutationHookResult = ReturnType<typeof useCreateTranscriptFromAudioFileMutation>;
export type CreateTranscriptFromAudioFileMutationResult = Apollo.MutationResult<CreateTranscriptFromAudioFileMutation>;
export type CreateTranscriptFromAudioFileMutationOptions = Apollo.BaseMutationOptions<CreateTranscriptFromAudioFileMutation, CreateTranscriptFromAudioFileMutationVariables>;
export const CreateTranscriptDocument = gql`
    mutation CreateTranscript($noteType: TranscriptNoteType, $patients: [ID!], $sessionType: TranscriptSessionType, $text: String!, $title: String, $source: TranscriptSource) {
  createTranscript(
    noteType: $noteType
    patients: $patients
    sessionType: $sessionType
    text: $text
    title: $title
    source: $source
  ) {
    id
  }
}
    `;
export type CreateTranscriptMutationFn = Apollo.MutationFunction<CreateTranscriptMutation, CreateTranscriptMutationVariables>;

/**
 * __useCreateTranscriptMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscriptMutation, { data, loading, error }] = useCreateTranscriptMutation({
 *   variables: {
 *      noteType: // value for 'noteType'
 *      patients: // value for 'patients'
 *      sessionType: // value for 'sessionType'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranscriptMutation, CreateTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranscriptMutation, CreateTranscriptMutationVariables>(CreateTranscriptDocument, options);
      }
export type CreateTranscriptMutationHookResult = ReturnType<typeof useCreateTranscriptMutation>;
export type CreateTranscriptMutationResult = Apollo.MutationResult<CreateTranscriptMutation>;
export type CreateTranscriptMutationOptions = Apollo.BaseMutationOptions<CreateTranscriptMutation, CreateTranscriptMutationVariables>;
export const UserLocationInfoDocument = gql`
    query UserLocationInfo {
  userLocationInfo {
    eu
    countryCode
  }
}
    `;

/**
 * __useUserLocationInfoQuery__
 *
 * To run a query within a React component, call `useUserLocationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLocationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLocationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserLocationInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserLocationInfoQuery, UserLocationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLocationInfoQuery, UserLocationInfoQueryVariables>(UserLocationInfoDocument, options);
      }
export function useUserLocationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLocationInfoQuery, UserLocationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLocationInfoQuery, UserLocationInfoQueryVariables>(UserLocationInfoDocument, options);
        }
export type UserLocationInfoQueryHookResult = ReturnType<typeof useUserLocationInfoQuery>;
export type UserLocationInfoLazyQueryHookResult = ReturnType<typeof useUserLocationInfoLazyQuery>;
export type UserLocationInfoQueryResult = Apollo.QueryResult<UserLocationInfoQuery, UserLocationInfoQueryVariables>;